import { jsx as r, jsxs as f, Fragment as t2 } from "react/jsx-runtime";
import * as e from "react";
import r1, {
  useRef as C1,
  useState as X,
  useEffect as v1,
  useLayoutEffect as F2,
  useCallback as f2,
} from "react";
const E1 = {
  "action-badge__text": "action-badge__text__lfI7m",
  "action-badge": "action-badge__s53nS",
  "action-badge__content": "action-badge__content__-BC4c",
  "action-badge__icon": "action-badge__icon__u--4W",
};
function R2(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function p2(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var a = t.default;
  if (typeof a == "function") {
    var n = function i() {
      return this instanceof i
        ? Reflect.construct(a, arguments, this.constructor)
        : a.apply(this, arguments);
    };
    n.prototype = a.prototype;
  } else n = {};
  return (
    Object.defineProperty(n, "__esModule", { value: !0 }),
    Object.keys(t).forEach(function (i) {
      var o = Object.getOwnPropertyDescriptor(t, i);
      Object.defineProperty(
        n,
        i,
        o.get
          ? o
          : {
              enumerable: !0,
              get: function () {
                return t[i];
              },
            },
      );
    }),
    n
  );
}
var z1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var a2;
function D2() {
  return (
    a2 ||
      ((a2 = 1),
      (function (t) {
        (function () {
          var a = {}.hasOwnProperty;
          function n() {
            for (var c = "", l = 0; l < arguments.length; l++) {
              var s = arguments[l];
              s && (c = o(c, i(s)));
            }
            return c;
          }
          function i(c) {
            if (typeof c == "string" || typeof c == "number") return c;
            if (typeof c != "object") return "";
            if (Array.isArray(c)) return n.apply(null, c);
            if (
              c.toString !== Object.prototype.toString &&
              !c.toString.toString().includes("[native code]")
            )
              return c.toString();
            var l = "";
            for (var s in c) a.call(c, s) && c[s] && (l = o(l, s));
            return l;
          }
          function o(c, l) {
            return l ? (c ? c + " " + l : c + l) : c;
          }
          t.exports ? ((n.default = n), (t.exports = n)) : (window.classNames = n);
        })();
      })(z1)),
    z1.exports
  );
}
var B2 = D2();
const F = /* @__PURE__ */ R2(B2),
  r2 = {
    "a11y-visually-hidden": "a11y-visually-hidden__UR-XE",
  },
  Q1 = ({ children: t, id: a, tag: n = "span", dangerous: i, a11y: o }) => {
    const c = n;
    return t
      ? i
        ? /* @__PURE__ */ r(c, {
            className: r2["a11y-visually-hidden"],
            id: a,
            dangerouslySetInnerHTML: { __html: t },
            "aria-hidden": !!(o != null && o.ariaHidden) || void 0,
            "aria-live": o == null ? void 0 : o.ariaLive,
          })
        : /* @__PURE__ */ r(c, {
            className: r2["a11y-visually-hidden"],
            id: a,
            "aria-hidden": !!(o != null && o.ariaHidden) || void 0,
            "aria-live": o == null ? void 0 : o.ariaLive,
            children: t,
          })
      : null;
  },
  O2 = ({
    icon: t,
    iconPosition: a = "start",
    text: n,
    labelText: i,
    extraClass: o,
    ariaExpanded: c,
    ariaControls: l,
    onClick: s,
  }) => {
    const d = F({
        [E1["action-badge"]]: !0,
        [o]: o,
      }),
      g = !!i || void 0,
      v = /* @__PURE__ */ f("span", {
        className: E1["action-badge__content"],
        "aria-hidden": g,
        children: [
          t && a === "start"
            ? /* @__PURE__ */ r("span", { className: E1["action-badge__icon"], children: t })
            : null,
          n
            ? /* @__PURE__ */ r("span", { className: E1["action-badge__text"], children: n })
            : null,
          t && a === "end"
            ? /* @__PURE__ */ r("span", { className: E1["action-badge__icon"], children: t })
            : null,
        ],
      });
    return /* @__PURE__ */ f("button", {
      className: d,
      type: "button",
      onClick: s,
      "aria-expanded": c,
      "aria-controls": l,
      children: [/* @__PURE__ */ r(Q1, { children: i == null ? void 0 : i.toString() }), v],
    });
  },
  n2 = {
    "app-download-widget": "app-download-widget__vtyXG",
    "app-download-widget--floating": "app-download-widget--floating__fNmDG",
  },
  Y1 = {
    "header-1": "header-1__lAXrY",
    "is-responsive": "is-responsive__rYxfk",
    "header-2": "header-2__y57BB",
    "header-3": "header-3__k6-Lw",
    "p-1": "p-1__aD1ch",
    "p-2": "p-2__BT3Ea",
    "p-3": "p-3__lTMCP",
    "action-small": "action-small__HuUlU",
    "action-medium": "action-medium__4L8rA",
    "action-large": "action-large__ZewT5",
    "is-inherited": "is-inherited__zWRpw",
    "is-italic": "is-italic__fs5nf",
    "formatted-text": "formatted-text__mEg3Z",
    "is-one-line": "is-one-line__PemiX",
    "qr-code": "qr-code__TyNAI",
    "qr-code--large": "qr-code--large__lSR3F",
    "qr-code--small": "qr-code--small__JFtXl",
    "qr-code--stretch": "qr-code--stretch__G80M3",
    "qr-code--no-padding": "qr-code--no-padding__JJdr3",
  },
  P2 = (t) =>
    /* @__PURE__ */ e.createElement("svg", {
        width: 136,
        height: 136,
        viewBox: "83.3 83.3 833.4 833.4",
        fill: "#202020",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        dangerouslySetInnerHTML: { __html: "<g><g><rect x=\"83.3\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"83.3\" y=\"428.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"83.3\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"83.3\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"83.3\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"83.3\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"83.3\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"83.3\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"83.3\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"112.1\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"112.1\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"140.8\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"140.8\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"140.8\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"140.8\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"140.8\" y=\"428.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"140.8\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"140.8\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"140.8\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"169.5\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"198.3\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"198.3\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"198.3\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"198.3\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"198.3\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"227\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"255.7\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"255.7\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"255.7\" y=\"428.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"255.7\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"255.7\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"255.7\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"255.7\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"284.5\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"284.5\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"284.5\" y=\"428.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"284.5\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"284.5\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"284.5\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"284.5\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"284.5\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"112.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"198.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"255.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"313.2\" y=\"830.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"83.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"198.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"284.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"428.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"715.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"342\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"112.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"169.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"227\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"255.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"370.7\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"112.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"169.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"198.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"227\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"284.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"399.4\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"428.2\" y=\"83.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"428.2\" y=\"140.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"428.2\" y=\"198.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"428.2\" y=\"255.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"428.2\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"428.2\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"428.2\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"456.9\" y=\"112.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"456.9\" y=\"198.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"456.9\" y=\"227\" width=\"28.7\" height=\"28.7\"/><rect x=\"456.9\" y=\"715.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"456.9\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"456.9\" y=\"830.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"456.9\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"456.9\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"112.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"169.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"255.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"284.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"715.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"485.6\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"514.4\" y=\"198.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"514.4\" y=\"284.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"514.4\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"514.4\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"514.4\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"514.4\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"514.4\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"514.4\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"83.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"112.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"140.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"169.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"198.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"227\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"255.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"543.1\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"83.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"112.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"169.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"227\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"284.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"715.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"571.8\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"140.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"255.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"284.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"830.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"600.6\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"169.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"227\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"629.3\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"83.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"112.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"140.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"169.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"255.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"715.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"658\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"830.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"686.8\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"715.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"715.5\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"744.3\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"428.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"715.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"773\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"801.7\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"801.7\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"801.7\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"801.7\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"801.7\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"801.7\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"801.7\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"370.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"428.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"456.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"830.5\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"313.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"514.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"543.1\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"600.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"629.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"686.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"744.3\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"801.7\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/><rect x=\"859.2\" y=\"887.9\" width=\"28.7\" height=\"28.7\"/><rect x=\"887.9\" y=\"342\" width=\"28.7\" height=\"28.7\"/><rect x=\"887.9\" y=\"399.4\" width=\"28.7\" height=\"28.7\"/><rect x=\"887.9\" y=\"485.6\" width=\"28.7\" height=\"28.7\"/><rect x=\"887.9\" y=\"571.8\" width=\"28.7\" height=\"28.7\"/><rect x=\"887.9\" y=\"658\" width=\"28.7\" height=\"28.7\"/><rect x=\"887.9\" y=\"715.5\" width=\"28.7\" height=\"28.7\"/><rect x=\"887.9\" y=\"773\" width=\"28.7\" height=\"28.7\"/><rect x=\"887.9\" y=\"859.2\" width=\"28.7\" height=\"28.7\"/></g></g><g><path d=\"M83.3,83.3v201.1h201.1V83.3H83.3ZM112.1,112.1h143.7v143.7H112.1V112.1Z\"/><rect x=\"140.8\" y=\"140.8\" width=\"86.2\" height=\"86.2\"/><path d=\"M916.7,83.3h-201.1v201.1h201.1V83.3ZM887.9,112.1v143.7h-143.7V112.1h143.7Z\"/><rect x=\"773\" y=\"140.8\" width=\"86.2\" height=\"86.2\"/><path d=\"M83.3,916.7h201.1v-201.1H83.3v201.1ZM112.1,887.9v-143.7h143.7v143.7H112.1Z\"/><rect x=\"140.8\" y=\"773\" width=\"86.2\" height=\"86.2\"/></g><path d=\"M573.6,493.2l-31.5-54.5c-2.4-4.2-6.9-6.8-11.7-6.8h-62.9c-4.8,0-9.3,2.6-11.7,6.8l-31.5,54.5c-2.4,4.2-2.4,9.3,0,13.5l31.5,54.5c2.4,4.2,6.9,6.8,11.7,6.8h62.9c4.8,0,9.3-2.6,11.7-6.8l31.5-54.5c2.4-4.2,2.4-9.3,0-13.5ZM470.8,467.8c0-5,4-9,9-9h37.3c5,0,9,4,9,9v1.5c0,5-4,9-9,9h-37.3c-5,0-9-4-9-9v-1.5ZM516.6,532.1c0,5-4,9-9,9h-18.1c-5,0-9-4-9-9v-1.5c0-5,4-9,9-9h18.1c5,0,9,4,9,9v1.5ZM545.4,500.8c0,5-4,9-9,9h-75.9c-5,0-9-4-9-9v-1.5c0-5,4-9,9-9h75.9c5,0,9,4,9,9v1.5Z\"/>" },
      }),
  F1 = ({ size: t = "medium", hasPadding: a = !0 }) =>
    /* @__PURE__ */ r("div", {
      className: F({
        [Y1["qr-code"]]: !0,
        [Y1[`qr-code--${t}`]]: t,
        [Y1["qr-code--no-padding"]]: !a,
      }),
      children: /* @__PURE__ */ r(P2, {}),
    }),
  q2 = "quote__upQyH",
  Y = {
    "header-1": "header-1__tslVg",
    "is-responsive": "is-responsive__Pz3kM",
    "header-2": "header-2__fKo6E",
    "header-3": "header-3__wWzpi",
    "p-1": "p-1__CnaDw",
    "p-2": "p-2__1lhRc",
    "p-3": "p-3__H3ha8",
    "action-small": "action-small__YgMkv",
    "action-medium": "action-medium__kOJAN",
    "action-large": "action-large__gV9G0",
    quote: q2,
    "is-inherited": "is-inherited__N9l0C",
    "is-italic": "is-italic__Zclg6",
    "formatted-text": "formatted-text__5Lnwl",
    "is-one-line": "is-one-line__jfg5h",
    "color-default": "color-default__B1Gjc",
    "color-inverse": "color-inverse__VRSN8",
    "color-brand": "color-brand__-27TA",
    "is-subdued": "is-subdued__VoQp-",
  },
  Q2 = {
    h1: Y["header-1"],
    h2: Y["header-2"],
    h3: Y["header-3"],
    p1: Y["p-1"],
    p2: Y["p-2"],
    p3: Y["p-3"],
    "action-large": Y["action-large"],
    "action-medium": Y["action-medium"],
    "action-small": Y["action-small"],
    quote: Y.quote,
  },
  G2 = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    p1: "p",
    p2: "p",
    p3: "p",
    "action-large": "span",
    "action-medium": "span",
    "action-small": "span",
    quote: "blockquote",
  },
  l1 = (t) => {
    const {
        inline: a,
        type: n,
        color: i = "default",
        noWrap: o,
        isExtended: c,
        isInherited: l,
        extraClass: s,
        style: d,
        html: g,
        htmlEditor: v,
        id: h,
        isResponsive: V,
        isSubdued: y,
        as: E = n ? G2[n] : "div",
      } = t,
      b = {
        block: F(
          typeof n < "u" && Q2[n],
          {
            text: !0,
            [Y["is-one-line"]]: o,
            [Y["is-extended"]]: c,
            [Y["is-inherited"]]: l,
            [s]: s,
            [Y["is-responsive"]]: V,
            [Y[`color-${i}`]]: i,
            [Y["is-subdued"]]: y,
          },
          i && typeof i == "string" ? i : null,
        ),
      },
      A = E;
    let L = {};
    return (
      a &&
        E !== "span" &&
        (L = {
          display: "inline",
        }),
      !a &&
        E === "span" &&
        (L = {
          display: "block",
        }),
      /* @__PURE__ */ r(A, {
        className: F(b.block),
        style: { ...L, ...d },
        dangerouslySetInnerHTML:
          g && !v
            ? {
                __html: g,
              }
            : void 0,
        id: h,
        children: v || t.children,
      })
    );
  },
  y1 = (t) =>
    /* @__PURE__ */ r(l1, {
      type: "action-large",
      isExtended: t.isExtended,
      isResponsive: t.isResponsive,
      ...t,
      children: t.children,
    }),
  j2 = (t) =>
    /* @__PURE__ */ r(l1, {
      type: "action-medium",
      isExtended: t.isExtended,
      isResponsive: t.isResponsive,
      ...t,
      children: t.children,
    }),
  X1 = (t) =>
    /* @__PURE__ */ r(l1, {
      type: "action-small",
      isExtended: t.isExtended,
      isResponsive: t.isResponsive,
      ...t,
      children: t.children,
    }),
  W2 = (t) =>
    /* @__PURE__ */ r(l1, { type: "h1", ...t, isResponsive: t.isResponsive, children: t.children }),
  k1 = (t) =>
    /* @__PURE__ */ r(l1, { type: "h2", ...t, isResponsive: t.isResponsive, children: t.children }),
  p1 = (t) =>
    /* @__PURE__ */ r(l1, { type: "h3", ...t, isResponsive: t.isResponsive, children: t.children }),
  n1 = (t) => /* @__PURE__ */ r(l1, { type: "p1", ...t, children: t.children }),
  G1 = (t) => /* @__PURE__ */ r(l1, { type: "p2", ...t, children: t.children }),
  f1 = (t) => /* @__PURE__ */ r(l1, { type: "p3", ...t, children: t.children }),
  l2 = (t) =>
    /* @__PURE__ */ r(l1, {
      type: "quote",
      ...t,
      isResponsive: t.isResponsive,
      children: t.children,
    }),
  _2 = ({ text: t, isFloating: a = !1 }) =>
    /* @__PURE__ */ f("div", {
      className: F({
        [n2["app-download-widget"]]: !0,
        [n2["app-download-widget--floating"]]: a,
      }),
      children: [
        /* @__PURE__ */ r(F1, { size: a ? "small" : "medium" }),
        a ? /* @__PURE__ */ r(p1, { children: t }) : /* @__PURE__ */ r(y1, { children: t }),
      ],
    }),
  z2 = "badge__kTvKz",
  Y2 = {
    badge: z2,
  },
  K2 = ({ text: t }) =>
    /* @__PURE__ */ r("span", {
      className: Y2.badge,
      children: /* @__PURE__ */ r(f1, { children: t }),
    }),
  U2 = "button__text__MRvbu",
  J2 = "button__Z331g",
  X2 = "button__content__9h4R4",
  $2 = "button__icon__nEr-x",
  W = {
    button__text: U2,
    button: J2,
    button__content: X2,
    button__icon: $2,
    "button--size-medium": "button--size-medium__PNgpr",
    "button--size-small": "button--size-small__CgTo7",
    "button--color-default": "button--color-default__QNhY6",
    "button--primary": "button--primary__Zx6YF",
    "button--secondary": "button--secondary__rC6lb",
    "button--tertiary": "button--tertiary__7ioWk",
    "button--color-inverse": "button--color-inverse__gW36X",
    "button--color-yellow": "button--color-yellow__E0jRg",
    "button--header": "button--header__YUR9S",
    "button--circle": "button--circle__CWFDs",
    "is-pressed": "is-pressed__oKIO8",
    "button--inline": "button--inline__xrEf2",
  },
  ee = "icon__2vrJz",
  N1 = {
    "header-1": "header-1__2PzE-",
    "is-responsive": "is-responsive__aJSJ3",
    "header-2": "header-2__3f86G",
    "header-3": "header-3__i2m2l",
    "p-1": "p-1__SEvkC",
    "p-2": "p-2__4XAbj",
    "p-3": "p-3__dSckt",
    "action-small": "action-small__zSSAW",
    "action-medium": "action-medium__-di3e",
    "action-large": "action-large__aRRTa",
    "is-inherited": "is-inherited__fw5YR",
    "is-italic": "is-italic__upOHO",
    "formatted-text": "formatted-text__jgaIv",
    "is-one-line": "is-one-line__hxCz8",
    icon: ee,
    "icon--sm": "icon--sm__dj47K",
    "icon--xsm": "icon--xsm__11v5Y",
    "icon--stretch": "icon--stretch__10qTq",
    "icon--inline": "icon--inline__6zxzh",
    "color-default": "color-default__Gkqid",
    "color-inverse": "color-inverse__Gnvsc",
    "color-brand": "color-brand__es-3r",
  },
  te = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M7.05025 16.9497L16.9497 7.05017M16.9497 7.05017L7.05025 7.05017M16.9497 7.05017L16.9497 16.9497",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }),
    ),
  ae = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 22,
        height: 16,
        viewBox: "0 0 22 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M8.61781 13.8678L4.00268 9.25271C3.8857 9.13573 3.96877 8.93398 4.13492 8.93398L20.5367 8.93398C21.0334 8.93398 21.4674 8.5593 21.4979 8.06425C21.5335 7.52172 21.1029 7.06905 20.5672 7.06905L4.13323 7.06905C3.96708 7.06905 3.884 6.86899 4.00098 6.75031L8.61612 2.13518C8.79752 1.95378 8.88908 1.71473 8.88908 1.47568C8.88908 1.21628 8.78227 0.956886 8.56695 0.770393C8.19397 0.446573 7.62601 0.485567 7.27845 0.834819L0.772958 7.33862C0.772958 7.33862 0.766175 7.34709 0.76109 7.35048C0.744136 7.36744 0.727183 7.38608 0.710231 7.40643C0.700057 7.4183 0.693274 7.43017 0.684796 7.44203C0.674624 7.4556 0.664452 7.46747 0.657672 7.48103C0.6475 7.49459 0.640719 7.50815 0.632243 7.52172C0.62546 7.53358 0.616982 7.54715 0.610202 7.55902C0.603419 7.57258 0.596638 7.58614 0.589856 7.5997C0.583075 7.61327 0.576295 7.62683 0.569512 7.64209C0.564425 7.65565 0.561034 7.66752 0.554251 7.68278C0.549164 7.69804 0.542386 7.7133 0.538995 7.73025C0.535605 7.74381 0.532214 7.75568 0.528823 7.76924C0.525431 7.7862 0.520344 7.80146 0.516953 7.81841C0.513564 7.83367 0.511868 7.84723 0.510173 7.86249C0.508477 7.87775 0.505088 7.89301 0.503392 7.90827C0.500001 7.9337 0.499999 7.95913 0.499999 7.98286L0.499999 8.01677C0.499999 8.0422 0.500001 8.06763 0.503392 8.09137C0.505088 8.10663 0.508477 8.12189 0.510173 8.13884C0.511868 8.1541 0.513564 8.16766 0.516953 8.18292C0.520344 8.19987 0.523738 8.21513 0.528823 8.23209C0.532214 8.24565 0.535605 8.25752 0.538994 8.27108C0.544081 8.28634 0.549164 8.3016 0.554251 8.31855C0.559338 8.33212 0.564425 8.34568 0.569512 8.35924C0.574599 8.3728 0.583075 8.38637 0.589856 8.40163C0.596638 8.41688 0.603419 8.42875 0.610201 8.44232C0.616982 8.45588 0.62546 8.46775 0.632243 8.47961C0.640719 8.49318 0.6475 8.50674 0.657672 8.5203C0.666148 8.53387 0.67632 8.54573 0.684796 8.5593C0.693274 8.57117 0.701752 8.58303 0.71023 8.5949C0.725487 8.61525 0.744135 8.6339 0.76109 8.65085C0.764479 8.65424 0.767872 8.65933 0.772957 8.66272L7.27676 15.1631C7.6277 15.5141 8.19905 15.5548 8.57204 15.2275C8.98063 14.8681 8.99589 14.2442 8.61781 13.8661L8.61781 13.8678Z",
        fill: "currentColor",
      }),
    ),
  re = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 22,
        height: 16,
        viewBox: "0 0 22 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M13.4956 2.09369L18.3305 6.73903C18.4531 6.85678 18.366 7.05985 18.192 7.05985L1.00922 7.05985C0.488816 7.05985 0.034128 7.43698 0.00215773 7.93528C-0.0351409 8.48136 0.415995 8.93699 0.977251 8.93699L18.1938 8.93699C18.3678 8.93699 18.4549 9.13836 18.3323 9.25781L13.4974 13.9031C13.3074 14.0857 13.2114 14.3264 13.2114 14.567C13.2114 14.8281 13.3233 15.0892 13.5489 15.2769C13.9397 15.6028 14.5347 15.5636 14.8988 15.212L21.714 8.66566C21.714 8.66566 21.7211 8.65712 21.7265 8.65371C21.7442 8.63665 21.762 8.61788 21.7798 8.5974C21.7904 8.58545 21.7975 8.57351 21.8064 8.56156C21.8171 8.54791 21.8277 8.53596 21.8348 8.52231C21.8455 8.50866 21.8526 8.49501 21.8615 8.48136C21.8686 8.46941 21.8774 8.45576 21.8846 8.44381C21.8917 8.43016 21.8988 8.41651 21.9059 8.40286C21.913 8.38921 21.9201 8.37555 21.9272 8.3602C21.9325 8.34654 21.9361 8.3346 21.9432 8.31924C21.9485 8.30388 21.9556 8.28852 21.9591 8.27146C21.9627 8.25781 21.9663 8.24586 21.9698 8.23221C21.9734 8.21514 21.9787 8.19979 21.9822 8.18272C21.9858 8.16736 21.9876 8.15371 21.9893 8.13835C21.9911 8.12299 21.9947 8.10764 21.9964 8.09228C22 8.06668 22 8.04108 22 8.01719V7.98306C22 7.95746 22 7.93187 21.9964 7.90798C21.9947 7.89262 21.9911 7.87726 21.9893 7.86019C21.9876 7.84484 21.9858 7.83118 21.9822 7.81583C21.9787 7.79876 21.9751 7.7834 21.9698 7.76634C21.9663 7.75269 21.9627 7.74074 21.9591 7.72709C21.9538 7.71173 21.9485 7.69637 21.9432 7.67931C21.9378 7.66565 21.9325 7.652 21.9272 7.63835C21.9218 7.6247 21.913 7.61105 21.9059 7.59569C21.8988 7.58033 21.8917 7.56838 21.8846 7.55473C21.8774 7.54108 21.8686 7.52913 21.8615 7.51719C21.8526 7.50354 21.8455 7.48989 21.8348 7.47623C21.8259 7.46258 21.8153 7.45064 21.8064 7.43698C21.7975 7.42504 21.7886 7.41309 21.7798 7.40115C21.7638 7.38067 21.7442 7.3619 21.7265 7.34483C21.7229 7.34142 21.7194 7.3363 21.714 7.33289L14.9005 0.789931C14.5329 0.436687 13.9343 0.395732 13.5436 0.725085C13.1155 1.08686 13.0995 1.71485 13.4956 2.0954V2.09369Z",
        fill: "currentColor",
      }),
    ),
  ne = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_14723_59141)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M14.2857 3.35714H10.9714C10.9086 3.35714 10.8571 3.30571 10.8571 3.24286V2.21429C10.8571 1.26743 10.0897 0.5 9.14286 0.5H6.85714C5.91029 0.5 5.14286 1.26743 5.14286 2.21429V3.24286C5.14286 3.30571 5.09143 3.35714 5.02857 3.35714H1.71429C0.767429 3.35714 0 4.12457 0 5.07143V8.5C0 8.97029 0.190857 9.40286 0.506286 9.716C0.548571 9.75771 0.571429 9.816 0.571429 9.87543V14.7857C0.571429 15.7326 1.33886 16.5 2.28571 16.5H13.7143C14.6611 16.5 15.4286 15.7326 15.4286 14.7857V9.87543C15.4286 9.816 15.4514 9.75829 15.4937 9.716C15.8097 9.40229 16 8.96971 16 8.5V5.07143C16 4.12457 15.2326 3.35714 14.2857 3.35714ZM6.28571 2.21429C6.28571 1.89886 6.54171 1.64286 6.85714 1.64286H9.14286C9.45829 1.64286 9.71429 1.89886 9.71429 2.21429V3.24286C9.71429 3.30571 9.66286 3.35714 9.6 3.35714H6.4C6.33714 3.35714 6.28571 3.30571 6.28571 3.24286V2.21429ZM1.14286 5.07143C1.14286 4.75657 1.39943 4.5 1.71429 4.5H14.2857C14.6006 4.5 14.8571 4.75657 14.8571 5.07143V8.5C14.8571 8.76286 14.6789 8.99086 14.4246 9.05429C14.3286 9.07829 12.024 9.64286 8 9.64286C3.976 9.64286 1.672 9.07829 1.576 9.05429C1.32114 8.99029 1.14286 8.76229 1.14286 8.5V5.07143ZM13.7143 15.3571H2.28571C1.97029 15.3571 1.71429 15.1011 1.71429 14.7857V10.3926C1.71429 10.3211 1.77886 10.2669 1.84971 10.28C2.79714 10.4606 4.92914 10.7857 8 10.7857C11.0709 10.7857 13.2029 10.4606 14.1503 10.28C14.2206 10.2669 14.2857 10.3206 14.2857 10.3926V14.7857C14.2857 15.1011 14.0297 15.3571 13.7143 15.3571Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_14723_59141" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 16,
            height: 16,
            fill: "white",
            transform: "translate(0 0.5)",
          }),
        ),
      ),
    ),
  le = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M14.2857 2.78568H12.6857C12.6229 2.78568 12.5714 2.73426 12.5714 2.6714V1.66226C12.5714 1.35768 12.3417 1.09197 12.0383 1.07254C11.7057 1.05083 11.4286 1.31426 11.4286 1.64283V2.6714C11.4286 2.73426 11.3771 2.78568 11.3143 2.78568H4.68571C4.62286 2.78568 4.57143 2.73426 4.57143 2.6714V1.66226C4.57143 1.35768 4.34171 1.09197 4.03829 1.07254C3.70571 1.05083 3.42857 1.31426 3.42857 1.64283V2.6714C3.42857 2.73426 3.37714 2.78568 3.31429 2.78568H1.71429C0.767429 2.78568 0 3.55311 0 4.49997V14.2143C0 15.1611 0.767429 15.9285 1.71429 15.9285H14.2857C15.2326 15.9285 16 15.1611 16 14.2143V4.49997C16 3.55311 15.2326 2.78568 14.2857 2.78568ZM1.71429 3.92854H3.31429C3.37714 3.92854 3.42857 3.97997 3.42857 4.04283V5.05197C3.42857 5.35654 3.65829 5.62226 3.96171 5.64169C4.29429 5.6634 4.57143 5.39997 4.57143 5.0714V4.04283C4.57143 3.97997 4.62286 3.92854 4.68571 3.92854H11.3143C11.3771 3.92854 11.4286 3.97997 11.4286 4.04283V5.05197C11.4286 5.35654 11.6583 5.62226 11.9617 5.64169C12.2943 5.6634 12.5714 5.39997 12.5714 5.0714V4.04283C12.5714 3.97997 12.6229 3.92854 12.6857 3.92854H14.2857C14.6011 3.92854 14.8571 4.18454 14.8571 4.49997V7.24283C14.8571 7.30569 14.8057 7.35711 14.7429 7.35711H1.25714C1.19429 7.35711 1.14286 7.30569 1.14286 7.24283V4.49997C1.14286 4.18454 1.39886 3.92854 1.71429 3.92854ZM14.2857 14.7857H1.71429C1.39886 14.7857 1.14286 14.5297 1.14286 14.2143V8.61426C1.14286 8.5514 1.19429 8.49997 1.25714 8.49997H14.7429C14.8057 8.49997 14.8571 8.5514 14.8571 8.61426V14.2143C14.8571 14.5297 14.6011 14.7857 14.2857 14.7857Z",
        fill: "currentColor",
      }),
    ),
  ie = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_14723_59130)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M8.06275 0.499869C3.62332 0.466154 0.000467883 4.06787 0.000467883 8.49987C0.000467883 10.1833 0.545039 11.8524 1.53532 13.2119C1.56847 13.2576 1.5639 13.3199 1.52447 13.3599L0.335325 14.549C0.00732504 14.877 -0.0898178 15.3656 0.087325 15.7947C0.265039 16.2233 0.679325 16.5004 1.14332 16.5004H8.00047C12.4325 16.5004 16.0342 12.8776 16.0005 8.43815C15.9668 4.08615 12.4142 0.533583 8.06275 0.499869ZM7.92504 15.357H1.41932C1.31761 15.357 1.26675 15.2342 1.33875 15.1622L2.7519 13.749C2.95304 13.5479 2.9759 13.2302 2.80561 13.0027L2.50904 12.6062C1.62847 11.429 1.14332 9.97073 1.14332 8.49987C1.14332 4.71873 4.21933 1.64273 8.00047 1.64273C11.7816 1.64273 14.8793 4.74044 14.8576 8.53987C14.8359 12.3239 11.709 15.357 7.92504 15.357Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M9.71429 5.07141C9.07486 5.07141 8.496 5.33541 8.08057 5.75998C8.03657 5.80513 7.96343 5.80513 7.91943 5.75998C7.504 5.33541 6.92514 5.07141 6.28571 5.07141C5.02514 5.07141 4 6.09655 4 7.35713C4 8.1537 4.29257 9.3697 5.68686 10.6371C6.37543 11.2634 7.42 11.9286 8 11.9286C8.58 11.9286 9.624 11.2634 10.3131 10.6371C11.7074 9.3697 12 8.1537 12 7.35713C12 6.09655 10.9749 5.07141 9.71429 5.07141ZM8 10.7823C7.50514 10.6708 5.14286 9.20627 5.14286 7.35713C5.14286 6.72684 5.65543 6.21427 6.28571 6.21427C6.916 6.21427 7.42857 6.72684 7.42857 7.35713C7.42857 7.67255 7.68457 7.92855 8 7.92855C8.31543 7.92855 8.57143 7.67255 8.57143 7.35713C8.57143 6.72684 9.084 6.21427 9.71429 6.21427C10.3446 6.21427 10.8571 6.72684 10.8571 7.35713C10.8571 9.20627 8.49486 10.6708 8 10.7823Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_14723_59130" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 16,
            height: 16,
            fill: "white",
            transform: "translate(0 0.5)",
          }),
        ),
      ),
    ),
  oe = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_14723_31)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M15.4988 1.00229C15.1754 0.678286 14.7445 0.5 14.2863 0.5C14.0217 0.5 13.7571 0.562857 13.52 0.681143L0.948539 6.96686C0.224538 7.32915 -0.14689 8.13829 0.0542527 8.92572C0.250253 9.692 0.959967 10.2149 1.75082 10.2149H6.17197C6.23483 10.2149 6.28625 10.2663 6.28625 10.3291V14.7863C6.28625 15.5851 6.82911 16.2714 7.60625 16.4549C7.7354 16.4857 7.86797 16.5011 8.00054 16.5011C8.65368 16.5011 9.24111 16.1377 9.53368 15.5531L15.8194 2.98172C16.1497 2.32057 16.0211 1.52571 15.4983 1.00286L15.4988 1.00229ZM14.7977 2.46972L8.51197 15.0411C8.41425 15.236 8.21883 15.3571 8.00111 15.3571C7.95711 15.3571 7.91311 15.352 7.86968 15.3417C7.61025 15.2806 7.42968 15.052 7.42968 14.7857V9.64286C7.42968 9.32743 7.17368 9.07143 6.85825 9.07143H1.7154C1.44911 9.07143 1.22054 8.89029 1.1594 8.63143C1.09825 8.372 1.22168 8.108 1.45997 7.98915L14.0314 1.70343C14.1103 1.664 14.1983 1.64286 14.2863 1.64286C14.4394 1.64286 14.5828 1.70229 14.6908 1.81029C14.8651 1.98457 14.908 2.24972 14.7977 2.46972Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_14723_31" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 16,
            height: 16,
            fill: "white",
            transform: "translate(0 0.5)",
          }),
        ),
      ),
    ),
  ce = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 20,
        height: 21,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M14.497 10.9223L10.9606 14.4587C10.8706 14.5487 10.717 14.4852 10.717 14.358L10.717 2.30873C10.717 1.92801 10.4299 1.59587 10.0506 1.57158C9.63486 1.54444 9.28843 1.87444 9.28843 2.28444L9.28843 14.358C9.28843 14.4852 9.13486 14.5487 9.04486 14.4587L5.50843 10.9223C5.36914 10.783 5.18629 10.713 5.00343 10.713C4.80486 10.713 4.60629 10.7952 4.46343 10.9594C4.21486 11.2452 4.24557 11.6802 4.51343 11.9473L9.497 16.9323C9.497 16.9323 9.50343 16.938 9.50629 16.9409C9.51986 16.9544 9.53414 16.9673 9.54914 16.9794C9.55771 16.9866 9.567 16.993 9.57628 16.9994C9.58629 17.0066 9.59557 17.0144 9.60557 17.0209C9.61557 17.028 9.62629 17.0337 9.637 17.0402C9.64629 17.0459 9.65628 17.0516 9.66557 17.0573C9.67628 17.063 9.68629 17.0673 9.697 17.0723C9.70771 17.0773 9.71771 17.0823 9.72914 17.0873C9.73914 17.0916 9.74914 17.0944 9.75986 17.0987C9.772 17.103 9.78343 17.1073 9.79557 17.1109C9.80557 17.1137 9.81557 17.1159 9.82557 17.1187C9.83843 17.1216 9.85057 17.1252 9.86343 17.128C9.87486 17.1302 9.88557 17.1316 9.897 17.133C9.90914 17.1344 9.92057 17.1373 9.93271 17.138C9.952 17.1402 9.97129 17.1409 9.98986 17.1409C9.99414 17.1409 9.99843 17.1409 10.0027 17.1409C10.007 17.1409 10.0113 17.1409 10.0156 17.1409C10.0349 17.1409 10.0541 17.1402 10.0727 17.138C10.0849 17.1366 10.0963 17.1344 10.1084 17.133C10.1199 17.1316 10.1306 17.1302 10.142 17.128C10.1549 17.1252 10.167 17.1223 10.1799 17.1187C10.1899 17.1159 10.1999 17.1137 10.2099 17.1109C10.222 17.1073 10.2334 17.103 10.2456 17.0987C10.2556 17.0952 10.2663 17.0916 10.2763 17.0873C10.287 17.083 10.2977 17.0773 10.3084 17.0723C10.3191 17.0673 10.3299 17.0623 10.3399 17.0573C10.3499 17.0523 10.3591 17.0459 10.3684 17.0402C10.3791 17.0337 10.3899 17.028 10.3999 17.0209C10.4099 17.0144 10.4191 17.0066 10.4291 16.9994C10.4384 16.993 10.447 16.9866 10.4563 16.9794C10.4713 16.9673 10.4856 16.9537 10.4991 16.9409C10.502 16.938 10.5056 16.9359 10.5084 16.9323L15.4899 11.9494C15.7591 11.6802 15.7906 11.2423 15.5391 10.9566C15.2641 10.6437 14.7863 10.6316 14.4963 10.9216L14.497 10.9223Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M2.31882 19.5462H16.8426C17.2041 19.5462 17.4974 19.2529 17.4974 18.8915C17.4974 18.53 17.2041 18.2367 16.8426 18.2367H2.31882C1.9574 18.2367 1.66406 18.53 1.66406 18.8915C1.66406 19.2529 1.9574 19.5462 2.31882 19.5462Z",
        fill: "currentColor",
      }),
    ),
  se = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_14723_37660)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M15.9304 8.02913C15.8899 7.88627 15.4979 6.5977 14.3242 5.3337C13.6567 4.61484 12.867 4.04055 11.9693 3.61884C11.8459 3.56113 11.8007 3.40855 11.8722 3.29255L13.0447 1.38741C13.2042 1.12798 13.1476 0.781695 12.8996 0.605695C12.6276 0.413123 12.2539 0.492552 12.0819 0.771981L2.9493 15.6103C2.78473 15.8777 2.84987 16.2366 3.1133 16.4074C3.20987 16.4703 3.31787 16.5 3.42416 16.5C3.61616 16.5 3.80359 16.4034 3.91159 16.228L5.27159 14.0183C5.32416 13.9326 5.42702 13.8926 5.52473 13.9171C6.29902 14.1143 7.12759 14.2143 7.99673 14.2143C11.271 14.2143 13.2453 12.8286 14.3242 11.6663C15.4979 10.4023 15.8899 9.1137 15.9304 8.97084C16.0184 8.66227 16.0184 8.33656 15.9304 8.02913ZM14.8316 8.65713C14.8282 8.66856 14.495 9.80284 13.4864 10.8891C12.5619 11.8846 10.859 13.072 7.99616 13.072C7.34873 13.072 6.72987 13.0103 6.1453 12.8886C6.06816 12.8726 6.03102 12.784 6.07216 12.7171L11.0779 4.58227C11.1076 4.53427 11.1676 4.51427 11.2196 4.53655C12.0944 4.90455 12.855 5.43255 13.4859 6.11198C14.4944 7.19827 14.8276 8.33256 14.831 8.34398C14.8602 8.44627 14.8602 8.55484 14.831 8.6577L14.8316 8.65713Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M3.05171 12.1657C3.25914 11.9275 3.234 11.5669 2.99571 11.3595C2.826 11.2115 2.66257 11.0532 2.51 10.8892C1.55 9.85545 1.20771 8.79888 1.16771 8.66688L1.16486 8.65602C1.13571 8.55431 1.13571 8.44574 1.16486 8.34288C1.16829 8.33145 1.50143 7.19717 2.51 6.11088C3.40829 5.14345 5.05857 3.97945 7.81857 3.93088C8.134 3.92517 8.38543 3.66517 8.37971 3.34917C8.374 3.03717 8.11971 2.78802 7.80886 2.78802C7.80543 2.78802 7.802 2.78802 7.79857 2.78802C4.63686 2.84402 2.722 4.20288 1.67286 5.33317C0.499143 6.59774 0.107143 7.88631 0.066 8.02917C-0.022 8.33774 -0.022 8.66345 0.066 8.97145L0.0705714 8.98631C0.0705714 8.98631 0.0717143 8.99088 0.0728571 8.99317C0.143714 9.22803 0.553429 10.4606 1.67286 11.6663C1.85286 11.86 2.04543 12.0463 2.246 12.2212C2.354 12.3155 2.48771 12.3617 2.62086 12.3617C2.78029 12.3617 2.93914 12.2955 3.05229 12.1657H3.05171Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_14723_37660" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 16,
            height: 16,
            fill: "white",
            transform: "translate(0 0.5)",
          }),
        ),
      ),
    ),
  de = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M22.9996 16.3219C22.9996 16.6236 22.8849 16.9253 22.6547 17.1555C22.1943 17.6159 21.4478 17.6159 20.9882 17.1555L12.1112 8.27852C12.0499 8.21723 11.9501 8.21723 11.8888 8.27852L3.01182 17.1555C2.55139 17.6159 1.80496 17.6159 1.34532 17.1555C0.884893 16.6951 0.884893 15.9487 1.34532 15.489L11.1667 5.66759C11.6272 5.20716 12.3736 5.20716 12.8333 5.66759L22.6547 15.489C22.8849 15.7192 22.9996 16.0209 22.9996 16.3227V16.3219Z",
        fill: "#1E1E1E",
      }),
    ),
  ue = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M1 7.67896C1 7.37725 1.11471 7.07554 1.34493 6.84532C1.80536 6.38489 2.55179 6.38489 3.01143 6.84532L11.8884 15.7223C11.9497 15.7836 12.0495 15.7836 12.1108 15.7223L20.9878 6.84532C21.4482 6.38489 22.1946 6.38489 22.6543 6.84532C23.1147 7.30575 23.1147 8.05218 22.6543 8.51182L12.8329 18.3333C12.3724 18.7937 11.626 18.7937 11.1664 18.3333L1.34493 8.51261C1.11471 8.28239 1 7.98068 1 7.67896Z",
        fill: "currentColor",
      }),
    ),
  Ce = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M16.3219 1C16.6236 1 16.9253 1.11471 17.1555 1.34493C17.6159 1.80536 17.6159 2.55179 17.1555 3.01143L8.27852 11.8884C8.21723 11.9497 8.21723 12.0495 8.27852 12.1108L17.1555 20.9878C17.6159 21.4482 17.6159 22.1946 17.1555 22.6543C16.6951 23.1147 15.9487 23.1147 15.489 22.6543L5.66759 12.8329C5.20716 12.3724 5.20716 11.626 5.66759 11.1664L15.4882 1.34493C15.7184 1.11471 16.0202 1 16.3219 1Z",
        fill: "currentColor",
      }),
    ),
  he = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M7.67896 22.9996C7.37725 22.9996 7.07554 22.8849 6.84532 22.6547C6.38489 22.1943 6.38489 21.4478 6.84532 20.9882L15.7223 12.1112C15.7836 12.0499 15.7836 11.9501 15.7223 11.8888L6.84532 3.01182C6.38489 2.55139 6.38489 1.80496 6.84532 1.34532C7.30575 0.884893 8.05218 0.884893 8.51182 1.34532L18.3333 11.1667C18.7937 11.6272 18.7937 12.3736 18.3333 12.8333L8.51182 22.6547C8.28161 22.8849 7.97989 22.9996 7.67818 22.9996H7.67896Z",
        fill: "currentColor",
      }),
    ),
  me = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M21.4612 19.7918L13.6512 12.0185L21.452 4.21767C21.9012 3.76851 21.9378 3.04434 21.5253 2.57684C21.3053 2.32934 20.9937 2.18267 20.6728 2.17351C20.352 2.15517 20.0312 2.29267 19.7928 2.52184L11.992 10.3318L4.19117 2.52184C3.962 2.29267 3.66867 2.18267 3.31117 2.17351C2.98117 2.18267 2.67867 2.32934 2.45867 2.57684C2.04617 3.04434 2.08284 3.75934 2.53201 4.21767L10.3237 12.0002L2.53201 19.7918C2.08284 20.241 2.04617 20.956 2.45867 21.4235C2.89867 21.9185 3.72367 21.946 4.19117 21.4877L11.992 13.6777L19.802 21.4877C20.022 21.7077 20.3245 21.836 20.6362 21.836C20.9753 21.836 21.3053 21.6893 21.5345 21.4235C21.9378 20.956 21.9103 20.241 21.4612 19.7918Z",
        fill: "currentColor",
      }),
    ),
  fe = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("circle", { cx: 12, cy: 12, r: 10, fill: "white" }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M12 23C18.0657 23 23 18.0657 23 12C23 5.93429 18.0657 1 12 0.999999C5.93429 0.999999 1 5.93428 1 12C1 18.0657 5.93429 23 12 23ZM10.8214 6.5C10.8214 5.84943 11.3494 5.32143 12 5.32143C12.6506 5.32143 13.1786 5.84943 13.1786 6.5L13.1786 12.3929C13.1786 13.0434 12.6506 13.5714 12 13.5714C11.3494 13.5714 10.8214 13.0434 10.8214 12.3929L10.8214 6.5ZM10.8214 17.1071C10.8214 16.4566 11.3494 15.9286 12 15.9286C12.6506 15.9286 13.1786 16.4566 13.1786 17.1071L13.1786 17.5C13.1786 18.1506 12.6506 18.6786 12 18.6786C11.3494 18.6786 10.8214 18.1506 10.8214 17.5L10.8214 17.1071Z",
        fill: "#CD2E0F",
      }),
    ),
  pe = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M24 2C11.8686 2 2 11.8686 2 24C2 36.1314 11.8686 46 24 46C36.1314 46 46 36.1314 46 24C46 11.8686 36.1314 2 24 2ZM40.6744 31.6733C38.6709 31.2411 36.1597 30.897 33.3421 30.6597C33.1646 30.644 33.0341 30.4869 33.0561 30.3093C33.2997 28.29 33.427 26.1701 33.427 24.0016C33.427 21.833 33.2981 19.7131 33.0561 17.6939C33.0341 17.5163 33.1646 17.3576 33.3421 17.3434C36.1597 17.1061 38.6709 16.762 40.6744 16.3299C40.9714 16.2654 41.2684 16.4241 41.3863 16.7039C42.3323 18.9494 42.8571 21.4166 42.8571 24.0031C42.8571 26.5897 42.3339 29.0553 41.3863 31.3024C41.2684 31.5821 40.9714 31.7409 40.6744 31.6764V31.6733ZM24 42.8571C22.2321 42.8571 19.996 39.6059 18.7231 33.9157C18.6807 33.7256 18.8206 33.5417 19.0154 33.5339C20.6246 33.4663 22.295 33.4301 24 33.4301C25.705 33.4301 27.3754 33.4663 28.9846 33.5339C29.1794 33.5417 29.3193 33.7256 29.2769 33.9157C28.004 39.6059 25.7663 42.8571 24 42.8571ZM24 30.2857C22.086 30.2857 20.2066 30.3297 18.4026 30.4146C18.2391 30.4224 18.0977 30.3046 18.0773 30.1411C17.8463 28.268 17.7143 26.2157 17.7143 24C17.7143 21.7843 17.8463 19.732 18.0773 17.8589C18.0977 17.6954 18.2391 17.5776 18.4026 17.5854C20.205 17.6703 22.086 17.7143 24 17.7143C25.914 17.7143 27.7934 17.6703 29.5959 17.5854C29.7593 17.5776 29.9007 17.6954 29.9211 17.8589C30.1521 19.732 30.2841 21.7843 30.2841 24C30.2841 26.2157 30.1521 28.268 29.9211 30.1411C29.9007 30.3046 29.7593 30.4224 29.5959 30.4146C27.7934 30.3297 25.9156 30.2857 24 30.2857ZM24 5.14286C25.7679 5.14286 28.004 8.39414 29.2769 14.0843C29.3193 14.2744 29.1794 14.4583 28.9846 14.4661C27.3754 14.5337 25.705 14.5699 24 14.5699C22.295 14.5699 20.6246 14.5337 19.0154 14.4661C18.8206 14.4583 18.6807 14.2744 18.7231 14.0843C19.996 8.39414 22.2337 5.14286 24 5.14286ZM39.0747 13.4447C37.2959 13.7779 35.1571 14.0466 32.789 14.2367C32.6303 14.2493 32.4873 14.1409 32.4559 13.9853C32.0803 12.175 31.601 10.492 31.0227 8.98971C30.7006 8.15214 30.3517 7.38371 29.9809 6.68914C29.8457 6.43771 30.094 6.14857 30.3627 6.246C33.9644 7.54086 37.0601 9.90271 39.2711 12.9466C39.4079 13.1351 39.3041 13.4007 39.0763 13.4431L39.0747 13.4447ZM17.6373 6.24757C17.906 6.15014 18.1543 6.43929 18.0191 6.69071C17.6483 7.38529 17.2994 8.15214 16.9773 8.98971C16.4006 10.4904 15.9213 12.1734 15.5441 13.9837C15.5111 14.1409 15.3681 14.2493 15.2079 14.2367C12.8397 14.0466 10.7026 13.7779 8.92371 13.4447C8.69586 13.4023 8.59371 13.1367 8.72886 12.9497C10.9383 9.90429 14.0356 7.54243 17.6373 6.24757ZM7.32557 16.3267C9.32914 16.7589 11.8403 17.103 14.6579 17.3403C14.8354 17.356 14.9643 17.5131 14.9439 17.6907C14.7003 19.71 14.5714 21.8314 14.5714 24C14.5714 26.1686 14.7003 28.2884 14.9439 30.3093C14.9659 30.4869 14.8354 30.644 14.6579 30.6597C11.8403 30.897 9.32914 31.2411 7.32557 31.6733C7.02857 31.7377 6.73157 31.579 6.61371 31.2993C5.66771 29.0537 5.14286 26.5866 5.14286 24C5.14286 21.4134 5.66614 18.9479 6.61371 16.7007C6.73157 16.421 7.02857 16.2623 7.32557 16.3267ZM8.92371 34.5553C10.7026 34.2221 12.8413 33.9534 15.2079 33.7633C15.3666 33.7507 15.5111 33.8591 15.5441 34.0163C15.9197 35.8266 16.399 37.508 16.9773 39.0103C17.2994 39.8479 17.6483 40.6147 18.0191 41.3093C18.1543 41.5623 17.906 41.8499 17.6373 41.7524C14.0356 40.4576 10.9399 38.0957 8.72886 35.0519C8.59214 34.8649 8.69586 34.5977 8.92371 34.5553ZM30.3611 41.7524C30.0924 41.8499 29.8441 41.5607 29.9793 41.3093C30.3517 40.6147 30.699 39.8463 31.0211 39.0087C31.5994 37.5064 32.0787 35.8234 32.4543 34.0131C32.4873 33.8576 32.6303 33.7491 32.7874 33.7617C35.1556 33.9519 37.2927 34.2206 39.0731 34.5537C39.301 34.5961 39.4047 34.8617 39.268 35.0503C37.0586 38.0957 33.9613 40.456 30.3596 41.7509L30.3611 41.7524Z",
        fill: "currentColor",
      }),
    ),
  _e = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M12 0C5.38286 0 0 5.38286 0 12C0 18.6171 5.38286 24 12 24C18.6171 24 24 18.6171 24 12C24 5.38286 18.6171 0 12 0ZM13.2857 18C13.2857 18.7097 12.7097 19.2857 12 19.2857C11.2903 19.2857 10.7143 18.7097 10.7143 18V11.5714C10.7143 10.8617 11.2903 10.2857 12 10.2857C12.7097 10.2857 13.2857 10.8617 13.2857 11.5714V18ZM13.2857 6.42857C13.2857 7.13829 12.7097 7.71429 12 7.71429C11.2903 7.71429 10.7143 7.13829 10.7143 6.42857V6C10.7143 5.29029 11.2903 4.71429 12 4.71429C12.7097 4.71429 13.2857 5.29029 13.2857 6V6.42857Z",
        fill: "currentColor",
      }),
    ),
  ge = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M11.1442 1.69006C9.73563 1.69006 8.73883 2.13844 8.08721 3.08392C8.04583 3.14416 7.9573 3.14416 7.91592 3.08392C7.2643 2.13844 6.26749 1.69006 4.85897 1.69006C2.50864 1.69006 0.667969 3.6774 0.667969 6.21368C0.667969 7.35821 0.997969 8.54254 1.64906 9.73263C2.18283 10.709 2.91773 11.6681 3.83335 12.5837C5.33564 14.086 7.20564 15.3086 8.0013 15.3086C8.79697 15.3086 10.667 14.086 12.1693 12.5837C13.0849 11.6681 13.8198 10.709 14.3535 9.73263C15.0046 8.54254 15.3346 7.35821 15.3346 6.21368C15.3346 3.67687 13.494 1.69006 11.1442 1.69006ZM11.4689 11.8033C9.91059 13.3742 8.33863 14.2348 8.0013 14.2615C7.66397 14.2348 6.09202 13.3742 4.53368 11.8033C3.48135 10.7425 1.71559 8.6054 1.71559 6.21421C1.71559 4.26511 3.09583 2.73821 4.85844 2.73821C6.33873 2.73821 7.0794 3.27511 7.50054 4.65325C7.56811 4.87378 7.77135 5.02411 8.0013 5.02411C8.23125 5.02411 8.43502 4.87378 8.50206 4.65325C8.92321 3.27511 9.66387 2.73821 11.1442 2.73821C12.9068 2.73821 14.287 4.26511 14.287 6.21421C14.287 8.6054 12.5213 10.7425 11.4689 11.8033Z",
        fill: "currentColor",
      }),
    ),
  ve = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M21.792 10.8214H13.1845V2.21391C13.1845 1.58141 12.6986 1.04974 12.0845 1.00391C11.7453 0.976406 11.4336 1.09557 11.1953 1.31557C10.957 1.53557 10.8195 1.85641 10.8195 2.17724V10.8122H2.21197C1.5703 10.8214 1.03864 11.3072 1.00197 11.9214C0.983638 12.2514 1.09364 12.5722 1.31364 12.8106C1.53364 13.0489 1.85447 13.1864 2.1753 13.1864H10.8103V21.7939C10.8103 22.4356 11.2961 22.9581 11.9195 23.0039C11.947 23.0039 11.9745 23.0039 12.002 23.0039C12.3045 23.0039 12.5886 22.8939 12.8086 22.6831C13.047 22.4631 13.1845 22.1422 13.1845 21.8214V13.1864H21.8195C22.1495 13.1864 22.4611 13.0489 22.6811 12.8106C22.9103 12.5722 23.0203 12.2514 23.002 11.9214C22.9653 11.2981 22.4336 10.8122 21.792 10.8122V10.8214Z",
        fill: "currentColor",
      }),
    ),
  He = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M12 2C17.5227 2 21.9998 6.50411 22 12.0605C22 17.0823 18.3432 21.2452 13.5625 22V14.9688H15.8926L16.3359 12.0605H13.5625V10.1738C13.5625 9.37818 13.9502 8.60254 15.1924 8.60254H16.4531V6.12598C16.4384 6.12346 15.3018 5.9297 14.2148 5.92969C11.9307 5.92969 10.4375 7.32316 10.4375 9.84473V12.0605H7.89844V14.9688H10.4375V22C5.65685 21.2452 2 17.0822 2 12.0605C2.00019 6.50413 6.4773 2.00004 12 2Z",
        fill: "currentColor",
      }),
    ),
  Ve = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 25,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M12 2.73669C14.7158 2.73669 15.0565 2.7476 16.123 2.79626C17.1874 2.84481 17.9147 3.01389 18.5508 3.26111C19.2081 3.51655 19.7655 3.85879 20.3213 4.41443C20.8772 4.9704 21.22 5.52833 21.4756 6.18591C21.7228 6.82199 21.8909 7.54926 21.9395 8.61365C21.9881 9.68015 22 10.0209 22 12.7367C22 15.4523 21.9881 15.7932 21.9395 16.8597C21.8909 17.9237 21.7226 18.6506 21.4756 19.2865C21.22 19.9441 20.8772 20.502 20.3213 21.058C19.7655 21.6137 19.2082 21.9558 18.5508 22.2113C17.9147 22.4585 17.1874 22.6276 16.123 22.6761C15.0564 22.7248 14.7158 22.7367 12 22.7367C9.28423 22.7367 8.94355 22.7248 7.87695 22.6761C6.81265 22.6276 6.08526 22.4585 5.44922 22.2113C4.79187 21.9558 4.23452 21.6137 3.67871 21.058C3.12278 20.502 2.78091 19.9441 2.52539 19.2865C2.27824 18.6505 2.10911 17.9239 2.06055 16.8597C2.01188 15.7932 2 15.4523 2 12.7367C2 10.021 2.01189 9.68015 2.06055 8.61365C2.10909 7.54926 2.27817 6.82199 2.52539 6.18591C2.7809 5.52844 3.12286 4.97032 3.67871 4.41443C4.23448 3.85878 4.79189 3.51656 5.44922 3.26111C6.08527 3.0139 6.81263 2.84482 7.87695 2.79626C8.94355 2.7476 9.28423 2.73669 12 2.73669ZM11.999 4.53845C9.3289 4.53845 9.01247 4.54894 7.95801 4.59705C6.98318 4.64151 6.45392 4.80484 6.10156 4.94177C5.63479 5.12318 5.30108 5.33987 4.95117 5.68982C4.60145 6.03959 4.38447 6.37263 4.20312 6.83923C4.06621 7.19157 3.90385 7.72106 3.85938 8.69568C3.81127 9.75011 3.80078 10.0667 3.80078 12.7367C3.80078 15.4068 3.81126 15.7233 3.85938 16.7777C3.90381 17.7523 4.06621 18.2818 4.20312 18.6342C4.38452 19.1009 4.6013 19.4347 4.95117 19.7845C5.30108 20.1345 5.63479 20.3512 6.10156 20.5326C6.45392 20.6695 6.98339 20.8319 7.95801 20.8763C9.01235 20.9245 9.3287 20.9349 11.999 20.9349C14.6693 20.9349 14.9857 20.9245 16.04 20.8763C17.0147 20.8319 17.5441 20.6695 17.8965 20.5326C18.3633 20.3512 18.697 20.1345 19.0469 19.7845C19.3968 19.4347 19.6135 19.1009 19.7949 18.6342C19.9318 18.2818 20.0942 17.7522 20.1387 16.7777C20.1868 15.7233 20.1973 15.4068 20.1973 12.7367C20.1973 10.0667 20.1868 9.75011 20.1387 8.69568C20.0942 7.72108 19.9318 7.19157 19.7949 6.83923C19.6136 6.37265 19.3966 6.03958 19.0469 5.68982C18.697 5.33987 18.3633 5.12318 17.8965 4.94177C17.5441 4.80484 17.0149 4.64152 16.04 4.59705C14.9856 4.54894 14.6691 4.53845 11.999 4.53845ZM11.999 7.60193C14.8349 7.60198 17.1336 9.90077 17.1338 12.7367C17.1338 15.5727 14.835 17.8724 11.999 17.8724C9.16293 17.8724 6.86426 15.5727 6.86426 12.7367C6.86442 9.90074 9.16303 7.60193 11.999 7.60193ZM12 9.40369C10.1592 9.40369 8.66722 10.8959 8.66699 12.7367C8.66699 14.5776 10.159 16.0707 12 16.0707C13.8409 16.0707 15.333 14.5776 15.333 12.7367C15.3328 10.8959 13.8408 9.40371 12 9.40369ZM17.3379 6.19861C18.0006 6.19867 18.5381 6.7361 18.5381 7.3988C18.5381 8.06151 18.0006 8.59894 17.3379 8.599C16.6752 8.599 16.1377 8.06155 16.1377 7.3988C16.1377 6.73607 16.6752 6.19861 17.3379 6.19861Z",
        fill: "currentColor",
      }),
    ),
  be = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 25,
        height: 25,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_8718_98089)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M20.957 2.73669C21.7727 2.73669 22.4372 3.38179 22.4375 4.17712V21.2933C22.4375 22.0899 21.7728 22.7367 20.957 22.7367H3.91406C3.09964 22.7367 2.4375 22.0899 2.4375 21.2933V4.17712C2.43776 3.38179 3.0998 2.73669 3.91406 2.73669H20.957ZM5.40234 10.2347V19.7797H8.36914V10.2347H5.40234ZM15.9219 9.99744C14.4791 9.99744 13.5115 10.7883 13.1152 11.5385H13.0752V10.2347H10.2295V19.7797H13.1934V15.058C13.1934 13.8131 13.4312 12.6068 14.9746 12.6068C16.4954 12.6071 16.5156 14.0314 16.5156 15.1381V19.7797H19.4805V14.5443C19.4805 11.9747 18.9255 9.99755 15.9219 9.99744ZM6.88477 5.4906C5.93411 5.49078 5.16504 6.26169 5.16504 7.21033C5.16517 8.15969 5.93419 8.92987 6.88477 8.93005C7.83313 8.93005 8.60436 8.1598 8.60449 7.21033C8.60449 6.26158 7.83321 5.4906 6.88477 5.4906Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_8718_98089" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 24,
            height: 24,
            fill: "white",
            transform: "translate(0.4375 0.736694)",
          }),
        ),
      ),
    ),
  Ee = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 35,
        height: 36,
        viewBox: "0 0 35 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M3.75 4.12695H31.25C33.3175 4.12695 35 5.80945 35 7.87695V27.877C35 29.9445 33.3175 31.627 31.25 31.627H3.75C1.6825 31.627 0 29.9445 0 27.877V7.87695C0 5.80945 1.6825 4.12695 3.75 4.12695ZM4.90875 7.0532L16.5875 18.732C16.8175 18.962 17.1213 19.112 17.4463 19.1257C17.8 19.1407 18.135 19.0095 18.3838 18.7607L30.0912 7.0532C30.2487 6.8957 30.1375 6.62695 29.915 6.62695H5.08625C4.86375 6.62695 4.7525 6.8957 4.91 7.0532H4.90875ZM3.75 29.127H31.25C31.94 29.127 32.5 28.567 32.5 27.877V8.78445C32.5 8.56195 32.2313 8.4507 32.0738 8.6082L20.1525 20.5295C19.4125 21.2695 18.4188 21.662 17.3675 21.6257C16.3962 21.592 15.4813 21.162 14.7938 20.4745L2.9275 8.6082C2.77 8.4507 2.50125 8.56195 2.50125 8.78445V27.8782C2.50125 28.5682 3.06125 29.1282 3.75125 29.1282L3.75 29.127Z",
        fill: "currentColor",
      }),
    ),
  we = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M4.5692 1.07141H2.85491C1.90977 1.07141 1.14062 1.84055 1.14062 2.7857V14.2143C1.14062 15.1594 1.90977 15.9286 2.85491 15.9286H4.5692C5.51434 15.9286 6.28348 15.1594 6.28348 14.2143V2.7857C6.28348 1.84055 5.51434 1.07141 4.5692 1.07141ZM5.14062 14.2143C5.14062 14.5291 4.88405 14.7857 4.5692 14.7857H2.85491C2.54005 14.7857 2.28348 14.5291 2.28348 14.2143V2.7857C2.28348 2.47084 2.54005 2.21427 2.85491 2.21427H4.5692C4.88405 2.21427 5.14062 2.47084 5.14062 2.7857V14.2143Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M13.1395 1.07141H11.4252C10.4801 1.07141 9.71094 1.84055 9.71094 2.7857V14.2143C9.71094 15.1594 10.4801 15.9286 11.4252 15.9286H13.1395C14.0847 15.9286 14.8538 15.1594 14.8538 14.2143V2.7857C14.8538 1.84055 14.0847 1.07141 13.1395 1.07141ZM13.7109 14.2143C13.7109 14.5291 13.4544 14.7857 13.1395 14.7857H11.4252C11.1104 14.7857 10.8538 14.5291 10.8538 14.2143V2.7857C10.8538 2.47084 11.1104 2.21427 11.4252 2.21427H13.1395C13.4544 2.21427 13.7109 2.47084 13.7109 2.7857V14.2143Z",
        fill: "currentColor",
      }),
    ),
  Ae = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 25,
        height: 25,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_8718_98091)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M12.4375 2.73669C14.2517 2.73669 15.9249 3.18346 17.457 4.07751C18.9891 4.97161 20.2026 6.18505 21.0967 7.71716C21.9907 9.24921 22.4375 10.9226 22.4375 12.7367C22.4375 14.5509 21.9907 16.2242 21.0967 17.7562C20.2026 19.2883 18.9891 20.5008 17.457 21.3949C15.9249 22.289 14.2517 22.7367 12.4375 22.7367C11.474 22.7367 10.5274 22.5975 9.59863 22.3197C10.1108 21.5124 10.4493 20.8003 10.6143 20.184C10.6925 19.8885 10.9269 18.9728 11.3174 17.4369C11.491 17.7754 11.8085 18.0684 12.2686 18.3158C12.7286 18.5631 13.2235 18.6869 13.7529 18.6869C14.8032 18.6868 15.7408 18.3899 16.5654 17.7953C17.39 17.2007 18.0281 16.3818 18.4795 15.3402C18.9307 14.2987 19.1562 13.1265 19.1562 11.8246C19.1562 10.8352 18.8982 9.90637 18.3818 9.03845C17.8654 8.17048 17.1165 7.46324 16.1357 6.91638C15.1549 6.36954 14.048 6.09611 12.8154 6.09607C11.904 6.09607 11.0526 6.22129 10.2627 6.47302C9.47287 6.72475 8.80214 7.05933 8.25098 7.47595C7.69993 7.89252 7.22691 8.37206 6.83203 8.91443C6.43711 9.45691 6.1466 10.0194 5.95996 10.601C5.77333 11.1825 5.67969 11.7645 5.67969 12.3461C5.67971 13.2488 5.853 14.0432 6.2002 14.7289C6.54737 15.4146 7.05536 15.8964 7.72363 16.1742C7.98405 16.2784 8.14931 16.1912 8.21875 15.9135C8.23612 15.8527 8.2712 15.7183 8.32324 15.5101C8.37522 15.3022 8.40936 15.1718 8.42676 15.1195C8.47884 14.9199 8.43175 14.7326 8.28418 14.559C7.84155 14.0295 7.62012 13.3743 7.62012 12.5931C7.62014 11.2824 8.07338 10.156 8.98047 9.21423C9.88758 8.27241 11.075 7.80115 12.542 7.80115C13.8526 7.80119 14.8749 8.15775 15.6084 8.86951C16.3418 9.58128 16.708 10.5059 16.708 11.6429C16.708 13.1185 16.411 14.3727 15.8164 15.4056C15.2218 16.4386 14.4601 16.9554 13.5312 16.9554C13.0018 16.9554 12.576 16.7666 12.2549 16.389C11.9338 16.0114 11.8345 15.5572 11.9561 15.0277C12.0255 14.724 12.1403 14.3184 12.3008 13.8109C12.4614 13.3031 12.5916 12.8554 12.6914 12.4691C12.7911 12.0831 12.8408 11.7557 12.8408 11.4867C12.8408 11.0527 12.7236 10.6921 12.4893 10.4056C12.2549 10.1194 11.9211 9.97601 11.4873 9.97595C10.9492 9.97595 10.4934 10.2235 10.1201 10.7181C9.74693 11.2128 9.55965 11.8291 9.55957 12.5668C9.55957 13.2005 9.66873 13.7303 9.88574 14.1556L8.59668 19.598C8.44913 20.2056 8.39207 20.9741 8.42676 21.9027C6.63879 21.1128 5.19315 19.8937 4.09082 18.2445C2.98845 16.5953 2.43754 14.7592 2.4375 12.7367C2.4375 10.9226 2.88435 9.24919 3.77832 7.71716C4.67242 6.18505 5.88585 4.97161 7.41797 4.07751C8.95007 3.18343 10.6233 2.73671 12.4375 2.73669Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_8718_98091" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 24,
            height: 24,
            fill: "white",
            transform: "translate(0.4375 0.736694)",
          }),
        ),
      ),
    ),
  Me = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M18.9778 18.0496L15.8939 14.9656C15.8461 14.9178 15.8428 14.8412 15.8867 14.7895C17.1589 13.2639 17.9086 11.2885 17.8575 9.14022C17.7515 4.66296 13.9113 0.878433 9.43337 0.833909C4.6726 0.787421 0.789863 4.67016 0.836351 9.43159C0.880874 13.9095 4.6654 17.7497 9.142 17.8558C11.2903 17.9068 13.2657 17.1571 14.7913 15.8849C14.8437 15.8417 14.9196 15.8443 14.9674 15.8921L18.0514 18.9761C18.179 19.1037 18.3466 19.1679 18.5143 19.1679C18.6819 19.1679 18.8495 19.1037 18.9772 18.9761C19.2325 18.72 19.2325 18.3056 18.9772 18.0502L18.9778 18.0496ZM2.14587 9.34581C2.14587 5.37468 5.37712 2.14343 9.34826 2.14343C13.3194 2.14343 16.5506 5.37468 16.5506 9.34581C16.5506 13.3169 13.3194 16.5482 9.34826 16.5482C5.37712 16.5482 2.14587 13.3169 2.14587 9.34581Z",
        fill: "currentColor",
      }),
    ),
  Ze = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M0.4994 7.17835V10.3225C0.4994 10.9733 1.02648 11.5004 1.67732 11.5004H10.3215C10.9723 11.5004 11.4994 10.9733 11.4994 10.3225V7.17835C11.4994 6.96294 11.3252 6.78418 11.1052 6.78418C10.8898 6.78418 10.7111 6.95835 10.7111 7.17835V10.3225C10.7111 10.5379 10.5323 10.7167 10.3169 10.7167H1.67273C1.45731 10.7167 1.27856 10.5379 1.27856 10.3225V7.17835C1.27856 6.96294 1.1044 6.78418 0.884398 6.78418C0.668981 6.78418 0.490234 6.95835 0.490234 7.17835H0.4994Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M3.5288 3.91946L5.47214 1.97613C5.52255 1.92571 5.60505 1.96238 5.60505 2.03113V8.34237C5.60505 8.55321 5.76547 8.73196 5.97172 8.74571C6.20089 8.75946 6.3888 8.58072 6.3888 8.35614V2.03113C6.3888 1.96238 6.4713 1.92571 6.52172 1.97613L8.46505 3.91946C8.54297 3.99737 8.6438 4.03404 8.74464 4.03404C8.85464 4.03404 8.96464 3.98822 9.04255 3.90113C9.18005 3.7453 9.16172 3.50238 9.01505 3.35572L6.27422 0.614878C6.27422 0.614878 6.27422 0.614874 6.26963 0.610291C6.26047 0.601124 6.25589 0.596546 6.24672 0.587379C6.24214 0.587379 6.23755 0.578218 6.23297 0.578218C6.22839 0.578218 6.2238 0.569052 6.21464 0.564468C6.21005 0.564468 6.20089 0.559876 6.1963 0.555293C6.19172 0.555293 6.18714 0.550714 6.18255 0.546131C6.17797 0.546131 6.1688 0.541539 6.16422 0.536956C6.15964 0.536956 6.15505 0.532377 6.14589 0.527794C6.1413 0.527794 6.13672 0.527789 6.12755 0.523206C6.12297 0.523206 6.1138 0.518628 6.10922 0.514044H6.09088C6.09088 0.514044 6.07714 0.504883 6.06797 0.504883C6.06339 0.504883 6.05422 0.504883 6.04964 0.504883C6.04505 0.504883 6.03589 0.504883 6.0313 0.504883C6.02214 0.504883 6.00839 0.504883 5.99922 0.504883H5.98547C5.98547 0.504883 5.96255 0.504883 5.95339 0.504883C5.9488 0.504883 5.93964 0.504883 5.93505 0.504883C5.93047 0.504883 5.9213 0.504883 5.91672 0.504883C5.91214 0.504883 5.90297 0.504873 5.89839 0.509457H5.88005C5.88005 0.509457 5.8663 0.518632 5.86172 0.518632C5.85713 0.518632 5.84797 0.518623 5.84339 0.523206C5.8388 0.523206 5.82964 0.527798 5.82505 0.532382C5.82047 0.532382 5.8113 0.53696 5.80672 0.541543C5.80214 0.541543 5.79755 0.546122 5.78839 0.550705C5.7838 0.550705 5.77922 0.555297 5.77005 0.559881C5.76547 0.559881 5.76089 0.569047 5.75172 0.57363C5.74714 0.57363 5.74255 0.582792 5.73797 0.582792C5.7288 0.587375 5.71964 0.59655 5.71505 0.605717C5.71505 0.605717 5.71505 0.605707 5.71047 0.610291L2.96964 3.35113C2.82297 3.4978 2.80464 3.74071 2.94214 3.89655C3.09339 4.07071 3.35464 4.0753 3.51505 3.91488L3.5288 3.91946Z",
        fill: "currentColor",
      }),
    ),
  ye = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_14723_59161)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M2.45307 3.76104C2.5645 3.87247 2.71079 3.92847 2.85707 3.92847C3.00336 3.92847 3.14964 3.87247 3.26107 3.76104C3.4845 3.53761 3.4845 3.1759 3.26107 2.95304L0.975357 0.667327C0.7525 0.443899 0.390214 0.443899 0.167357 0.667327C-0.0554999 0.890756 -0.0560714 1.25247 0.167357 1.47533L2.45307 3.76104Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M13.5457 13.2389C13.3222 13.0154 12.9605 13.0154 12.7377 13.2389C12.5148 13.4623 12.5142 13.824 12.7377 14.0469L15.0234 16.3326C15.1348 16.444 15.2811 16.5 15.4274 16.5C15.5737 16.5 15.72 16.444 15.8314 16.3326C16.0548 16.1091 16.0548 15.7474 15.8314 15.5246L13.5457 13.2389Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M13.1419 3.9285C13.2882 3.9285 13.4345 3.8725 13.5459 3.76107L15.8316 1.47536C16.055 1.25193 16.055 0.890214 15.8316 0.667357C15.6082 0.4445 15.2465 0.443929 15.0236 0.667357L12.7379 2.95307C12.5145 3.1765 12.5145 3.53821 12.7379 3.76107C12.8493 3.8725 12.9956 3.9285 13.1419 3.9285Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M2.45329 13.2388L0.167571 15.5245C-0.0558571 15.7479 -0.0558571 16.1096 0.167571 16.3325C0.279 16.4439 0.425286 16.4999 0.571571 16.4999C0.717857 16.4999 0.864143 16.4439 0.975571 16.3325L3.26129 14.0468C3.48471 13.8233 3.48471 13.4616 3.26129 13.2388C3.03786 13.0159 2.67614 13.0153 2.45329 13.2388Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M7.99611 14.2143C7.52239 14.2143 7.09211 13.916 6.92582 13.4725L5.89782 10.7314C5.87439 10.6697 5.82582 10.6205 5.76411 10.5977L3.02296 9.56969C2.57954 9.4034 2.28125 8.97312 2.28125 8.4994C2.28125 8.02569 2.57954 7.5954 3.02296 7.42912L5.76411 6.40112C5.82582 6.37769 5.87496 6.32912 5.89782 6.2674L6.92582 3.52626C7.09211 3.08283 7.52239 2.78455 7.99611 2.78455C8.46982 2.78455 8.90011 3.08283 9.06639 3.52626L10.0944 6.2674C10.1178 6.32912 10.1664 6.37826 10.2281 6.40112L12.9693 7.42912C13.4127 7.5954 13.711 8.02569 13.711 8.4994C13.711 8.97312 13.4127 9.4034 12.9693 9.56969L10.2281 10.5977C10.1664 10.6211 10.1173 10.6697 10.0944 10.7314L9.06639 13.4725C8.90011 13.916 8.46982 14.2143 7.99611 14.2143ZM7.88925 4.21369L6.84068 7.00969C6.78296 7.16397 6.66068 7.28626 6.50639 7.34397L3.71039 8.39255C3.61154 8.42969 3.61154 8.56969 3.71039 8.60683L6.50639 9.6554C6.66068 9.71312 6.78296 9.8354 6.84068 9.98969L7.88868 12.784C7.92582 12.8828 8.06582 12.8828 8.10296 12.784L9.15211 9.98969C9.20982 9.8354 9.33211 9.71312 9.48639 9.6554L12.2824 8.60683C12.3813 8.56969 12.3813 8.42969 12.2824 8.39255L9.48639 7.34397C9.33211 7.28626 9.20982 7.16397 9.15211 7.00969L8.10354 4.21369C8.06639 4.11483 7.92639 4.11483 7.88925 4.21369Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_14723_59161" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 16,
            height: 16,
            fill: "white",
            transform: "translate(0 0.5)",
          }),
        ),
      ),
    ),
  ke = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_8718_98096)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M18.8281 0.824585H2.82812C1.72356 0.824585 0.828125 1.72002 0.828125 2.82459V18.8246C0.828125 19.9292 1.72356 20.8246 2.82813 20.8246H18.8281C19.9327 20.8246 20.8281 19.9292 20.8281 18.8246V2.82458C20.8281 1.72002 19.9327 0.824585 18.8281 0.824585Z",
          fill: "#202020",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M9.50079 9.39132V8.84832C9.31913 8.82365 9.13446 8.80798 8.94579 8.80798C6.67513 8.80798 4.82812 10.6553 4.82812 12.9256C4.82812 14.3186 5.52413 15.5516 6.58613 16.297C5.90079 15.5613 5.49412 14.5756 5.49412 13.4933C5.49412 11.2553 7.27513 9.44298 9.50079 9.39098V9.39132Z",
          fill: "#25F4EE",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M9.60212 15.3902C10.6151 15.3902 11.4535 14.5729 11.4911 13.5689L11.4998 4.61586L13.1235 4.61652L13.1208 4.60319C13.0868 4.41886 13.0681 4.22952 13.0681 4.03552H10.8311L10.8275 13.0012C10.7898 14.0052 9.96346 14.8109 8.95046 14.8109C8.63546 14.8109 8.33912 14.7322 8.07812 14.5949C8.41979 15.0685 8.97513 15.3902 9.60246 15.3902H9.60212Z",
          fill: "#25F4EE",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M16.1794 7.67521V7.14987C15.5544 7.14987 14.9724 6.96421 14.4844 6.64587C14.919 7.14487 15.5094 7.53154 16.1794 7.67521Z",
          fill: "#25F4EE",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M14.4766 6.64748C14.0006 6.10048 13.7112 5.38714 13.7112 4.60681H13.1016C13.2592 5.45914 13.7756 6.19048 14.4766 6.64748Z",
          fill: "#FE2C55",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M8.94769 11.0319C7.91069 11.0319 7.05469 11.8926 7.05469 12.9296C7.05469 13.6516 7.47669 14.2789 8.07535 14.5939C7.85235 14.2849 7.71935 13.9066 7.71935 13.4973C7.71935 12.4603 8.56302 11.6166 9.60002 11.6166C9.79369 11.6166 9.97935 11.6486 10.155 11.7036V9.41961C9.97335 9.39494 9.78869 9.37927 9.60002 9.37927C9.56735 9.37927 9.53535 9.38094 9.50269 9.38161H9.49402L9.48802 11.1109C9.31235 11.0559 9.14135 11.0316 8.94769 11.0316V11.0319Z",
          fill: "#FE2C55",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M16.1759 7.6469L16.1656 7.6449L16.1649 9.37223C15.0049 9.37223 13.9273 8.99056 13.0496 8.36056L13.0503 12.9309C13.0503 15.2016 11.2163 17.0372 8.9456 17.0372C8.06827 17.0372 7.2546 16.7719 6.58594 16.3022C7.33827 17.1099 8.4096 17.6162 9.59794 17.6162C11.8686 17.6162 13.7156 15.7689 13.7156 13.4986V8.95223C14.5929 9.5819 15.6679 9.95323 16.8279 9.95323V7.71623C16.6043 7.71623 16.3863 7.6919 16.1759 7.6469Z",
          fill: "#FE2C55",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M13.068 12.9338V8.38748C13.9454 9.01714 15.0204 9.38848 16.1804 9.38848V7.64981C15.5104 7.50648 14.92 7.14648 14.4854 6.64748C13.7844 6.19048 13.2784 5.45914 13.1207 4.60681H11.4827L11.479 13.5725C11.4414 14.5765 10.615 15.3821 9.60204 15.3821C8.97471 15.3821 8.41938 15.0721 8.07771 14.5985C7.47904 14.2835 7.06938 13.6561 7.06938 12.9341C7.06938 11.8971 7.91304 11.0535 8.95004 11.0535C9.14371 11.0535 9.32938 11.0855 9.50504 11.1405V9.38648C7.27938 9.43848 5.48438 11.2638 5.48438 13.5018C5.48438 14.5841 5.90471 15.5698 6.59004 16.3055C7.25871 16.7751 8.07237 17.0518 8.94971 17.0518C11.2204 17.0518 13.0674 15.2045 13.0674 12.9341L13.068 12.9338Z",
          fill: "white",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_8718_98096" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 20,
            height: 20,
            fill: "white",
            transform: "translate(0.4375 0.736694)",
          }),
        ),
      ),
    ),
  Ne = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 20,
        height: 25,
        viewBox: "0 0 20 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M11.6784 11.2869L18.9151 2.82263H17.2002L10.9166 10.1721L5.89787 2.82263H0.109375L7.69865 13.9363L0.109375 22.8124H1.82434L8.46001 15.0511L13.7601 22.8124H19.5486L11.678 11.2869H11.6784ZM9.32949 14.0342L8.56054 12.9275L2.44226 4.12164H5.07635L10.0139 11.2283L10.7828 12.3349L17.201 21.5724H14.5669L9.32949 14.0346V14.0342Z",
        fill: "currentColor",
      }),
    ),
  Le = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 16,
        height: 17,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M15.1869 4.75595C14.916 4.58852 14.604 4.49995 14.2857 4.49995C14.0211 4.49995 13.756 4.5628 13.5194 4.68109L12.0006 5.44052V3.92852C12.0006 2.98338 11.2314 2.21423 10.2863 2.21423H1.71429C0.769143 2.21423 0 2.98338 0 3.92852V13.0714C0 14.0165 0.769143 14.7857 1.71429 14.7857H10.2857C11.2309 14.7857 12 14.0165 12 13.0714V11.5594L13.5189 12.3188C13.7554 12.4371 14.0206 12.4999 14.2857 12.4999C14.6046 12.4999 14.916 12.4114 15.1869 12.2439C15.696 11.9291 16 11.3839 16 10.7857V6.21423C16 5.61595 15.696 5.0708 15.1869 4.75595ZM14.8571 10.7857C14.8571 10.9851 14.756 11.1668 14.5863 11.2719C14.4211 11.3742 14.2046 11.3839 14.0303 11.2971L11.684 10.1239C11.5069 10.0354 11.2966 10.0451 11.128 10.1491C10.9594 10.2531 10.8571 10.4371 10.8571 10.6354V13.0719C10.8571 13.3868 10.6006 13.6434 10.2857 13.6434H1.71429C1.39943 13.6434 1.14286 13.3868 1.14286 13.0719V3.92852C1.14286 3.61366 1.39943 3.35709 1.71429 3.35709H10.2857C10.6006 3.35709 10.8571 3.61366 10.8571 3.92852V6.36509C10.8571 6.56338 10.9594 6.7468 11.128 6.85138C11.2966 6.95538 11.5069 6.96509 11.684 6.87652L14.0303 5.70338C14.2046 5.61652 14.4211 5.62623 14.5863 5.72852C14.756 5.83366 14.8571 6.01538 14.8571 6.2148V10.7862V10.7857Z",
        fill: "currentColor",
      }),
    ),
  Ie = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 25,
        height: 25,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_8718_98093)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M12.4424 5.78455C12.4939 5.78455 16.6571 5.78601 19.4385 5.98474C19.477 5.98928 19.5205 5.99293 19.5674 5.99744C19.9969 6.03871 20.7569 6.11209 21.4424 6.82166C22.0365 7.416 22.2347 8.75861 22.2383 8.78357C22.2383 8.78357 22.4375 10.3839 22.4375 11.9838V13.4838C22.4375 15.0738 22.2407 16.6638 22.2383 16.683C22.2383 16.683 22.0421 18.0459 21.4424 18.6459C20.7569 19.3553 19.9969 19.4288 19.5674 19.4701C19.5204 19.4746 19.477 19.4782 19.4385 19.4828C16.6398 19.6827 12.4375 19.6888 12.4375 19.6888C12.4149 19.6886 7.23429 19.6419 5.6377 19.4906C5.56171 19.4765 5.46958 19.4649 5.36523 19.4525C4.85842 19.3923 4.06332 19.2984 3.43262 18.6459C2.83296 18.0459 2.6377 16.683 2.6377 16.683C2.6358 16.6678 2.43752 15.0758 2.4375 13.4838V11.9838C2.4375 10.3839 2.6377 8.78357 2.6377 8.78357C2.64169 8.75608 2.83912 7.41542 3.43262 6.82166C4.11831 6.11209 4.87808 6.03871 5.30762 5.99744C5.35451 5.99293 5.39804 5.98928 5.43652 5.98474C8.23533 5.78477 12.4336 5.78455 12.4336 5.78455H12.4424ZM10.3721 15.3002L15.7754 12.5326L10.3711 9.74548L10.3721 15.3002Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_8718_98093" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 24,
            height: 24,
            fill: "white",
            transform: "translate(0.4375 0.736694)",
          }),
        ),
      ),
    ),
  xe = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ e.createElement("path", {
        d: "M22.2143 11.2148H1.78571C1.352 11.2148 1 11.5668 1 12.0006C1 12.4343 1.352 12.7863 1.78571 12.7863H22.2143C22.648 12.7863 23 12.4343 23 12.0006C23 11.5668 22.648 11.2148 22.2143 11.2148Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M22.2143 18.2852H1.78571C1.352 18.2852 1 18.6372 1 19.0709C1 19.5046 1.352 19.8566 1.78571 19.8566H22.2143C22.648 19.8566 23 19.5046 23 19.0709C23 18.6372 22.648 18.2852 22.2143 18.2852Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M1.78571 5.71401H22.2143C22.648 5.71401 23 5.36201 23 4.92829C23 4.49458 22.648 4.14258 22.2143 4.14258H1.78571C1.352 4.14258 1 4.49458 1 4.92829C1 5.36201 1.352 5.71401 1.78571 5.71401Z",
        fill: "currentColor",
      }),
    ),
  w = {
    ArrowDiagonal: "arrow-diagonal",
    ArrowLeft: "arrow-left",
    ArrowRight: "arrow-right",
    Briefcase: "briefcase",
    Calendar: "calendar",
    Close: "generic-close",
    Compliment: "compliment",
    Direction: "direction",
    Download: "download",
    EyeStrike: "eye-strike",
    Facebook: "facebook",
    GenericChevronUp: "generic-chevron-up",
    GenericChevronDown: "generic-chevron-down",
    GenericChevronLeft: "generic-chevron-left",
    GenericChevronRight: "generic-chevron-right",
    GenericError: "generic-error",
    GenericEthnicity: "generic-ethnicity",
    GenericInformation: "generic-information",
    GenericHeart: "generic-heart",
    GenericPlus: "generic-plus",
    Instagram: "instagram",
    Linkedin: "linkedin",
    Mail: "mail",
    NavigationBarHamburgerMenu: "navigation-bar-hamburger-menu",
    Pause: "pause",
    Tiktok: "tiktok",
    Search: "search",
    Share: "share",
    SpotlightBurst: "spotlight-burst",
    Twitter: "twitter",
    Pinterest: "pinterest",
    Video: "video",
    Youtube: "youtube",
  },
  Te = {
    [w.ArrowDiagonal]: /* @__PURE__ */ r(te, {}),
    [w.ArrowLeft]: /* @__PURE__ */ r(ae, {}),
    [w.ArrowRight]: /* @__PURE__ */ r(re, {}),
    [w.Briefcase]: /* @__PURE__ */ r(ne, {}),
    [w.Calendar]: /* @__PURE__ */ r(le, {}),
    [w.Close]: /* @__PURE__ */ r(me, {}),
    [w.Compliment]: /* @__PURE__ */ r(ie, {}),
    [w.Direction]: /* @__PURE__ */ r(oe, {}),
    [w.Download]: /* @__PURE__ */ r(ce, {}),
    [w.EyeStrike]: /* @__PURE__ */ r(se, {}),
    [w.GenericChevronUp]: /* @__PURE__ */ r(de, {}),
    [w.GenericChevronDown]: /* @__PURE__ */ r(ue, {}),
    [w.GenericChevronLeft]: /* @__PURE__ */ r(Ce, {}),
    [w.GenericChevronRight]: /* @__PURE__ */ r(he, {}),
    [w.GenericError]: /* @__PURE__ */ r(fe, {}),
    [w.GenericEthnicity]: /* @__PURE__ */ r(pe, {}),
    [w.GenericInformation]: /* @__PURE__ */ r(_e, {}),
    [w.GenericHeart]: /* @__PURE__ */ r(ge, {}),
    [w.GenericPlus]: /* @__PURE__ */ r(ve, {}),
    [w.Facebook]: /* @__PURE__ */ r(He, {}),
    [w.Instagram]: /* @__PURE__ */ r(Ve, {}),
    [w.Linkedin]: /* @__PURE__ */ r(be, {}),
    [w.Mail]: /* @__PURE__ */ r(Ee, {}),
    [w.NavigationBarHamburgerMenu]: /* @__PURE__ */ r(xe, {}),
    [w.Pause]: /* @__PURE__ */ r(we, {}),
    [w.Pinterest]: /* @__PURE__ */ r(Ae, {}),
    [w.Search]: /* @__PURE__ */ r(Me, {}),
    [w.Share]: /* @__PURE__ */ r(Ze, {}),
    [w.SpotlightBurst]: /* @__PURE__ */ r(ye, {}),
    [w.Tiktok]: /* @__PURE__ */ r(ke, {}),
    [w.Twitter]: /* @__PURE__ */ r(Ne, {}),
    [w.Youtube]: /* @__PURE__ */ r(Ie, {}),
    [w.Video]: /* @__PURE__ */ r(Le, {}),
  },
  N = ({ size: t = "stretch", color: a, name: n, a11yLabel: i, isInline: o }) => {
    const c = F({
      [N1.icon]: !0,
      [N1[`icon--${t}`]]: !0,
      [N1[`color-${a}`]]: a,
      [N1["icon--inline"]]: o,
    });
    return /* @__PURE__ */ r("div", {
      className: c,
      "aria-label": i,
      role: i ? "img" : void 0,
      children: n ? Te[n] : null,
    });
  };
N.Name = w;
const Se = {
    none: "",
    primary: W["button--primary"],
    secondary: W["button--secondary"],
    tertiary: W["button--tertiary"],
    circle: W["button--circle"],
  },
  Fe = {
    small: W["button--size-small"],
    medium: W["button--size-medium"],
  },
  Re = {
    default: W["button--color-default"],
    inverse: W["button--color-inverse"],
    yellow: W["button--color-yellow"],
  };
function U(t) {
  const {
      icon: a,
      iconPosition: n = "start",
      labelText: i,
      text: o,
      href: c,
      extraClass: l,
      testId: s,
      color: d = "default",
      size: g = "medium",
      designType: v = "primary",
      isCircle: h,
      isInline: V,
      isDisabled: y = !1,
      isHeaderButton: E = !1,
      isTargetBlank: b = !1,
      isActive: A = !1,
      onClick: L,
      type: q = "button",
      seo: P = {
        name: null,
        category: null,
        action: null,
        label: null,
        source: null,
      },
      ariaLabel: D,
      ariaLabelledBy: $,
      ariaExpanded: e1,
      ariaControls: H,
      ariaHasPopup: _,
    } = t,
    Z = F({
      [W.button]: !0,
      [W["button--circle"]]: h,
      [W["button--inline"]]: V,
      [W["button--header"]]: E,
      [W["is-pressed"]]: A,
      [Re[d]]: !0,
      [Fe[g]]: !0,
      [Se[v]]: !0,
      [l]: l,
    }),
    m = !!i || void 0,
    I = /* @__PURE__ */ f("span", {
      className: W.button__content,
      "aria-hidden": m,
      children: [
        a && n === "start"
          ? /* @__PURE__ */ r("span", {
              className: W.button__icon,
              children: /* @__PURE__ */ r(N, {
                name: a,
                color:
                  v === "secondary" || v === "tertiary"
                    ? d
                    : d !== "default"
                      ? "default"
                      : "inverse",
              }),
            })
          : null,
        o ? /* @__PURE__ */ r("span", { className: W.button__text, children: o }) : null,
        a && n === "end"
          ? /* @__PURE__ */ r("span", {
              className: W.button__icon,
              children: /* @__PURE__ */ r(N, { name: a, color: "default" }),
            })
          : null,
      ],
    });
  return /* @__PURE__ */ f(c ? "a" : "button", {
    className: Z,
    type: q,
    "data-seo-name": P.name,
    "data-seo-category": P.category,
    "data-seo-action": P.action,
    "data-seo-label": P.label,
    "data-source": P.source,
    "data-test": s,
    href: c,
    onClick: L,
    "aria-label": D,
    "aria-labelledby": $,
    "aria-expanded": e1,
    "aria-controls": H,
    "aria-haspopup": _,
    disabled: y,
    target: b ? "_blank" : void 0,
    children: [/* @__PURE__ */ r(Q1, { children: i == null ? void 0 : i.toString() }), I],
  });
}
const De = "card__HG0v6",
  Be = "card__image__I-atu",
  Oe = "card__copy__kC7e8",
  Pe = "card__link__zCqjc",
  qe = "card__year__wl5--",
  Qe = "cards__IcpQg",
  Ge = "cards__grid__h4YGT",
  K = {
    "header-1": "header-1__36Wn5",
    "is-responsive": "is-responsive__kE1Mk",
    "header-2": "header-2__Uz0ns",
    "header-3": "header-3__TVu-C",
    "p-1": "p-1__SrElt",
    "p-2": "p-2__vzwuz",
    "p-3": "p-3__nmIwG",
    "action-small": "action-small__j9v-D",
    "action-medium": "action-medium__H3UQx",
    "action-large": "action-large__JcONN",
    "is-inherited": "is-inherited__hnJuQ",
    "is-italic": "is-italic__xfa3T",
    "formatted-text": "formatted-text__Lv87J",
    "is-one-line": "is-one-line__UJwhY",
    card: De,
    "card--bg-light-yellow": "card--bg-light-yellow__fwbrC",
    "card--3-up": "card--3-up__tpKIu",
    "card--2-up": "card--2-up__o9tFM",
    "card--blog": "card--blog__z5BkF",
    "card--year": "card--year__O-QGn",
    card__image: Be,
    card__copy: Oe,
    "card__title-description": "card__title-description__vizG6",
    card__link: Pe,
    card__year: qe,
    "card__year-image": "card__year-image__ZtHJK",
    cards: Qe,
    "cards--2-up": "cards--2-up__VTLlI",
    cards__grid: Ge,
    "cards--3-up": "cards--3-up__sWAQZ",
    "cards--blog": "cards--blog__9cdx9",
    "cards--year": "cards--year__bA-jJ",
    "cards--scrollable": "cards--scrollable__59j9Q",
    "cards--is-at-end": "cards--is-at-end__SxKo0",
  },
  g2 = r1.createContext(void 0),
  v2 = r1.createContext(void 0),
  je = (t) => /* @__PURE__ */ r("img", { ...t }),
  We = () => r1.useContext(g2) ?? je,
  H2 = () => r1.useContext(v2) ?? "",
  y4 = ({ imageComponent: t, imagePath: a, children: n }) =>
    /* @__PURE__ */ r(g2.Provider, {
      value: t,
      children: /* @__PURE__ */ r(v2.Provider, { value: a, children: n }),
    }),
  H1 = () => {
    const t = We(),
      a = H2();
    return (n) => /* @__PURE__ */ r(t, { ...n, src: `${a}${n.src}` });
  },
  i2 = ({
    type: t,
    title: a,
    description: n,
    link: i,
    linkText: o,
    year: c,
    image: l,
    backgroundColor: s,
  }) => {
    const d = H1(),
      g = t === "2-up" ? n1 : G1;
    return /* @__PURE__ */ f("div", {
      className: F(K.card, {
        [K[`card--${t}`]]: t,
        [K[`card--bg-${s}`]]: s,
      }),
      children: [
        l &&
          t !== "year" &&
          /* @__PURE__ */ r("div", {
            className: K.card__image,
            children: /* @__PURE__ */ r(d, {
              src: l.src,
              alt: l.alt,
              style: l.style,
              ...(l.overrideSrc ? { overrideSrc: l.overrideSrc } : {}),
              ...(l.loader ? { loader: l.loader } : {}),
              ...(l.width && l.height ? { width: l.width, height: l.height } : {}),
            }),
          }),
        t === "year" &&
          l &&
          /* @__PURE__ */ r("div", {
            className: K["card__year-image"],
            children: /* @__PURE__ */ r(d, {
              src: l.src,
              alt: l.alt,
              width: 100,
              height: 100,
              ...(l.overrideSrc ? { overrideSrc: l.overrideSrc } : {}),
              ...(l.loader ? { loader: l.loader } : {}),
            }),
          }),
        t === "year" &&
          c &&
          !l &&
          /* @__PURE__ */ r("div", { className: K.card__year, children: c }),
        /* @__PURE__ */ f("div", {
          className: K.card__copy,
          children: [
            /* @__PURE__ */ f("div", {
              className: K["card__title-description"],
              children: [/* @__PURE__ */ r(p1, { html: a }), /* @__PURE__ */ r(g, { children: n })],
            }),
            i &&
              /* @__PURE__ */ r("a", {
                className: K.card__link,
                href: i,
                children: t === "3-up" ? /* @__PURE__ */ r(j2, { children: o }) : o,
              }),
          ],
        }),
      ],
    });
  },
  ze = ({
    type: t,
    size: a,
    viewMoreCta: n,
    cards: i,
    ref: o,
    id: c,
    onScrollChange: l,
    onCardVisible: s,
  }) => {
    const d = C1(null),
      [g, v] = X(!1);
    v1(() => {
      const y = new IntersectionObserver(
        (E) => {
          E.forEach((b) => {
            if (b.isIntersecting) {
              const A = Array.from(d.current.children).indexOf(b.target);
              s == null || s(A);
            }
          });
        },
        {
          threshold: 1,
          // Trigger when the card is fully visible
        },
      );
      if (d.current && o) {
        o.current = d.current;
        const E = d.current.scrollWidth - d.current.scrollLeft <= d.current.clientWidth + 1;
        (v(E),
          l == null || l(d.current.scrollLeft === 0, E),
          d.current.querySelectorAll(`.${K.card}`).forEach((b) => {
            y.observe(b);
          }));
      }
      return () => {
        y.disconnect();
      };
    }, [d.current, v]);
    let h = [i];
    if (t === "blog") {
      let y = i.length / (a === "mobile" ? 3 : a === "tablet" ? 4 : 6);
      (i.length % (a === "mobile" ? 3 : a === "tablet" ? 4 : 6) !== 0 && (y += 1),
        (h = Array.from({ length: y }, (E, b) => {
          const A = b * (a === "mobile" ? 3 : a === "tablet" ? 4 : 6),
            L = A + (a === "mobile" ? 3 : a === "tablet" ? 4 : 6);
          return i.slice(A, L);
        })));
    }
    const V = (y) => {
      const E = y.target,
        b = E.scrollWidth - E.scrollLeft <= E.clientWidth + 1;
      (v(b), l == null || l(E.scrollLeft === 0, b));
    };
    return /* @__PURE__ */ f("div", {
      className: F(K.cards, {
        [K[`cards--${t}`]]: t,
        [K["cards--is-at-end"]]: g,
        [K["cards--scrollable"]]: t === "year",
      }),
      id: c,
      children: [
        h.map((y, E) =>
          /* @__PURE__ */ r(
            "div",
            {
              className: K.cards__grid,
              onScrollEnd: V,
              ref: d,
              tabIndex: t === "year" ? 0 : void 0,
              children: y.map((b, A) =>
                t === "year"
                  ? /* @__PURE__ */ r(
                      i2,
                      {
                        title: b.title,
                        description: b.description,
                        type: t,
                        year: b.year,
                        image: b.image,
                        link: b.link,
                        linkText: b.linkText,
                      },
                      `card-${A}`,
                    )
                  : /* @__PURE__ */ r(
                      i2,
                      {
                        title: b.title,
                        description: b.description,
                        type: t,
                        image: b.image ?? { src: "", alt: "" },
                        link: b.link ?? "",
                        linkText: b.linkText ?? "",
                        backgroundColor: b.backgroundColor ?? "default",
                      },
                      `card-${A}`,
                    ),
              ),
            },
            `grid__${E}`,
          ),
        ),
        n &&
          /* @__PURE__ */ r("div", {
            className: K.cards__load,
            children: /* @__PURE__ */ r(O2, {
              icon: /* @__PURE__ */ r(N, { name: w.GenericPlus }),
              iconPosition: "end",
              text: n.text,
              onClick: n.onClick,
            }),
          }),
      ],
    });
  },
  a1 = {
    "carousel-quotes": "carousel-quotes__q8uPW",
    "carousel-quotes__content": "carousel-quotes__content__7-kmk",
    "carousel-quotes__copy": "carousel-quotes__copy__J-Qxh",
    "carousel-quotes--image-start": "carousel-quotes--image-start__2hVIO",
    "carousel-quotes__link": "carousel-quotes__link__9E7AY",
    "carousel-quotes__image": "carousel-quotes__image__GRDGs",
    "carousel-quotes__arrows": "carousel-quotes__arrows__Fpqvk",
    "carousel-quotes__arrows--mobile": "carousel-quotes__arrows--mobile__fPhx2",
    "carousel-quotes__dots": "carousel-quotes__dots__FXT2g",
  },
  Ye = "quote__JIDmV",
  Ke = "quote__text__mI3fx",
  L1 = {
    quote: Ye,
    quote__text: Ke,
  },
  Ue = ({
    text: t,
    author: a,
    isQuoteTypography: n,
    isAuthorSubdued: i,
    isSpeechmarkIncludedInText: o = !1,
  }) =>
    /* @__PURE__ */ f("div", {
      className: L1.quote,
      children: [
        n
          ? /* @__PURE__ */ r("div", {
              className: L1.quote__text,
              children: o
                ? /* @__PURE__ */ r(l2, { html: t })
                : /* @__PURE__ */ f(l2, {
                    ...(o ? { html: t } : {}),
                    children: ['"', /* @__PURE__ */ r("br", {}), t],
                  }),
            })
          : o
            ? /* @__PURE__ */ r("blockquote", {
                className: L1.quote__text,
                dangerouslySetInnerHTML: { __html: t },
              })
            : /* @__PURE__ */ f("blockquote", {
                className: L1.quote__text,
                children: ['"', /* @__PURE__ */ r("br", {}), t],
              }),
        a && /* @__PURE__ */ r(n1, { isSubdued: i, children: a }),
      ],
    }),
  M1 = {
    "header-1": "header-1__CXG1q",
    "is-responsive": "is-responsive__KL-nz",
    "header-2": "header-2__bnfCQ",
    "header-3": "header-3__jq0i0",
    "p-1": "p-1__-OTvg",
    "p-2": "p-2__ewprj",
    "p-3": "p-3__T3w9e",
    "action-small": "action-small__0zjGq",
    "action-medium": "action-medium__ZaCjT",
    "action-large": "action-large__YfBZD",
    "is-inherited": "is-inherited__Qxhie",
    "is-italic": "is-italic__O6pmv",
    "formatted-text": "formatted-text__IBI-d",
    "is-one-line": "is-one-line__x1YE3",
    "pagination-dots": "pagination-dots__N0Lmf",
    "pagination-dots--simple": "pagination-dots--simple__8R0wC",
    "pagination-dots--exploration": "pagination-dots--exploration__7Y2Dk",
    "pagination-dots--color-default": "pagination-dots--color-default__gdp5L",
    "pagination-dots__dot--active": "pagination-dots__dot--active__gMnbr",
    "pagination-dots--color-inverse": "pagination-dots--color-inverse__hI1Iv",
    "pagination-dots__dot": "pagination-dots__dot__eXYWe",
  },
  V2 = ({ type: t = "simple", color: a, children: n }) => {
    const i = F({
      [M1["pagination-dots"]]: !0,
      [M1[`pagination-dots--${t}`]]: !0,
      [M1[`pagination-dots--color-${a}`]]: !0,
    });
    return /* @__PURE__ */ r("div", { className: i, children: n });
  },
  b2 = ({ isActive: t, style: a }) => {
    const n = F({
      [M1["pagination-dots__dot"]]: !0,
      [M1["pagination-dots__dot--active"]]: t,
    });
    return /* @__PURE__ */ r("div", { className: n, style: a });
  },
  E2 = (t) => new Array(t).fill(null),
  Je = ({ pageCount: t, pageActive: a, color: n }) =>
    /* @__PURE__ */ r(V2, {
      pageCount: t,
      pageActive: a,
      color: n,
      children: E2(t).map((i, o) => {
        const c = o + 1;
        return /* @__PURE__ */ r(b2, { isActive: a === c }, o);
      }),
    }),
  Xe = ({ pageCount: t, pageActive: a, color: n }) => {
    const s = [1, 0.5, 0.25, 0],
      { pageActiveRangeStart: d, pageActiveRangeEnd: g } = e3({
        pageCount: t,
        pageActive: a,
      });
    return /* @__PURE__ */ r(V2, {
      pageCount: t,
      pageActive: a,
      color: n,
      type: "exploration",
      children: E2(t).map((v, h) => {
        const V = h + 1,
          y = $e({
            pageNumber: V,
            pageActiveRangeStart: d,
            pageActiveRangeEnd: g,
            tokenDotSize: 8,
            tokenDotGap: 8,
            tokenScalingFactors: s,
          });
        return /* @__PURE__ */ r(b2, { isActive: a === V, style: y }, h);
      }),
    });
  },
  w2 = ({ type: t = "simple", pageCount: a, pageActive: n, color: i = "default" }) => {
    switch (t) {
      case "exploration":
        return /* @__PURE__ */ r(Xe, { pageCount: a, pageActive: n, color: i });
      case "simple":
      default:
        return /* @__PURE__ */ r(Je, { pageCount: a, pageActive: n, color: i });
    }
  };
function $e({
  pageNumber: t,
  pageActiveRangeStart: a,
  pageActiveRangeEnd: n,
  tokenDotSize: i,
  tokenDotGap: o,
  tokenScalingFactors: c,
}) {
  if (t < a - 3 || t > n + 3) return { display: "none" };
  const l = c,
    s = a + 1,
    d = (t - s) * (i + o);
  let g;
  return (
    t < a ? (g = l[a - t]) : t > n ? (g = l[t - n]) : (g = l[0]),
    {
      // we apply a "translate3d" instead of a simple "translateX" because we want to force
      // the GPU rendering of the dots animation, to have a smooth transition between stats and avoid junk rendering
      transform: `translate3d(${d}px, 0px, 0px) scale(${g})`,
      // React doesn't auto-prefix and we need compatibility with older Chrome versions: https://caniuse.com/#search=transform
      WebkitTransform: `translate3d(${d}px, 0px, 0px) scale(${g})`,
    }
  );
}
function e3(t) {
  const a = Math.min(t.pageCount, 3),
    n = Math.max(t.pageActive - a + 1, 1),
    i = n + a - 1,
    o = {
      pageCount: t.pageCount,
      pageActive: t.pageActive || 1,
      // for this calculations, see: https://docs.google.com/spreadsheets/d/1dSD85ED-qATvN3AF4oe37s74f9x3BlszMsEeEpOb00M/edit#gid=1728387463
      pageActiveRangeStart: n,
      pageActiveRangeEnd: i,
    },
    c = C1(o);
  let l = "none";
  return (
    t.pageCount < c.current.pageCount && (l = "removeActivePage"),
    t.pageActive > c.current.pageActive && (l = "moveForwards"),
    t.pageActive < c.current.pageActive && (l = "moveBackwards"),
    (c.current = [l].reduce((s, d) => {
      switch (d) {
        case "none":
          return s;
        case "moveBackwards":
          return s.pageActive === 1
            ? s
            : s.pageActive === s.pageActiveRangeStart
              ? {
                  ...s,
                  pageActive: s.pageActive - 1,
                  pageActiveRangeStart: s.pageActiveRangeStart - 1,
                  pageActiveRangeEnd: s.pageActiveRangeEnd - 1,
                }
              : {
                  ...s,
                  pageActive: s.pageActive - 1,
                };
        case "moveForwards":
          return s.pageActive === s.pageCount
            ? s
            : s.pageActive === s.pageActiveRangeEnd
              ? {
                  ...s,
                  pageActive: s.pageActive + 1,
                  pageActiveRangeStart: s.pageActiveRangeStart + 1,
                  pageActiveRangeEnd: s.pageActiveRangeEnd + 1,
                }
              : {
                  ...s,
                  pageActive: s.pageActive + 1,
                };
        case "removeActivePage":
          return s.pageActive === s.pageCount
            ? {
                ...s,
                pageCount: s.pageCount - 1,
                pageActive: s.pageActive - 1,
                pageActiveRangeStart: s.pageActiveRangeStart - 1,
                pageActiveRangeEnd: s.pageActiveRangeEnd - 1,
              }
            : s.pageActiveRangeEnd === s.pageCount
              ? {
                  ...s,
                  pageCount: s.pageCount - 1,
                  pageActiveRangeStart: s.pageActiveRangeStart - 1,
                  pageActiveRangeEnd: s.pageActiveRangeEnd - 1,
                }
              : {
                  ...s,
                  pageCount: s.pageCount - 1,
                };
      }
    }, c.current)),
    c.current
  );
}
const k4 = ({ badgeText: t, quotes: a, linkText: n, imagePosition: i = "end" }) => {
    const o = H1(),
      [c, l] = X(0),
      {
        quote: s,
        author: d,
        link: g,
        imageSrc: v,
        imageAlt: h,
        imageWidth: V,
        imageHeight: y,
        isSpeechmarkIncludedInText: E,
      } = a[c],
      b = () => {
        l((L) => (L > 0 ? L - 1 : 0));
      },
      A = () => {
        l((L) => (L < a.length - 1 ? L + 1 : a.length - 1));
      };
    return /* @__PURE__ */ r("section", {
      className: F(a1["carousel-quotes"], { [a1["carousel-quotes--image-start"]]: i === "start" }),
      children: /* @__PURE__ */ f("div", {
        className: a1["carousel-quotes__content"],
        children: [
          /* @__PURE__ */ f("div", {
            className: a1["carousel-quotes__copy"],
            children: [
              t && /* @__PURE__ */ r(K2, { text: t }),
              /* @__PURE__ */ r("div", {
                className: a1["carousel-quotes__quote"],
                children: /* @__PURE__ */ r(Ue, {
                  text: s,
                  author: d,
                  isQuoteTypography: !0,
                  isSpeechmarkIncludedInText: E,
                }),
              }),
              a.length > 1
                ? /* @__PURE__ */ r("a", {
                    className: a1["carousel-quotes__link"],
                    href: g,
                    children: n,
                  })
                : /* @__PURE__ */ r(U, { href: g, text: n }),
              a.length > 1
                ? /* @__PURE__ */ f("div", {
                    className: a1["carousel-quotes__arrows"],
                    children: [
                      /* @__PURE__ */ r(U, {
                        designType: "circle",
                        icon: w.ArrowLeft,
                        isDisabled: c === 0,
                        onClick: b,
                      }),
                      /* @__PURE__ */ r(U, {
                        designType: "circle",
                        icon: w.ArrowRight,
                        onClick: A,
                        isDisabled: c === a.length - 1,
                      }),
                    ],
                  })
                : null,
            ],
          }),
          /* @__PURE__ */ r("div", {
            className: a1["carousel-quotes__image"],
            children:
              v &&
              /* @__PURE__ */ r(o, {
                src: v,
                alt: h || "",
                width: V,
                height: y,
                ...("fill" in o ? { fill: !0 } : {}),
              }),
          }),
          a.length > 1
            ? /* @__PURE__ */ f("div", {
                className: a1["carousel-quotes__arrows--mobile"],
                children: [
                  /* @__PURE__ */ r(U, {
                    designType: "circle",
                    icon: w.ArrowLeft,
                    isDisabled: c === 0,
                    onClick: b,
                  }),
                  /* @__PURE__ */ r("div", {
                    className: a1["carousel-quotes__dots"],
                    children: /* @__PURE__ */ r(w2, {
                      type: "exploration",
                      pageCount: a.length,
                      pageActive: c + 1,
                    }),
                  }),
                  /* @__PURE__ */ r(U, {
                    designType: "circle",
                    icon: w.ArrowRight,
                    onClick: A,
                    isDisabled: c === a.length - 1,
                  }),
                ],
              })
            : null,
        ],
      }),
    });
  },
  J = {
    "carousel-stacked-cards": "carousel-stacked-cards__vjqUb",
    "carousel-stacked-cards--yellow": "carousel-stacked-cards--yellow__5uWSi",
    "carousel-stacked-cards--rounded": "carousel-stacked-cards--rounded__Jlr2T",
    "carousel-stacked-cards__inner": "carousel-stacked-cards__inner__H8d1W",
    "carousel-stacked-cards--app-download": "carousel-stacked-cards--app-download__URUl3",
    "carousel-stacked-cards__copy": "carousel-stacked-cards__copy__z5i1w",
    "carousel-stacked-cards__cards": "carousel-stacked-cards__cards__EC4ue",
    "carousel-stacked-cards__cards-inner": "carousel-stacked-cards__cards-inner__uLZjI",
    "stacked-card": "stacked-card__V7RUE",
    "stacked-card__badge": "stacked-card__badge__CLJHy",
    "app-download": "app-download__6HDZf",
    "app-download__icon-circle": "app-download__icon-circle__i2S1y",
    "app-download__icon": "app-download__icon__F9wzG",
  },
  g1 = {
    "cta-box": "cta-box__D8MPe",
    "cta-box--center": "cta-box--center__YyUx-",
    "cta-box__copy": "cta-box__copy__pFKAM",
    "cta-box--stacked-cards": "cta-box--stacked-cards__75CoT",
    "cta-box--text-shadow": "cta-box--text-shadow__93jxR",
    "cta-box--text-shadow-inverse": "cta-box--text-shadow-inverse__Zq4vC",
  },
  R1 = ({
    title: t,
    description: a,
    cta: n,
    color: i = "default",
    align: o = "left",
    variant: c = "default",
    headerLevel: l = "h2",
    isTextShadow: s = !1,
    isHtml: d = !1,
  }) =>
    /* @__PURE__ */ f("div", {
      className: F(g1["cta-box"], {
        [g1["cta-box--center"]]: o === "center",
        [g1["cta-box--stacked-cards"]]: c === "stacked-cards",
        [g1["cta-box--text-shadow"]]: s && i !== "default",
        [g1["cta-box--text-shadow-inverse"]]: s && i === "default",
      }),
      children: [
        /* @__PURE__ */ f("div", {
          className: g1["cta-box__copy"],
          children: [
            /* @__PURE__ */ r(k1, { color: i, as: l, children: t }),
            a &&
              /* @__PURE__ */ r(n1, {
                color: i,
                ...(d ? { html: a } : {}),
                children: d ? null : a,
              }),
          ],
        }),
        n &&
          /* @__PURE__ */ r(U, {
            text: n.text,
            color: i !== "brand" ? i : "default",
            href: n.href,
            onClick: n.onClick,
          }),
      ],
    }),
  N4 = ({
    cards: t,
    title: a,
    description: n,
    cta: i,
    appDownloadTexts: o,
    background: c = "white",
    isRoundedCorners: l = !1,
  }) => {
    const s = H1();
    return /* @__PURE__ */ r("section", {
      className: F(J["carousel-stacked-cards"], {
        [J["carousel-stacked-cards--yellow"]]: c === "yellow",
        [J["carousel-stacked-cards--app-download"]]: !!o,
        [J["carousel-stacked-cards--rounded"]]: l,
      }),
      children: /* @__PURE__ */ f("div", {
        className: J["carousel-stacked-cards__inner"],
        children: [
          /* @__PURE__ */ f("div", {
            className: J["carousel-stacked-cards__copy"],
            children: [
              /* @__PURE__ */ r(R1, { title: a, description: n, cta: i, variant: "stacked-cards" }),
              o &&
                /* @__PURE__ */ f("div", {
                  className: J["app-download"],
                  children: [
                    /* @__PURE__ */ r("div", {
                      className: J["app-download__icon-circle"],
                      children: /* @__PURE__ */ r("div", {
                        className: J["app-download__icon"],
                        children: /* @__PURE__ */ r(N, { name: N.Name.Mail, size: "stretch" }),
                      }),
                    }),
                    /* @__PURE__ */ f("div", {
                      className: J["app-download__text"],
                      children: [
                        /* @__PURE__ */ r(f1, { children: o[0] }),
                        /* @__PURE__ */ r(X1, { children: o[1] }),
                        /* @__PURE__ */ r(f1, { children: o[2] }),
                      ],
                    }),
                  ],
                }),
            ],
          }),
          /* @__PURE__ */ r("div", {
            className: J["carousel-stacked-cards__cards"],
            children: /* @__PURE__ */ r("div", {
              className: J["carousel-stacked-cards__cards-inner"],
              children: t.map((d, g) =>
                /* @__PURE__ */ f(
                  "div",
                  {
                    className: J["stacked-card"],
                    children: [
                      /* @__PURE__ */ r(s, { src: d.imageSrc, alt: d.imageAlt }),
                      d.badgeText &&
                        /* @__PURE__ */ r("div", {
                          className: J["stacked-card__badge"],
                          children: d.badgeText,
                        }),
                    ],
                  },
                  g,
                ),
              ),
            }),
          }),
        ],
      }),
    });
  },
  c1 = {
    "carousel-year-cards": "carousel-year-cards__ztlC4",
    "carousel-year-cards__top": "carousel-year-cards__top__TRQAi",
    "carousel-year-cards__top--no-description": "carousel-year-cards__top--no-description__9HRq1",
    "carousel-year-cards__copy": "carousel-year-cards__copy__Y-zGR",
    "carousel-year-cards__scroll": "carousel-year-cards__scroll__5tAZe",
    "carousel-year-cards__cards": "carousel-year-cards__cards__RF-g2",
    "carousel-year-cards__arrows": "carousel-year-cards__arrows__x6jlm",
    "carousel-year-cards__dots": "carousel-year-cards__dots__mrixX",
  },
  L4 = ({
    title: t,
    description: a,
    cards: n,
    scrollText: i,
    a11yScrollRightText: o,
    a11yScrollLeftText: c,
  }) => {
    const [l, s] = X(!0),
      [d, g] = X(!1),
      [v, h] = X(0),
      V = C1(null),
      y = () => {
        var L;
        (L = V.current) == null ||
          L.scrollTo({
            left: V.current.scrollLeft - 300,
            behavior: "smooth",
          });
      },
      E = () => {
        var L;
        (L = V.current) == null ||
          L.scrollTo({
            left: V.current.scrollLeft + 300,
            behavior: "smooth",
          });
      },
      b = (L, q) => {
        (s(L), g(q));
      },
      A = (L) => {
        h(L);
      };
    return /* @__PURE__ */ f("section", {
      className: c1["carousel-year-cards"],
      children: [
        /* @__PURE__ */ f("div", {
          className: F(c1["carousel-year-cards__top"], {
            [c1["carousel-year-cards__top--no-description"]]: !a,
          }),
          children: [
            /* @__PURE__ */ f("div", {
              className: c1["carousel-year-cards__copy"],
              children: [
                /* @__PURE__ */ r(k1, { children: t }),
                a && /* @__PURE__ */ r(n1, { children: a }),
              ],
            }),
            /* @__PURE__ */ f("div", {
              className: c1["carousel-year-cards__scroll"],
              children: [
                /* @__PURE__ */ r(G1, { id: "scroll-text", children: i }),
                /* @__PURE__ */ r(U, {
                  designType: "circle",
                  icon: N.Name.ArrowRight,
                  onClick: E,
                  isDisabled: d,
                  ariaLabelledBy: "scroll-text",
                  ariaControls: "card-years",
                }),
              ],
            }),
          ],
        }),
        /* @__PURE__ */ r("div", {
          className: c1["carousel-year-cards__cards"],
          children: /* @__PURE__ */ r(ze, {
            type: "year",
            cards: n,
            size: "desktop",
            ref: V,
            id: "card-years",
            onScrollChange: b,
            onCardVisible: A,
          }),
        }),
        /* @__PURE__ */ f("div", {
          className: c1["carousel-year-cards__arrows"],
          children: [
            /* @__PURE__ */ r(U, {
              designType: "circle",
              icon: N.Name.ArrowLeft,
              isDisabled: l,
              ariaLabel: c,
              ariaControls: "card-years",
              onClick: y,
            }),
            /* @__PURE__ */ r("div", {
              className: c1["carousel-year-cards__dots"],
              children: /* @__PURE__ */ r(w2, {
                type: "exploration",
                pageCount: n.length,
                pageActive: v + 1,
              }),
            }),
            /* @__PURE__ */ r(U, {
              designType: "circle",
              icon: N.Name.ArrowRight,
              isDisabled: d,
              ariaLabel: o,
              ariaControls: "card-years",
              onClick: E,
            }),
          ],
        }),
      ],
    });
  },
  s1 = {
    "cta-image-box-wrapper": "cta-image-box-wrapper__YhdBO",
    "cta-image-box": "cta-image-box__Ylbur",
    "cta-image-box--background-yellow": "cta-image-box--background-yellow__nrwSO",
    "cta-content": "cta-content__u7938",
    "cta-image-box--image-start": "cta-image-box--image-start__k-ryD",
    "cta-image": "cta-image__y1CEU",
    "cta-image__overlay": "cta-image__overlay__Qscst",
  },
  I4 = ({
    image: t,
    imagePosition: a,
    title: n,
    description: i,
    cta: o,
    background: c = "default",
    isHtml: l = !1,
    imageOverlay: s,
  }) => {
    const d = H1();
    return /* @__PURE__ */ r("section", {
      className: s1["cta-image-box-wrapper"],
      children: /* @__PURE__ */ f("div", {
        className: F(s1["cta-image-box"], {
          [s1["cta-image-box--image-start"]]: a === "start",
          [s1["cta-image-box--background-yellow"]]: c === "yellow",
        }),
        children: [
          /* @__PURE__ */ r("div", {
            className: s1["cta-content"],
            children: /* @__PURE__ */ r(R1, {
              title: n,
              description: i,
              cta: o,
              align: "left",
              isHtml: l,
            }),
          }),
          /* @__PURE__ */ f("div", {
            className: s1["cta-image"],
            children: [
              /* @__PURE__ */ r(d, { src: t.src, alt: t.alt, className: s1.image, style: t.style }),
              s && /* @__PURE__ */ r("div", { className: s1["cta-image__overlay"], children: s }),
            ],
          }),
        ],
      }),
    });
  },
  t3 = "dropdown__G8lk1",
  t1 = {
    dropdown: t3,
    "dropdown--header-style": "dropdown--header-style__Zzkao",
    "is-opened": "is-opened__wPOzQ",
    "dropdown-label__icon-flip": "dropdown-label__icon-flip__9tE96",
    "direction-top": "direction-top__isge6",
    "dropdown-label": "dropdown-label__x3Gql",
    "dropdown-dropdown": "dropdown-dropdown__Zs-kr",
    "dropdown-dropdown--has-max-height": "dropdown-dropdown--has-max-height__ef8Oe",
    "dropdown-dropdown__list": "dropdown-dropdown__list__zh50b",
    "dropdown-dropdown__item": "dropdown-dropdown__item__JyA-R",
    "dropdown-dropdown__link": "dropdown-dropdown__link__9kkzr",
    "dropdown-label__icon-start": "dropdown-label__icon-start__Yjqw8",
  };
var I1 = { exports: {} };
/*!
 * tabbable 6.2.0
 * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
 */
var A2 = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])",
  ],
  D1 = /* @__PURE__ */ A2.join(","),
  M2 = typeof Element > "u",
  _1 = M2
    ? function () {}
    : Element.prototype.matches ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector,
  B1 =
    !M2 && Element.prototype.getRootNode
      ? function (t) {
          var a;
          return t == null || (a = t.getRootNode) === null || a === void 0 ? void 0 : a.call(t);
        }
      : function (t) {
          return t == null ? void 0 : t.ownerDocument;
        },
  O1 = function t(a, n) {
    var i;
    n === void 0 && (n = !0);
    var o =
        a == null || (i = a.getAttribute) === null || i === void 0 ? void 0 : i.call(a, "inert"),
      c = o === "" || o === "true",
      l = c || (n && a && t(a.parentNode));
    return l;
  },
  a3 = function (a) {
    var n,
      i =
        a == null || (n = a.getAttribute) === null || n === void 0
          ? void 0
          : n.call(a, "contenteditable");
    return i === "" || i === "true";
  },
  Z2 = function (a, n, i) {
    if (O1(a)) return [];
    var o = Array.prototype.slice.apply(a.querySelectorAll(D1));
    return (n && _1.call(a, D1) && o.unshift(a), (o = o.filter(i)), o);
  },
  y2 = function t(a, n, i) {
    for (var o = [], c = Array.from(a); c.length; ) {
      var l = c.shift();
      if (!O1(l, !1))
        if (l.tagName === "SLOT") {
          var s = l.assignedElements(),
            d = s.length ? s : l.children,
            g = t(d, !0, i);
          i.flatten
            ? o.push.apply(o, g)
            : o.push({
                scopeParent: l,
                candidates: g,
              });
        } else {
          var v = _1.call(l, D1);
          v && i.filter(l) && (n || !a.includes(l)) && o.push(l);
          var h =
              l.shadowRoot || // check for an undisclosed shadow
              (typeof i.getShadowRoot == "function" && i.getShadowRoot(l)),
            V = !O1(h, !1) && (!i.shadowRootFilter || i.shadowRootFilter(l));
          if (h && V) {
            var y = t(h === !0 ? l.children : h.children, !0, i);
            i.flatten
              ? o.push.apply(o, y)
              : o.push({
                  scopeParent: l,
                  candidates: y,
                });
          } else c.unshift.apply(c, l.children);
        }
    }
    return o;
  },
  k2 = function (a) {
    return !isNaN(parseInt(a.getAttribute("tabindex"), 10));
  },
  u1 = function (a) {
    if (!a) throw new Error("No node provided");
    return a.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(a.tagName) || a3(a)) && !k2(a)
      ? 0
      : a.tabIndex;
  },
  r3 = function (a, n) {
    var i = u1(a);
    return i < 0 && n && !k2(a) ? 0 : i;
  },
  n3 = function (a, n) {
    return a.tabIndex === n.tabIndex ? a.documentOrder - n.documentOrder : a.tabIndex - n.tabIndex;
  },
  N2 = function (a) {
    return a.tagName === "INPUT";
  },
  l3 = function (a) {
    return N2(a) && a.type === "hidden";
  },
  i3 = function (a) {
    var n =
      a.tagName === "DETAILS" &&
      Array.prototype.slice.apply(a.children).some(function (i) {
        return i.tagName === "SUMMARY";
      });
    return n;
  },
  o3 = function (a, n) {
    for (var i = 0; i < a.length; i++) if (a[i].checked && a[i].form === n) return a[i];
  },
  c3 = function (a) {
    if (!a.name) return !0;
    var n = a.form || B1(a),
      i = function (s) {
        return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
      },
      o;
    if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
      o = i(window.CSS.escape(a.name));
    else
      try {
        o = i(a.name);
      } catch (l) {
        return (
          console.error(
            "Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",
            l.message,
          ),
          !1
        );
      }
    var c = o3(o, a.form);
    return !c || c === a;
  },
  s3 = function (a) {
    return N2(a) && a.type === "radio";
  },
  d3 = function (a) {
    return s3(a) && !c3(a);
  },
  u3 = function (a) {
    var n,
      i = a && B1(a),
      o = (n = i) === null || n === void 0 ? void 0 : n.host,
      c = !1;
    if (i && i !== a) {
      var l, s, d;
      for (
        c = !!(
          ((l = o) !== null &&
            l !== void 0 &&
            (s = l.ownerDocument) !== null &&
            s !== void 0 &&
            s.contains(o)) ||
          (a != null && (d = a.ownerDocument) !== null && d !== void 0 && d.contains(a))
        );
        !c && o;
      ) {
        var g, v, h;
        ((i = B1(o)),
          (o = (g = i) === null || g === void 0 ? void 0 : g.host),
          (c = !!(
            (v = o) !== null &&
            v !== void 0 &&
            (h = v.ownerDocument) !== null &&
            h !== void 0 &&
            h.contains(o)
          )));
      }
    }
    return c;
  },
  o2 = function (a) {
    var n = a.getBoundingClientRect(),
      i = n.width,
      o = n.height;
    return i === 0 && o === 0;
  },
  C3 = function (a, n) {
    var i = n.displayCheck,
      o = n.getShadowRoot;
    if (getComputedStyle(a).visibility === "hidden") return !0;
    var c = _1.call(a, "details>summary:first-of-type"),
      l = c ? a.parentElement : a;
    if (_1.call(l, "details:not([open]) *")) return !0;
    if (!i || i === "full" || i === "legacy-full") {
      if (typeof o == "function") {
        for (var s = a; a; ) {
          var d = a.parentElement,
            g = B1(a);
          if (d && !d.shadowRoot && o(d) === !0) return o2(a);
          a.assignedSlot
            ? (a = a.assignedSlot)
            : !d && g !== a.ownerDocument
              ? (a = g.host)
              : (a = d);
        }
        a = s;
      }
      if (u3(a)) return !a.getClientRects().length;
      if (i !== "legacy-full") return !0;
    } else if (i === "non-zero-area") return o2(a);
    return !1;
  },
  h3 = function (a) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(a.tagName))
      for (var n = a.parentElement; n; ) {
        if (n.tagName === "FIELDSET" && n.disabled) {
          for (var i = 0; i < n.children.length; i++) {
            var o = n.children.item(i);
            if (o.tagName === "LEGEND")
              return _1.call(n, "fieldset[disabled] *") ? !0 : !o.contains(a);
          }
          return !0;
        }
        n = n.parentElement;
      }
    return !1;
  },
  P1 = function (a, n) {
    return !(
      n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
      //  because we're limited in the type of selectors we can use in JSDom (see related
      //  note related to `candidateSelectors`)
      O1(n) ||
      l3(n) ||
      C3(n, a) || // For a details element with a summary, the summary element gets the focus
      i3(n) ||
      h3(n)
    );
  },
  U1 = function (a, n) {
    return !(d3(n) || u1(n) < 0 || !P1(a, n));
  },
  m3 = function (a) {
    var n = parseInt(a.getAttribute("tabindex"), 10);
    return !!(isNaN(n) || n >= 0);
  },
  f3 = function t(a) {
    var n = [],
      i = [];
    return (
      a.forEach(function (o, c) {
        var l = !!o.scopeParent,
          s = l ? o.scopeParent : o,
          d = r3(s, l),
          g = l ? t(o.candidates) : s;
        d === 0
          ? l
            ? n.push.apply(n, g)
            : n.push(s)
          : i.push({
              documentOrder: c,
              tabIndex: d,
              item: o,
              isScope: l,
              content: g,
            });
      }),
      i
        .sort(n3)
        .reduce(function (o, c) {
          return (c.isScope ? o.push.apply(o, c.content) : o.push(c.content), o);
        }, [])
        .concat(n)
    );
  },
  L2 = function (a, n) {
    n = n || {};
    var i;
    return (
      n.getShadowRoot
        ? (i = y2([a], n.includeContainer, {
            filter: U1.bind(null, n),
            flatten: !1,
            getShadowRoot: n.getShadowRoot,
            shadowRootFilter: m3,
          }))
        : (i = Z2(a, n.includeContainer, U1.bind(null, n))),
      f3(i)
    );
  },
  I2 = function (a, n) {
    n = n || {};
    var i;
    return (
      n.getShadowRoot
        ? (i = y2([a], n.includeContainer, {
            filter: P1.bind(null, n),
            flatten: !0,
            getShadowRoot: n.getShadowRoot,
          }))
        : (i = Z2(a, n.includeContainer, P1.bind(null, n))),
      i
    );
  },
  m1 = function (a, n) {
    if (((n = n || {}), !a)) throw new Error("No node provided");
    return _1.call(a, D1) === !1 ? !1 : U1(n, a);
  },
  p3 = /* @__PURE__ */ A2.concat("iframe").join(","),
  S1 = function (a, n) {
    if (((n = n || {}), !a)) throw new Error("No node provided");
    return _1.call(a, p3) === !1 ? !1 : P1(n, a);
  };
const _3 = /* @__PURE__ */ Object.freeze(
  /* @__PURE__ */ Object.defineProperty(
    {
      __proto__: null,
      focusable: I2,
      getTabIndex: u1,
      isFocusable: S1,
      isTabbable: m1,
      tabbable: L2,
    },
    Symbol.toStringTag,
    { value: "Module" },
  ),
);
/*!
 * focus-trap 7.6.5
 * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
 */
function J1(t, a) {
  (a == null || a > t.length) && (a = t.length);
  for (var n = 0, i = Array(a); n < a; n++) i[n] = t[n];
  return i;
}
function g3(t) {
  if (Array.isArray(t)) return J1(t);
}
function v3(t, a, n) {
  return (
    (a = w3(a)) in t
      ? Object.defineProperty(t, a, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (t[a] = n),
    t
  );
}
function H3(t) {
  if ((typeof Symbol < "u" && t[Symbol.iterator] != null) || t["@@iterator"] != null)
    return Array.from(t);
}
function V3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c2(t, a) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    (a &&
      (i = i.filter(function (o) {
        return Object.getOwnPropertyDescriptor(t, o).enumerable;
      })),
      n.push.apply(n, i));
  }
  return n;
}
function s2(t) {
  for (var a = 1; a < arguments.length; a++) {
    var n = arguments[a] != null ? arguments[a] : {};
    a % 2
      ? c2(Object(n), !0).forEach(function (i) {
          v3(t, i, n[i]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
        : c2(Object(n)).forEach(function (i) {
            Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
          });
  }
  return t;
}
function b3(t) {
  return g3(t) || H3(t) || A3(t) || V3();
}
function E3(t, a) {
  if (typeof t != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, a);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (a === "string" ? String : Number)(t);
}
function w3(t) {
  var a = E3(t, "string");
  return typeof a == "symbol" ? a : a + "";
}
function A3(t, a) {
  if (t) {
    if (typeof t == "string") return J1(t, a);
    var n = {}.toString.call(t).slice(8, -1);
    return (
      n === "Object" && t.constructor && (n = t.constructor.name),
      n === "Map" || n === "Set"
        ? Array.from(t)
        : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          ? J1(t, a)
          : void 0
    );
  }
}
var d2 = {
    activateTrap: function (a, n) {
      if (a.length > 0) {
        var i = a[a.length - 1];
        i !== n && i._setPausedState(!0);
      }
      var o = a.indexOf(n);
      (o === -1 || a.splice(o, 1), a.push(n));
    },
    deactivateTrap: function (a, n) {
      var i = a.indexOf(n);
      (i !== -1 && a.splice(i, 1),
        a.length > 0 &&
          !a[a.length - 1]._isManuallyPaused() &&
          a[a.length - 1]._setPausedState(!1));
    },
  },
  M3 = function (a) {
    return a.tagName && a.tagName.toLowerCase() === "input" && typeof a.select == "function";
  },
  Z3 = function (a) {
    return (
      (a == null ? void 0 : a.key) === "Escape" ||
      (a == null ? void 0 : a.key) === "Esc" ||
      (a == null ? void 0 : a.keyCode) === 27
    );
  },
  Z1 = function (a) {
    return (a == null ? void 0 : a.key) === "Tab" || (a == null ? void 0 : a.keyCode) === 9;
  },
  y3 = function (a) {
    return Z1(a) && !a.shiftKey;
  },
  k3 = function (a) {
    return Z1(a) && a.shiftKey;
  },
  u2 = function (a) {
    return setTimeout(a, 0);
  },
  w1 = function (a) {
    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      i[o - 1] = arguments[o];
    return typeof a == "function" ? a.apply(void 0, i) : a;
  },
  x1 = function (a) {
    return a.target.shadowRoot && typeof a.composedPath == "function"
      ? a.composedPath()[0]
      : a.target;
  },
  N3 = [],
  L3 = function (a, n) {
    var i = (n == null ? void 0 : n.document) || document,
      o = (n == null ? void 0 : n.trapStack) || N3,
      c = s2(
        {
          returnFocusOnDeactivate: !0,
          escapeDeactivates: !0,
          delayInitialFocus: !0,
          isKeyForward: y3,
          isKeyBackward: k3,
        },
        n,
      ),
      l = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        manuallyPaused: !1,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: void 0,
      },
      s,
      d = function (u, C, p) {
        return u && u[C] !== void 0 ? u[C] : c[p || C];
      },
      g = function (u, C) {
        var p =
          typeof (C == null ? void 0 : C.composedPath) == "function" ? C.composedPath() : void 0;
        return l.containerGroups.findIndex(function (k) {
          var T = k.container,
            S = k.tabbableNodes;
          return (
            T.contains(u) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (p == null ? void 0 : p.includes(T)) ||
            S.find(function (x) {
              return x === u;
            })
          );
        });
      },
      v = function (u) {
        var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
          p = C.hasFallback,
          k = p === void 0 ? !1 : p,
          T = C.params,
          S = T === void 0 ? [] : T,
          x = c[u];
        if (
          (typeof x == "function" && (x = x.apply(void 0, b3(S))), x === !0 && (x = void 0), !x)
        ) {
          if (x === void 0 || x === !1) return x;
          throw new Error(
            "`".concat(u, "` was specified but was not a node, or did not return a node"),
          );
        }
        var O = x;
        if (typeof x == "string") {
          try {
            O = i.querySelector(x);
          } catch (Q) {
            throw new Error(
              "`".concat(u, '` appears to be an invalid selector; error="').concat(Q.message, '"'),
            );
          }
          if (!O && !k) throw new Error("`".concat(u, "` as selector refers to no known node"));
        }
        return O;
      },
      h = function () {
        var u = v("initialFocus", {
          hasFallback: !0,
        });
        if (u === !1) return !1;
        if (u === void 0 || (u && !S1(u, c.tabbableOptions)))
          if (g(i.activeElement) >= 0) u = i.activeElement;
          else {
            var C = l.tabbableGroups[0],
              p = C && C.firstTabbableNode;
            u = p || v("fallbackFocus");
          }
        else u === null && (u = v("fallbackFocus"));
        if (!u) throw new Error("Your focus-trap needs to have at least one focusable element");
        return u;
      },
      V = function () {
        if (
          ((l.containerGroups = l.containers.map(function (u) {
            var C = L2(u, c.tabbableOptions),
              p = I2(u, c.tabbableOptions),
              k = C.length > 0 ? C[0] : void 0,
              T = C.length > 0 ? C[C.length - 1] : void 0,
              S = p.find(function (Q) {
                return m1(Q);
              }),
              x = p
                .slice()
                .reverse()
                .find(function (Q) {
                  return m1(Q);
                }),
              O = !!C.find(function (Q) {
                return u1(Q) > 0;
              });
            return {
              container: u,
              tabbableNodes: C,
              focusableNodes: p,
              /** True if at least one node with positive `tabindex` was found in this container. */
              posTabIndexesFound: O,
              /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
              firstTabbableNode: k,
              /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
              lastTabbableNode: T,
              // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
              //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
              //  because that API doesn't work with Shadow DOM as well as it should (@see
              //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
              //  to address an edge case related to positive tabindex support, this seems like a much easier,
              //  "close enough most of the time" alternative for positive tabindexes which should generally
              //  be avoided anyway...
              /** First tabbable node in container, __DOM__ order; `undefined` if none. */
              firstDomTabbableNode: S,
              /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
              lastDomTabbableNode: x,
              /**
               * Finds the __tabbable__ node that follows the given node in the specified direction,
               *  in this container, if any.
               * @param {HTMLElement} node
               * @param {boolean} [forward] True if going in forward tab order; false if going
               *  in reverse.
               * @returns {HTMLElement|undefined} The next tabbable node, if any.
               */
              nextTabbableNode: function (h1) {
                var V1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
                  o1 = C.indexOf(h1);
                return o1 < 0
                  ? V1
                    ? p.slice(p.indexOf(h1) + 1).find(function (b1) {
                        return m1(b1);
                      })
                    : p
                        .slice(0, p.indexOf(h1))
                        .reverse()
                        .find(function (b1) {
                          return m1(b1);
                        })
                  : C[o1 + (V1 ? 1 : -1)];
              },
            };
          })),
          (l.tabbableGroups = l.containerGroups.filter(function (u) {
            return u.tabbableNodes.length > 0;
          })),
          l.tabbableGroups.length <= 0 && !v("fallbackFocus"))
        )
          throw new Error(
            "Your focus-trap must have at least one container with at least one tabbable node in it at all times",
          );
        if (
          l.containerGroups.find(function (u) {
            return u.posTabIndexesFound;
          }) &&
          l.containerGroups.length > 1
        )
          throw new Error(
            "At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.",
          );
      },
      y = function (u) {
        var C = u.activeElement;
        if (C) return C.shadowRoot && C.shadowRoot.activeElement !== null ? y(C.shadowRoot) : C;
      },
      E = function (u) {
        if (u !== !1 && u !== y(document)) {
          if (!u || !u.focus) {
            E(h());
            return;
          }
          (u.focus({
            preventScroll: !!c.preventScroll,
          }),
            (l.mostRecentlyFocusedNode = u),
            M3(u) && u.select());
        }
      },
      b = function (u) {
        var C = v("setReturnFocus", {
          params: [u],
        });
        return C || (C === !1 ? !1 : u);
      },
      A = function (u) {
        var C = u.target,
          p = u.event,
          k = u.isBackward,
          T = k === void 0 ? !1 : k;
        ((C = C || x1(p)), V());
        var S = null;
        if (l.tabbableGroups.length > 0) {
          var x = g(C, p),
            O = x >= 0 ? l.containerGroups[x] : void 0;
          if (x < 0)
            T
              ? (S = l.tabbableGroups[l.tabbableGroups.length - 1].lastTabbableNode)
              : (S = l.tabbableGroups[0].firstTabbableNode);
          else if (T) {
            var Q = l.tabbableGroups.findIndex(function (j1) {
              var W1 = j1.firstTabbableNode;
              return C === W1;
            });
            if (
              (Q < 0 &&
                (O.container === C ||
                  (S1(C, c.tabbableOptions) &&
                    !m1(C, c.tabbableOptions) &&
                    !O.nextTabbableNode(C, !1))) &&
                (Q = x),
              Q >= 0)
            ) {
              var h1 = Q === 0 ? l.tabbableGroups.length - 1 : Q - 1,
                V1 = l.tabbableGroups[h1];
              S = u1(C) >= 0 ? V1.lastTabbableNode : V1.lastDomTabbableNode;
            } else Z1(p) || (S = O.nextTabbableNode(C, !1));
          } else {
            var o1 = l.tabbableGroups.findIndex(function (j1) {
              var W1 = j1.lastTabbableNode;
              return C === W1;
            });
            if (
              (o1 < 0 &&
                (O.container === C ||
                  (S1(C, c.tabbableOptions) &&
                    !m1(C, c.tabbableOptions) &&
                    !O.nextTabbableNode(C))) &&
                (o1 = x),
              o1 >= 0)
            ) {
              var b1 = o1 === l.tabbableGroups.length - 1 ? 0 : o1 + 1,
                e2 = l.tabbableGroups[b1];
              S = u1(C) >= 0 ? e2.firstTabbableNode : e2.firstDomTabbableNode;
            } else Z1(p) || (S = O.nextTabbableNode(C));
          }
        } else S = v("fallbackFocus");
        return S;
      },
      L = function (u) {
        var C = x1(u);
        if (!(g(C, u) >= 0)) {
          if (w1(c.clickOutsideDeactivates, u)) {
            s.deactivate({
              // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
              //  which will result in the outside click setting focus to the node
              //  that was clicked (and if not focusable, to "nothing"); by setting
              //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
              //  on activation (or the configured `setReturnFocus` node), whether the
              //  outside click was on a focusable node or not
              returnFocus: c.returnFocusOnDeactivate,
            });
            return;
          }
          w1(c.allowOutsideClick, u) || u.preventDefault();
        }
      },
      q = function (u) {
        var C = x1(u),
          p = g(C, u) >= 0;
        if (p || C instanceof Document) p && (l.mostRecentlyFocusedNode = C);
        else {
          u.stopImmediatePropagation();
          var k,
            T = !0;
          if (l.mostRecentlyFocusedNode)
            if (u1(l.mostRecentlyFocusedNode) > 0) {
              var S = g(l.mostRecentlyFocusedNode),
                x = l.containerGroups[S].tabbableNodes;
              if (x.length > 0) {
                var O = x.findIndex(function (Q) {
                  return Q === l.mostRecentlyFocusedNode;
                });
                O >= 0 &&
                  (c.isKeyForward(l.recentNavEvent)
                    ? O + 1 < x.length && ((k = x[O + 1]), (T = !1))
                    : O - 1 >= 0 && ((k = x[O - 1]), (T = !1)));
              }
            } else
              l.containerGroups.some(function (Q) {
                return Q.tabbableNodes.some(function (h1) {
                  return u1(h1) > 0;
                });
              }) || (T = !1);
          else T = !1;
          (T &&
            (k = A({
              // move FROM the MRU node, not event-related node (which will be the node that is
              //  outside the trap causing the focus escape we're trying to fix)
              target: l.mostRecentlyFocusedNode,
              isBackward: c.isKeyBackward(l.recentNavEvent),
            })),
            E(k || l.mostRecentlyFocusedNode || h()));
        }
        l.recentNavEvent = void 0;
      },
      P = function (u) {
        var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        l.recentNavEvent = u;
        var p = A({
          event: u,
          isBackward: C,
        });
        p && (Z1(u) && u.preventDefault(), E(p));
      },
      D = function (u) {
        (c.isKeyForward(u) || c.isKeyBackward(u)) && P(u, c.isKeyBackward(u));
      },
      $ = function (u) {
        Z3(u) && w1(c.escapeDeactivates, u) !== !1 && (u.preventDefault(), s.deactivate());
      },
      e1 = function (u) {
        var C = x1(u);
        g(C, u) >= 0 ||
          w1(c.clickOutsideDeactivates, u) ||
          w1(c.allowOutsideClick, u) ||
          (u.preventDefault(), u.stopImmediatePropagation());
      },
      H = function () {
        if (l.active)
          return (
            d2.activateTrap(o, s),
            (l.delayInitialFocusTimer = c.delayInitialFocus
              ? u2(function () {
                  E(h());
                })
              : E(h())),
            i.addEventListener("focusin", q, !0),
            i.addEventListener("mousedown", L, {
              capture: !0,
              passive: !1,
            }),
            i.addEventListener("touchstart", L, {
              capture: !0,
              passive: !1,
            }),
            i.addEventListener("click", e1, {
              capture: !0,
              passive: !1,
            }),
            i.addEventListener("keydown", D, {
              capture: !0,
              passive: !1,
            }),
            i.addEventListener("keydown", $),
            s
          );
      },
      _ = function () {
        if (l.active)
          return (
            i.removeEventListener("focusin", q, !0),
            i.removeEventListener("mousedown", L, !0),
            i.removeEventListener("touchstart", L, !0),
            i.removeEventListener("click", e1, !0),
            i.removeEventListener("keydown", D, !0),
            i.removeEventListener("keydown", $),
            s
          );
      },
      Z = function (u) {
        var C = u.some(function (p) {
          var k = Array.from(p.removedNodes);
          return k.some(function (T) {
            return T === l.mostRecentlyFocusedNode;
          });
        });
        C && E(h());
      },
      m = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(Z) : void 0,
      I = function () {
        m &&
          (m.disconnect(),
          l.active &&
            !l.paused &&
            l.containers.map(function (u) {
              m.observe(u, {
                subtree: !0,
                childList: !0,
              });
            }));
      };
    return (
      (s = {
        get active() {
          return l.active;
        },
        get paused() {
          return l.paused;
        },
        activate: function (u) {
          if (l.active) return this;
          var C = d(u, "onActivate"),
            p = d(u, "onPostActivate"),
            k = d(u, "checkCanFocusTrap");
          (k || V(),
            (l.active = !0),
            (l.paused = !1),
            (l.nodeFocusedBeforeActivation = y(i)),
            C == null || C());
          var T = function () {
            (k && V(), H(), I(), p == null || p());
          };
          return k ? (k(l.containers.concat()).then(T, T), this) : (T(), this);
        },
        deactivate: function (u) {
          if (!l.active) return this;
          var C = s2(
            {
              onDeactivate: c.onDeactivate,
              onPostDeactivate: c.onPostDeactivate,
              checkCanReturnFocus: c.checkCanReturnFocus,
            },
            u,
          );
          (clearTimeout(l.delayInitialFocusTimer),
            (l.delayInitialFocusTimer = void 0),
            _(),
            (l.active = !1),
            (l.paused = !1),
            I(),
            d2.deactivateTrap(o, s));
          var p = d(C, "onDeactivate"),
            k = d(C, "onPostDeactivate"),
            T = d(C, "checkCanReturnFocus"),
            S = d(C, "returnFocus", "returnFocusOnDeactivate");
          p == null || p();
          var x = function () {
            u2(function () {
              (S && E(b(l.nodeFocusedBeforeActivation)), k == null || k());
            });
          };
          return S && T ? (T(b(l.nodeFocusedBeforeActivation)).then(x, x), this) : (x(), this);
        },
        pause: function (u) {
          return l.active ? ((l.manuallyPaused = !0), this._setPausedState(!0, u)) : this;
        },
        unpause: function (u) {
          return l.active
            ? ((l.manuallyPaused = !1),
              o[o.length - 1] !== this ? this : this._setPausedState(!1, u))
            : this;
        },
        updateContainerElements: function (u) {
          var C = [].concat(u).filter(Boolean);
          return (
            (l.containers = C.map(function (p) {
              return typeof p == "string" ? i.querySelector(p) : p;
            })),
            l.active && V(),
            I(),
            this
          );
        },
      }),
      Object.defineProperties(s, {
        _isManuallyPaused: {
          value: function () {
            return l.manuallyPaused;
          },
        },
        _setPausedState: {
          value: function (u, C) {
            if (l.paused === u) return this;
            if (((l.paused = u), u)) {
              var p = d(C, "onPause"),
                k = d(C, "onPostPause");
              (p == null || p(), _(), I(), k == null || k());
            } else {
              var T = d(C, "onUnpause"),
                S = d(C, "onPostUnpause");
              (T == null || T(), V(), H(), I(), S == null || S());
            }
            return this;
          },
        },
      }),
      s.updateContainerElements(a),
      s
    );
  };
const I3 = /* @__PURE__ */ Object.freeze(
    /* @__PURE__ */ Object.defineProperty(
      {
        __proto__: null,
        createFocusTrap: L3,
      },
      Symbol.toStringTag,
      { value: "Module" },
    ),
  ),
  x3 = /* @__PURE__ */ p2(I3),
  T3 = /* @__PURE__ */ p2(_3);
var C2;
function S3() {
  if (C2) return I1.exports;
  C2 = 1;
  function t(H) {
    "@babel/helpers - typeof";
    return (
      (t =
        typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
          ? function (_) {
              return typeof _;
            }
          : function (_) {
              return _ &&
                typeof Symbol == "function" &&
                _.constructor === Symbol &&
                _ !== Symbol.prototype
                ? "symbol"
                : typeof _;
            }),
      t(H)
    );
  }
  var a, n;
  function i(H, _) {
    if (!(H instanceof _)) throw new TypeError("Cannot call a class as a function");
  }
  function o(H, _) {
    for (var Z = 0; Z < _.length; Z++) {
      var m = _[Z];
      ((m.enumerable = m.enumerable || !1),
        (m.configurable = !0),
        "value" in m && (m.writable = !0),
        Object.defineProperty(H, E(m.key), m));
    }
  }
  function c(H, _, Z) {
    return (_ && o(H.prototype, _), Object.defineProperty(H, "prototype", { writable: !1 }), H);
  }
  function l(H, _, Z) {
    return (
      (_ = v(_)),
      s(H, g() ? Reflect.construct(_, Z || [], v(H).constructor) : _.apply(H, Z))
    );
  }
  function s(H, _) {
    if (_ && (t(_) == "object" || typeof _ == "function")) return _;
    if (_ !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return d(H);
  }
  function d(H) {
    if (H === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return H;
  }
  function g() {
    try {
      var H = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch {}
    return (g = function () {
      return !!H;
    })();
  }
  function v(H) {
    return (
      (v = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (_) {
            return _.__proto__ || Object.getPrototypeOf(_);
          }),
      v(H)
    );
  }
  function h(H, _) {
    if (typeof _ != "function" && _ !== null)
      throw new TypeError("Super expression must either be null or a function");
    ((H.prototype = Object.create(_ && _.prototype, {
      constructor: { value: H, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(H, "prototype", { writable: !1 }),
      _ && V(H, _));
  }
  function V(H, _) {
    return (
      (V = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (Z, m) {
            return ((Z.__proto__ = m), Z);
          }),
      V(H, _)
    );
  }
  function y(H, _, Z) {
    return (
      (_ = E(_)) in H
        ? Object.defineProperty(H, _, { value: Z, enumerable: !0, configurable: !0, writable: !0 })
        : (H[_] = Z),
      H
    );
  }
  function E(H) {
    var _ = b(H, "string");
    return t(_) == "symbol" ? _ : _ + "";
  }
  function b(H, _) {
    if (t(H) != "object" || !H) return H;
    var Z = H[Symbol.toPrimitive];
    if (Z !== void 0) {
      var m = Z.call(H, _);
      if (t(m) != "object") return m;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (_ === "string" ? String : Number)(H);
  }
  var A = r1,
    L = x3,
    q = L.createFocusTrap,
    P = T3,
    D = P.isFocusable,
    $ = parseInt(
      (a = (n = /^(\d+)\./.exec(A.version)) === null || n === void 0 ? void 0 : n[1]) !== null &&
        a !== void 0
        ? a
        : 0,
      10,
    ),
    e1 = /* @__PURE__ */ (function (H) {
      function _(Z) {
        var m;
        (i(this, _),
          (m = l(this, _, [Z])),
          y(m, "getNodeForOption", function (u) {
            var C,
              p =
                (C = this.internalOptions[u]) !== null && C !== void 0
                  ? C
                  : this.originalOptions[u];
            if (typeof p == "function") {
              for (var k = arguments.length, T = new Array(k > 1 ? k - 1 : 0), S = 1; S < k; S++)
                T[S - 1] = arguments[S];
              p = p.apply(void 0, T);
            }
            if ((p === !0 && (p = void 0), !p)) {
              if (p === void 0 || p === !1) return p;
              throw new Error(
                "`".concat(u, "` was specified but was not a node, or did not return a node"),
              );
            }
            var x = p;
            if (typeof p == "string") {
              var O;
              if (
                ((x =
                  (O = this.getDocument()) === null || O === void 0 ? void 0 : O.querySelector(p)),
                !x)
              )
                throw new Error("`".concat(u, "` as selector refers to no known node"));
            }
            return x;
          }),
          (m.handleDeactivate = m.handleDeactivate.bind(m)),
          (m.handlePostDeactivate = m.handlePostDeactivate.bind(m)),
          (m.handleClickOutsideDeactivates = m.handleClickOutsideDeactivates.bind(m)),
          (m.internalOptions = {
            // We need to hijack the returnFocusOnDeactivate option,
            // because React can move focus into the element before we arrived at
            // this lifecycle hook (e.g. with autoFocus inputs). So the component
            // captures the previouslyFocusedElement in componentWillMount,
            // then (optionally) returns focus to it in componentWillUnmount.
            returnFocusOnDeactivate: !1,
            // the rest of these are also related to deactivation of the trap, and we
            //  need to use them and control them as well
            checkCanReturnFocus: null,
            onDeactivate: m.handleDeactivate,
            onPostDeactivate: m.handlePostDeactivate,
            // we need to special-case this setting as well so that we can know if we should
            //  NOT return focus if the trap gets auto-deactivated as the result of an
            //  outside click (otherwise, we'll always think we should return focus because
            //  of how we manage that flag internally here)
            clickOutsideDeactivates: m.handleClickOutsideDeactivates,
          }),
          (m.originalOptions = {
            // because of the above `internalOptions`, we maintain our own flag for
            //  this option, and default it to `true` because that's focus-trap's default
            returnFocusOnDeactivate: !0,
            // because of the above `internalOptions`, we keep these separate since
            //  they're part of the deactivation process which we configure (internally) to
            //  be shared between focus-trap and focus-trap-react
            onDeactivate: null,
            onPostDeactivate: null,
            checkCanReturnFocus: null,
            // the user's setting, defaulted to false since focus-trap defaults this to false
            clickOutsideDeactivates: !1,
          }));
        var I = Z.focusTrapOptions;
        for (var M in I)
          if (Object.prototype.hasOwnProperty.call(I, M)) {
            if (
              M === "returnFocusOnDeactivate" ||
              M === "onDeactivate" ||
              M === "onPostDeactivate" ||
              M === "checkCanReturnFocus" ||
              M === "clickOutsideDeactivates"
            ) {
              m.originalOptions[M] = I[M];
              continue;
            }
            m.internalOptions[M] = I[M];
          }
        return (
          (m.outsideClick = null),
          (m.focusTrapElements = Z.containerElements || []),
          m.updatePreviousElement(),
          m
        );
      }
      return (
        h(_, H),
        c(_, [
          {
            key: "getDocument",
            value: function () {
              return (
                this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0)
              );
            },
          },
          {
            key: "getReturnFocusNode",
            value: function () {
              var m = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
              return m || (m === !1 ? !1 : this.previouslyFocusedElement);
            },
            /** Update the previously focused element with the currently focused element. */
          },
          {
            key: "updatePreviousElement",
            value: function () {
              var m = this.getDocument();
              m && (this.previouslyFocusedElement = m.activeElement);
            },
          },
          {
            key: "deactivateTrap",
            value: function () {
              !this.focusTrap ||
                !this.focusTrap.active ||
                this.focusTrap.deactivate({
                  // NOTE: we never let the trap return the focus since we do that ourselves
                  returnFocus: !1,
                  // we'll call this in our own post deactivate handler so make sure the trap doesn't
                  //  do it prematurely
                  checkCanReturnFocus: null,
                  // let it call the user's original deactivate handler, if any, instead of
                  //  our own which calls back into this function
                  onDeactivate: this.originalOptions.onDeactivate,
                  // NOTE: for post deactivate, don't specify anything so that it calls the
                  //  onPostDeactivate handler specified on `this.internalOptions`
                  //  which will always be our own `handlePostDeactivate()` handler, which
                  //  will finish things off by calling the user's provided onPostDeactivate
                  //  handler, if any, at the right time
                  // onPostDeactivate: NOTHING
                });
            },
          },
          {
            key: "handleClickOutsideDeactivates",
            value: function (m) {
              var I =
                typeof this.originalOptions.clickOutsideDeactivates == "function"
                  ? this.originalOptions.clickOutsideDeactivates.call(null, m)
                  : this.originalOptions.clickOutsideDeactivates;
              return (
                I &&
                  (this.outsideClick = {
                    target: m.target,
                    allowDeactivation: I,
                  }),
                I
              );
            },
          },
          {
            key: "handleDeactivate",
            value: function () {
              (this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null),
                this.deactivateTrap());
            },
          },
          {
            key: "handlePostDeactivate",
            value: function () {
              var m = this,
                I = function () {
                  var u = m.getReturnFocusNode(),
                    C = !!(
                      // did the consumer allow it?
                      (
                        m.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
                        u !== null &&
                        u !== void 0 &&
                        u.focus && // was there an outside click that allowed deactivation?
                        (!m.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
                          (m.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
                            //  as a result of the click-through) -- in which case do NOT restore focus
                            //  to `returnFocusNode` because focus should remain on the outside node
                            !D(m.outsideClick.target, m.internalOptions.tabbableOptions)))
                      )
                    ),
                    p = m.internalOptions.preventScroll,
                    k = p === void 0 ? !1 : p;
                  (C &&
                    u.focus({
                      preventScroll: k,
                    }),
                    m.originalOptions.onPostDeactivate &&
                      m.originalOptions.onPostDeactivate.call(null),
                    (m.outsideClick = null));
                };
              this.originalOptions.checkCanReturnFocus
                ? this.originalOptions.checkCanReturnFocus
                    .call(null, this.getReturnFocusNode())
                    .then(I, I)
                : I();
            },
          },
          {
            key: "setupFocusTrap",
            value: function () {
              if (this.focusTrap)
                this.props.active &&
                  !this.focusTrap.active &&
                  (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
              else {
                var m = this.focusTrapElements.some(Boolean);
                m &&
                  ((this.focusTrap = this.props._createFocusTrap(
                    this.focusTrapElements,
                    this.internalOptions,
                  )),
                  this.props.active && this.focusTrap.activate(),
                  this.props.paused && this.focusTrap.pause());
              }
            },
          },
          {
            key: "componentDidMount",
            value: function () {
              this.props.active && this.setupFocusTrap();
            },
          },
          {
            key: "componentDidUpdate",
            value: function (m) {
              if (this.focusTrap) {
                m.containerElements !== this.props.containerElements &&
                  this.focusTrap.updateContainerElements(this.props.containerElements);
                var I = !m.active && this.props.active,
                  M = m.active && !this.props.active,
                  u = !m.paused && this.props.paused,
                  C = m.paused && !this.props.paused;
                if ((I && (this.updatePreviousElement(), this.focusTrap.activate()), M)) {
                  this.deactivateTrap();
                  return;
                }
                (u && this.focusTrap.pause(), C && this.focusTrap.unpause());
              } else
                (m.containerElements !== this.props.containerElements &&
                  (this.focusTrapElements = this.props.containerElements),
                  this.props.active && (this.updatePreviousElement(), this.setupFocusTrap()));
            },
          },
          {
            key: "componentWillUnmount",
            value: function () {
              this.deactivateTrap();
            },
          },
          {
            key: "render",
            value: function () {
              var m = this,
                I = this.props.children ? A.Children.only(this.props.children) : void 0;
              if (I) {
                if (I.type && I.type === A.Fragment)
                  throw new Error(
                    "A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.",
                  );
                var M = function (p) {
                    var k = m.props.containerElements;
                    (I &&
                      ($ >= 19
                        ? typeof I.props.ref == "function"
                          ? I.props.ref(p)
                          : I.props.ref && (I.props.ref.current = p)
                        : typeof I.ref == "function"
                          ? I.ref(p)
                          : I.ref && (I.ref.current = p)),
                      (m.focusTrapElements = k || [p]));
                  },
                  u = A.cloneElement(I, {
                    ref: M,
                  });
                return u;
              }
              return null;
            },
          },
        ])
      );
    })(A.Component);
  return (
    (e1.defaultProps = {
      active: !0,
      paused: !1,
      focusTrapOptions: {},
      _createFocusTrap: q,
    }),
    (I1.exports = e1),
    (I1.exports.FocusTrap = e1),
    I1.exports
  );
}
var x2 = S3();
const T2 = ({
    onChange: t,
    options: a,
    selectedValue: n,
    dropdownDirection: i = "down",
    hasMaxHeight: o,
    a11y: c,
    isIconOnly: l = !1,
    isHeaderStyle: s = !1,
  }) => {
    const [d, g] = X(() => (n ? a.find((D) => D.value === n) : a[0])),
      [v, h] = X(!1),
      [V, y] = X(i === "down"),
      E = C1(null),
      b = C1(null),
      A = C1(null);
    (v1(() => {
      if (n) {
        const D = a.find(($) => $.value === n);
        D && g(D);
      }
    }, [n, a]),
      v1(() => {
        y(i === "down");
      }, [i]));
    const L = (D) => {
        (g(D), h(!1), t && t(D.value));
      },
      q = () => {
        A.current && h(!v);
      },
      P = {
        block: F({
          [t1.dropdown]: !0,
          [t1["dropdown--header-style"]]: s,
          [t1["is-opened"]]: v,
          [t1["direction-top"]]: !V,
        }),
        dropdown: F({
          [t1["dropdown-dropdown"]]: !0,
          [t1["dropdown-dropdown--has-max-height"]]: o,
        }),
      };
    return /* @__PURE__ */ r(x2.FocusTrap, {
      focusTrapOptions: {
        escapeDeactivates: !0,
        onDeactivate: () => h(!1),
        initialFocus: !1,
        allowOutsideClick: !0,
      },
      active: v,
      children: /* @__PURE__ */ f("div", {
        ref: b,
        className: P.block,
        children: [
          /* @__PURE__ */ r("button", {
            onClick: q,
            className: t1["dropdown-label"],
            ref: A,
            "aria-expanded": !!v,
            type: "button",
            "data-testid": "dropdown-button",
            "aria-label": c == null ? void 0 : c.label,
            children: l
              ? /* @__PURE__ */ f(t2, {
                  children: [
                    /* @__PURE__ */ r("span", {
                      className: t1["dropdown-label__icon-start"],
                      children: /* @__PURE__ */ r(
                        N,
                        {
                          size: "stretch",
                          name: N.Name.GenericEthnicity,
                          color: "default",
                          a11yLabel: `${N.Name.GenericEthnicity} Icon`,
                          isInline: !1,
                        },
                        N.Name.GenericEthnicity,
                      ),
                    }),
                    /* @__PURE__ */ r("span", {
                      className: t1["dropdown-label__icon-flip"],
                      children: /* @__PURE__ */ r(
                        N,
                        {
                          size: "stretch",
                          name: N.Name.GenericChevronDown,
                          color: "default",
                          a11yLabel: `${N.Name.GenericChevronDown} Icon`,
                          isInline: !1,
                        },
                        N.Name.GenericChevronDown,
                      ),
                    }),
                  ],
                })
              : /* @__PURE__ */ f(t2, {
                  children: [
                    /* @__PURE__ */ r("span", {
                      className: t1["dropdown-label__icon-flip"],
                      children: /* @__PURE__ */ r(
                        N,
                        {
                          size: "md",
                          name: N.Name.GenericChevronDown,
                          color: "default",
                          a11yLabel: `${N.Name.GenericChevronDown} Icon`,
                          isInline: !1,
                        },
                        N.Name.GenericChevronDown,
                      ),
                    }),
                    /* @__PURE__ */ r(G1, { noWrap: !0, children: d == null ? void 0 : d.title }),
                  ],
                }),
          }),
          /* @__PURE__ */ r("div", {
            className: P.dropdown,
            ref: E,
            style: { display: v ? "block" : "none" },
            children: /* @__PURE__ */ r("ul", {
              className: t1["dropdown-dropdown__list"],
              role: "list",
              children:
                a == null
                  ? void 0
                  : a.map((D) => {
                      const $ = D.href ? "a" : "button";
                      return /* @__PURE__ */ r(
                        "li",
                        {
                          className: t1["dropdown-dropdown__item"],
                          children: /* @__PURE__ */ r($, {
                            "data-value": D.value,
                            href: D.href,
                            onClick: (e1) => {
                              (e1.preventDefault(), L(D));
                            },
                            className: t1["dropdown-dropdown__link"],
                            type: D.href ? void 0 : "button",
                            children: /* @__PURE__ */ r(f1, {
                              isSubdued: D.value !== (d == null ? void 0 : d.value),
                              children: D.title,
                            }),
                          }),
                        },
                        D.title,
                      );
                    }),
            }),
          }),
        ],
      }),
    });
  },
  F3 = "footer__YIYIL",
  R3 = "footer__upper__f-cTS",
  D3 = "footer__lower__uhTla",
  B3 = "footer__links__ZorwW",
  O3 = "footer__qr__TDMZX",
  P3 = "footer__social__7CL3K",
  q3 = "footer__buttons__mYSJg",
  Q3 = "footer__language__ppwni",
  G = {
    footer: F3,
    footer__upper: R3,
    footer__lower: D3,
    "footer__lower-right": "footer__lower-right__deggm",
    footer__links: B3,
    footer__qr: O3,
    footer__social: P3,
    footer__buttons: q3,
    "footer__download-cta": "footer__download-cta__BniiW",
    footer__language: Q3,
    "link-group": "link-group__M9ZUU",
    "link-group__link-icon": "link-group__link-icon__6wSvj",
    "link-group--legal": "link-group--legal__AF-Py",
    "social-link-icon": "social-link-icon__i4U21",
  },
  G3 = "root__INDVg",
  j3 = "image__5GHdQ",
  q1 = {
    root: G3,
    "color-black": "color-black__OtUw3",
    "color-white": "color-white__pVanj",
    image: j3,
  },
  W3 = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      { viewBox: "0 0 1594 285", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t },
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_16632_270789)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M350.477 24.9199C350.477 19.7036 354.73 15.4922 359.943 15.4922H476.899C526.08 15.4922 555.967 39.4444 555.967 79.7157C555.967 106.563 539.198 127.979 512.962 133.794C546.838 140.326 563.247 161 563.247 194.763C563.247 240.849 530.452 269.515 477.981 269.515H359.919C354.682 269.515 350.453 265.28 350.453 260.087V24.9199H350.477ZM463.421 113.837C486.75 113.837 498.763 104.41 498.763 86.9899C498.763 69.5701 486.75 60.8602 463.421 60.8602H406.577V113.837H463.421ZM465.247 223.429C491.843 223.429 506.066 211.824 506.066 189.307C506.066 166.791 491.843 154.827 465.247 154.827H406.577V223.405H465.247V223.429Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M579.969 199.118V101.873C579.969 96.6567 584.222 92.4453 589.435 92.4453H624.777C630.014 92.4453 634.243 96.6806 634.243 101.873V180.621C634.243 212.565 645.895 228.525 668.119 228.525C691.448 228.525 703.46 212.565 703.46 180.621V101.873C703.46 96.6567 707.713 92.4453 712.927 92.4453H747.908C753.145 92.4453 757.374 96.6806 757.374 101.873V260.087C757.374 265.303 753.121 269.515 747.908 269.515H712.927C707.689 269.515 703.46 265.279 703.46 260.087V249.917C689.982 266.978 670.305 274.587 646.616 274.587C605.076 274.587 579.945 245.921 579.945 199.118H579.969Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M788.248 92.4219H823.589C828.827 92.4219 833.055 96.6572 833.055 101.85V113.096C846.534 95.3172 864.024 87.3252 888.434 87.3252C912.844 87.3252 933.242 97.8536 944.534 117.81C959.478 97.1358 980.596 87.3252 1008.3 87.3252C1048.37 87.3252 1075.33 115.991 1075.33 161.718V260.064C1075.33 265.28 1071.08 269.491 1065.86 269.491H1031.24C1026 269.491 1021.78 265.256 1021.78 260.064V180.957C1021.78 149.754 1012.31 133.411 989.702 133.411C967.094 133.411 954.36 151.549 954.36 180.957V260.064C954.36 265.28 950.108 269.491 944.894 269.491H909.913C904.676 269.491 900.447 265.256 900.447 260.064V180.957C900.447 149.754 890.981 133.411 868.373 133.411C845.765 133.411 833.031 151.549 833.031 181.316V260.064C833.031 265.28 828.779 269.491 823.565 269.491H788.224C782.986 269.491 778.758 265.256 778.758 260.064V101.85C778.758 96.6333 783.01 92.4219 788.224 92.4219H788.248Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M1149.59 248.099V260.087C1149.59 265.304 1145.34 269.515 1140.12 269.515H1105.86C1100.63 269.515 1096.4 265.28 1096.4 260.087V24.9199C1096.4 19.7036 1100.65 15.4922 1105.86 15.4922H1141.21C1146.44 15.4922 1150.67 19.7275 1150.67 24.9199V116.015C1163.07 98.9541 1185.65 87.3488 1212.25 87.3488C1262.53 87.3488 1299.7 126.543 1299.7 180.621C1299.7 234.699 1262.53 274.612 1207.52 274.612C1182.75 274.612 1160.88 264.442 1149.59 248.123V248.099ZM1246.51 180.597C1246.51 150.831 1227.94 131.975 1197.69 131.975C1167.44 131.975 1148.87 150.855 1148.87 180.597C1148.87 210.34 1167.44 230.32 1197.69 230.32C1227.94 230.32 1246.51 211.441 1246.51 180.597Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M1326.44 15.4922H1361.78C1367.02 15.4922 1371.25 19.7275 1371.25 24.9199V260.063C1371.25 265.28 1367 269.491 1361.78 269.491H1326.44C1321.21 269.491 1316.98 265.256 1316.98 260.063V24.9199C1316.98 19.7036 1321.23 15.4922 1326.44 15.4922Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M1388.64 180.957C1388.64 126.52 1429.46 87.3252 1487.39 87.3252C1545.31 87.3252 1582.12 125.419 1582.12 181.674C1582.12 186.891 1577.87 191.102 1572.65 191.102H1440.75C1441.86 197.994 1443.66 203.808 1446.59 208.522C1454.98 223.405 1470.28 230.297 1491.04 230.297C1508.72 230.297 1523.38 223.501 1534.57 210.101C1537.62 206.44 1542.96 205.651 1546.94 208.235L1568.04 221.826C1572.44 224.65 1573.76 230.536 1570.87 234.891C1554.8 258.963 1523.11 274.588 1489.96 274.588C1429.84 274.588 1388.66 238.672 1388.66 180.957H1388.64ZM1528.93 164.279C1528.93 144.681 1511.8 129.439 1487.75 129.439C1467.71 129.439 1453.13 136.689 1445.85 152.29C1444.02 155.928 1442.94 159.9 1441.83 164.255H1528.93V164.279Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M325.825 128.265L260.024 14.7404C254.974 6.02809 245.622 0.661133 235.521 0.661133H103.919C93.8185 0.661133 84.4666 6.02809 79.4162 14.7404L13.6394 128.265C8.58895 136.977 8.58895 147.711 13.6394 156.447L79.4404 269.948C84.4908 278.66 93.8426 284.027 103.944 284.027H235.545C245.646 284.027 254.998 278.66 260.049 269.948L325.85 156.447C330.9 147.735 330.9 137.001 325.85 128.265H325.825ZM110.589 75.3172C110.589 64.9443 119.022 56.569 129.437 56.569H207.49C217.905 56.569 226.339 64.9684 226.339 75.3172V78.3978C226.339 88.7707 217.905 97.1701 207.49 97.1701H129.437C119.022 97.1701 110.589 88.7707 110.589 78.3978V75.3172ZM206.258 209.371C206.258 219.744 197.824 228.143 187.409 228.143H149.47C139.055 228.143 130.622 219.744 130.622 209.371V206.29C130.622 195.917 139.055 187.542 149.47 187.542H187.409C197.824 187.542 206.258 195.941 206.258 206.29V209.371ZM266.67 143.884C266.67 154.257 258.236 162.657 247.821 162.657H89.058C78.6429 162.657 70.2335 154.257 70.2335 143.884V140.804C70.2335 130.431 78.6671 122.055 89.058 122.055H247.845C258.26 122.055 266.694 130.455 266.694 140.804V143.884H266.67Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_16632_270789" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 1594,
            height: 284,
            fill: "white",
            transform: "translate(0 0.654297)",
          }),
        ),
      ),
    ),
  z3 = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      { viewBox: "0 0 715 633", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t },
      /* @__PURE__ */ e.createElement("path", {
        d: "M705.565 284.984L558.72 31.6372C547.449 12.1945 526.579 0.217285 504.038 0.217285H210.348C187.807 0.217285 166.937 12.1945 155.666 31.6372L8.87502 284.984C-2.39584 304.427 -2.39584 328.381 8.87502 347.878L155.72 601.171C166.991 620.613 187.861 632.591 210.402 632.591H504.092C526.633 632.591 547.503 620.613 558.774 601.171L705.619 347.878C716.89 328.435 716.89 304.48 705.619 284.984H705.565ZM225.232 166.824C225.232 143.675 244.053 124.984 267.296 124.984H441.482C464.725 124.984 483.545 143.729 483.545 166.824V173.698C483.545 196.847 464.725 215.592 441.482 215.592H267.296C244.053 215.592 225.232 196.847 225.232 173.698V166.824ZM438.731 465.984C438.731 489.133 419.911 507.878 396.668 507.878H312.002C288.759 507.878 269.938 489.133 269.938 465.984V459.11C269.938 435.961 288.759 417.27 312.002 417.27H396.668C419.911 417.27 438.731 436.015 438.731 459.11V465.984ZM573.55 319.841C573.55 342.99 554.73 361.735 531.487 361.735H177.183C153.94 361.735 135.173 342.99 135.173 319.841V312.967C135.173 289.818 153.994 271.127 177.183 271.127H531.541C554.784 271.127 573.604 289.872 573.604 312.967V319.841H573.55Z",
        fill: "currentColor",
      }),
    ),
  Y3 = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        viewBox: "0 0 1363 287",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Bumble",
        ...t,
      },
      /* @__PURE__ */ e.createElement("title", null, "Bumble"),
      /* @__PURE__ */ e.createElement("path", {
        d: "M0.0265632 10.4295C0.0265632 4.65886 4.73085 0 10.4982 0H139.879C194.284 0 227.347 26.4973 227.347 71.0476C227.347 100.748 208.795 124.439 179.772 130.872C217.247 138.098 235.4 160.969 235.4 198.319C235.4 249.302 199.121 281.014 141.075 281.014H10.4717C4.67771 281.014 0 276.329 0 270.585V10.4295H0.0265632ZM124.969 108.795C150.776 108.795 164.065 98.3655 164.065 79.0948C164.065 59.824 150.776 50.1886 124.969 50.1886H62.0858V108.795H124.969ZM126.989 230.031C156.411 230.031 172.145 217.193 172.145 192.284C172.145 167.375 156.411 154.14 126.989 154.14H62.0858V230.005H126.989V230.031Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M253.894 203.137V95.5601C253.894 89.7895 258.598 85.1306 264.365 85.1306H303.461C309.255 85.1306 313.933 89.8159 313.933 95.5601V182.676C313.933 218.014 326.823 235.67 351.408 235.67C377.215 235.67 390.504 218.014 390.504 182.676V95.5601C390.504 89.7895 395.208 85.1306 400.976 85.1306H439.673C445.467 85.1306 450.145 89.8159 450.145 95.5601V270.585C450.145 276.356 445.44 281.015 439.673 281.015H400.976C395.182 281.015 390.504 276.329 390.504 270.585V259.335C375.594 278.209 353.826 286.626 327.621 286.626C281.668 286.626 253.867 254.914 253.867 203.137H253.894Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M484.287 85.1046H523.383C529.177 85.1046 533.855 89.7899 533.855 95.5341V107.975C548.765 88.3076 568.114 79.4663 595.117 79.4663C622.12 79.4663 644.685 91.1135 657.176 113.19C673.708 90.3193 697.07 79.4663 727.714 79.4663C772.046 79.4663 801.866 111.178 801.866 161.764V270.559C801.866 276.33 797.162 280.989 791.394 280.989H753.096C747.302 280.989 742.624 276.303 742.624 270.559V183.047C742.624 148.529 732.152 130.449 707.142 130.449C682.133 130.449 668.046 150.514 668.046 183.047V270.559C668.046 276.33 663.342 280.989 657.575 280.989H618.877C613.084 280.989 608.406 276.303 608.406 270.559V183.047C608.406 148.529 597.934 130.449 572.924 130.449C547.915 130.449 533.828 150.514 533.828 183.444V270.559C533.828 276.33 529.124 280.989 523.357 280.989H484.261C478.467 280.989 473.789 276.303 473.789 270.559V95.5341C473.789 89.7635 478.493 85.1046 484.261 85.1046H484.287Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M884 257.323V270.585C884 276.355 879.295 281.014 873.528 281.014H835.628C829.834 281.014 825.156 276.329 825.156 270.585V10.4295C825.156 4.65886 829.861 0 835.628 0H874.724C880.518 0 885.196 4.68533 885.196 10.4295V111.204C898.91 92.3302 923.893 79.4919 953.315 79.4919C1008.94 79.4919 1050.06 122.851 1050.06 182.675C1050.06 242.499 1008.94 286.652 948.079 286.652C920.677 286.652 896.491 275.402 884 257.349V257.323ZM991.215 182.649C991.215 149.719 970.67 128.86 937.208 128.86C903.747 128.86 883.202 149.745 883.202 182.649C883.202 215.552 903.747 237.655 937.208 237.655C970.67 237.655 991.215 216.77 991.215 182.649Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M1079.67 0H1118.77C1124.56 0 1129.24 4.68533 1129.24 10.4295V270.558C1129.24 276.329 1124.54 280.988 1118.77 280.988H1079.67C1073.88 280.988 1069.2 276.302 1069.2 270.558V10.4295C1069.2 4.65886 1073.91 0 1079.67 0Z",
        fill: "currentColor",
      }),
      /* @__PURE__ */ e.createElement("path", {
        d: "M1148.51 183.047C1148.51 122.826 1193.66 79.467 1257.74 79.467C1321.82 79.467 1362.54 121.609 1362.54 183.841C1362.54 189.612 1357.83 194.271 1352.07 194.271H1206.16C1207.38 201.895 1209.37 208.327 1212.61 213.542C1221.89 230.007 1238.82 237.63 1261.78 237.63C1281.34 237.63 1297.56 230.112 1309.94 215.289C1313.32 211.239 1319.22 210.365 1323.63 213.224L1346.96 228.259C1351.83 231.383 1353.29 237.895 1350.1 242.713C1332.32 269.342 1297.26 286.628 1260.59 286.628C1194.09 286.628 1148.53 246.895 1148.53 183.047H1148.51ZM1303.7 164.597C1303.7 142.918 1284.75 126.056 1258.14 126.056C1235.98 126.056 1219.84 134.076 1211.79 151.335C1209.77 155.359 1208.57 159.753 1207.35 164.571H1303.7V164.597Z",
        fill: "currentColor",
      }),
    ),
  K3 = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        viewBox: "0 0 804 293",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "BFF",
        ...t,
      },
      /* @__PURE__ */ e.createElement("title", null, "BFF"),
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_15056_179397)" },
        /* @__PURE__ */ e.createElement(
          "g",
          { clipPath: "url(#clip1_15056_179397)" },
          /* @__PURE__ */ e.createElement("path", {
            d: "M281.25 49.9797C281.25 45.5848 284.835 42 289.23 42H387.821C429.279 42 454.474 62.2732 454.474 96.359C454.474 119.083 440.337 137.209 418.221 142.131C446.778 147.66 460.61 165.158 460.61 193.735C460.61 232.742 432.965 257.006 388.733 257.006H289.23C284.815 257.006 281.25 253.421 281.25 249.026V49.9797ZM376.459 125.24C396.125 125.24 406.251 117.26 406.251 102.516C406.251 87.7717 396.125 80.3996 376.459 80.3996H328.541V125.24H376.459ZM377.998 217.998C400.418 217.998 412.408 208.176 412.408 189.118C412.408 170.06 400.439 159.933 377.998 159.933H328.541V217.978H377.998V217.998Z",
            fill: "currentColor",
          }),
          /* @__PURE__ */ e.createElement("path", {
            d: "M483.292 42H623.666C628.081 42 631.645 45.5848 631.645 49.9797V74.8503C631.645 79.2655 628.06 82.83 623.666 82.83H522.603V122.445H604.607C609.023 122.445 612.587 126.03 612.587 130.424V154.991C612.587 159.406 609.002 162.971 604.607 162.971H522.603V248.965C522.603 253.38 519.018 256.945 514.624 256.945H483.292C478.877 256.945 475.312 253.36 475.312 248.965V49.9797C475.312 45.5848 478.877 42 483.292 42Z",
            fill: "currentColor",
          }),
          /* @__PURE__ */ e.createElement("path", {
            d: "M654.894 42H795.267C799.682 42 803.247 45.5848 803.247 49.9797V74.8503C803.247 79.2655 799.662 82.83 795.267 82.83H694.205V122.445H776.209C780.624 122.445 784.189 126.03 784.189 130.424V154.991C784.189 159.406 780.604 162.971 776.209 162.971H694.205V248.965C694.205 253.38 690.62 256.945 686.225 256.945H654.894C650.479 256.945 646.914 253.36 646.914 248.965V49.9797C646.894 45.5848 650.479 42 654.894 42Z",
            fill: "currentColor",
          }),
        ),
        /* @__PURE__ */ e.createElement(
          "g",
          { clipPath: "url(#clip2_15056_179397)" },
          /* @__PURE__ */ e.createElement("path", {
            d: "M133.233 0.654277C165.828 1.30283 183.413 34.1265 174.268 63.4883C171.283 73.6535 167.153 82.0079 162.452 92.1445C161.839 93.4484 161.217 94.7593 160.591 96.0781C160.354 96.5777 160.718 97.1543 161.272 97.1543C161.519 97.1543 161.75 97.0324 161.891 96.8291C162.735 95.6087 163.573 94.3957 164.407 93.1933C170.558 84.4488 176.252 75.9708 183.451 68.5136C204.736 45.4935 243.1 45.2262 259.092 74.3398C274.836 102.891 255.191 134.532 225.19 141.293C214.892 143.791 205.594 144.392 194.466 145.394C192.187 145.584 189.878 145.775 187.552 145.966C187.469 145.973 187.396 145.995 187.334 146.027C187.17 146.114 187.133 146.319 187.133 146.505C187.133 146.69 187.169 146.895 187.332 146.981C187.394 147.015 187.468 147.037 187.552 147.044C189.898 147.235 192.234 147.425 194.532 147.616C205.184 148.57 215.369 149.256 225.42 151.764C256.002 158.687 275.408 191.778 258.195 220.187C241.335 248.089 204.116 246.906 183.261 224.306C175.947 216.639 170.778 208.886 164.351 199.75C163.459 198.468 162.564 197.171 161.663 195.868C161.528 195.673 161.306 195.557 161.068 195.557C160.537 195.557 160.187 196.11 160.414 196.59C161.101 198.043 161.781 199.49 162.462 200.923C166.963 210.621 171.454 219.795 174.306 229.751C183.594 259.694 164.646 293.052 131.432 292.347C98.8373 291.698 81.2526 258.874 90.3975 229.513C93.3823 219.347 97.5117 210.993 102.213 200.856C102.877 199.443 103.55 198.021 104.226 196.59C104.452 196.109 104.102 195.557 103.57 195.557C103.333 195.557 103.11 195.673 102.975 195.868C102.06 197.191 101.151 198.506 100.248 199.808C94.0974 208.552 88.4037 217.03 81.2041 224.478C59.9194 247.497 21.5556 247.764 5.5635 218.65C-10.1708 190.099 9.46434 158.458 39.4649 151.697C49.7637 149.199 59.062 148.598 70.1905 147.597C72.4694 147.406 74.7777 147.215 77.0947 147.024C77.1711 147.018 77.2385 146.998 77.2969 146.97C77.4678 146.887 77.5078 146.675 77.5078 146.485C77.5078 146.295 77.4677 146.083 77.2959 146C77.2378 145.972 77.1705 145.954 77.0947 145.947C74.7491 145.757 72.4123 145.566 70.1143 145.375C59.4626 144.421 49.2776 143.734 39.2266 141.217C8.67287 134.303 -10.733 101.213 6.47952 72.8047C23.3395 44.9022 60.5586 46.0849 81.4141 68.6855C88.7281 76.3524 93.8971 84.1049 100.324 93.2402C101.151 94.4286 101.98 95.6262 102.813 96.8301C102.954 97.0331 103.186 97.1543 103.433 97.1543C103.985 97.1543 104.35 96.5788 104.114 96.0791C103.477 94.7307 102.845 93.3888 102.213 92.0586C97.7119 82.3604 93.2205 73.1861 90.3692 63.2304C81.081 33.3061 100.029 -0.0510803 133.233 0.654277ZM111.649 105.216C109.693 105.216 107.891 106.261 106.916 107.951L86.2354 143.766C85.2607 145.456 85.2606 147.538 86.2354 149.235L106.916 185.05C107.891 186.74 109.7 187.784 111.649 187.784H153.011C154.967 187.784 156.769 186.74 157.744 185.05L178.425 149.235C179.4 147.545 179.4 145.463 178.425 143.766L157.744 107.951C156.769 106.261 154.96 105.216 153.011 105.216H111.649ZM137.842 159.663C140.864 159.663 143.304 162.11 143.305 165.133V166.031C143.304 169.054 140.857 171.501 137.842 171.501H126.832C123.81 171.501 121.363 169.054 121.362 166.031V165.133C121.363 162.11 123.81 159.663 126.832 159.663H137.842ZM155.374 140.581C158.397 140.581 160.844 143.029 160.844 146.052V146.949H160.837C160.837 149.972 158.39 152.419 155.367 152.419H109.293C106.271 152.419 103.823 149.972 103.823 146.949V146.052C103.823 143.029 106.271 140.581 109.293 140.581H155.374ZM143.655 121.5C146.678 121.5 149.126 123.947 149.126 126.97V127.867C149.126 130.89 146.678 133.337 143.655 133.337H121.005C117.982 133.337 115.542 130.89 115.542 127.867V126.97C115.542 123.947 117.989 121.5 121.005 121.5H143.655Z",
            fill: "currentColor",
          }),
        ),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_15056_179397" },
          /* @__PURE__ */ e.createElement("rect", { width: 804, height: 293, fill: "white" }),
        ),
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip1_15056_179397" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 522,
            height: 215.006,
            fill: "white",
            transform: "translate(281.25 42)",
          }),
        ),
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip2_15056_179397" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 264.66,
            height: 291.714,
            fill: "white",
            transform: "translate(0 0.642822)",
          }),
        ),
      ),
    ),
  U3 = (t) =>
    /* @__PURE__ */ e.createElement(
      "svg",
      {
        viewBox: "0 0 326 122",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": "Bumble for Friends",
        ...t,
      },
      /* @__PURE__ */ e.createElement("title", null, "Bumble for Friends"),
      /* @__PURE__ */ e.createElement(
        "g",
        { clipPath: "url(#clip0_16723_1836)" },
        /* @__PURE__ */ e.createElement("path", {
          d: "M322.492 30.791L310.681 10.4317C310.375 9.90957 309.94 9.47539 309.416 9.17616C308.892 8.87107 308.298 8.71265 307.686 8.70679H284.054C283.448 8.70679 282.853 8.87107 282.324 9.17616C281.8 9.48126 281.359 9.91543 281.058 10.4317L269.236 30.791C268.93 31.3132 268.771 31.9116 268.771 32.5218C268.771 33.132 268.936 33.7246 269.236 34.2527L281.047 54.5943C281.353 55.1165 281.782 55.5507 282.312 55.8499C282.836 56.155 283.43 56.3134 284.042 56.3193H307.692C308.298 56.3193 308.892 56.155 309.422 55.8499C309.946 55.5448 310.387 55.1165 310.687 54.5943L322.498 34.2351C322.804 33.7129 322.962 33.1144 322.962 32.5042C322.962 31.894 322.798 31.3014 322.498 30.7734V30.791H322.492ZM289.244 19.3265H302.461C303.255 19.3265 304.02 19.6374 304.579 20.1948C305.138 20.7522 305.45 21.5149 305.45 22.3011C305.45 23.0873 305.138 23.8501 304.579 24.4075C304.02 24.9648 303.255 25.2758 302.461 25.2758H289.244C288.449 25.2758 287.684 24.9648 287.125 24.4075C286.566 23.8501 286.249 23.0873 286.249 22.3011C286.249 21.5149 286.561 20.7522 287.125 20.1948C287.684 19.6374 288.449 19.3265 289.244 19.3265ZM299.518 45.7993H292.18C291.386 45.7993 290.621 45.4884 290.062 44.931C289.503 44.3736 289.185 43.6109 289.185 42.8247C289.185 42.0385 289.497 41.2757 290.062 40.7183C290.621 40.1609 291.386 39.85 292.18 39.85H299.518C300.313 39.85 301.078 40.1609 301.637 40.7183C302.196 41.2757 302.508 42.0385 302.508 42.8247C302.508 43.6109 302.196 44.3736 301.637 44.931C301.078 45.4884 300.313 45.7993 299.518 45.7993ZM307.821 35.52H283.877C283.083 35.52 282.318 35.209 281.759 34.6516C281.2 34.0942 280.888 33.3315 280.888 32.5453C280.888 31.7591 281.2 30.9963 281.759 30.439C282.318 29.8816 283.083 29.5706 283.877 29.5706H307.821C308.616 29.5706 309.381 29.8816 309.94 30.439C310.499 30.9963 310.811 31.7591 310.811 32.5453C310.811 33.3315 310.499 34.0942 309.94 34.6516C309.381 35.209 308.616 35.52 307.821 35.52Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M26.5865 19.3502C21.1021 19.3502 16.0531 22.2192 13.7699 26.3087V4.57651C13.7346 3.62602 13.3168 2.72833 12.6342 2.06534C11.9398 1.40821 11.0336 1.03857 10.0744 1.03857C9.11525 1.03857 8.19726 1.40821 7.51465 2.06534C6.82027 2.72247 6.41424 3.62602 6.37893 4.57651V52.8578C6.35539 53.3566 6.43778 53.8611 6.6202 54.3246C6.79673 54.7882 7.06154 55.2165 7.40873 55.5744C7.75592 55.9323 8.17372 56.2198 8.62683 56.4192C9.07994 56.607 9.58602 56.7185 10.0862 56.7185C10.5864 56.7185 11.0807 56.6246 11.5456 56.4192C11.9987 56.2315 12.4165 55.9323 12.7637 55.5744C13.1109 55.2165 13.3757 54.7882 13.5522 54.3246C13.7287 53.8611 13.8052 53.3624 13.7935 52.8578V49.6191C15.9237 53.691 21.1198 56.5777 26.6101 56.5777C35.8606 56.5777 44.1225 49.1204 44.1225 37.9727C44.1225 26.825 35.8606 19.3795 26.6101 19.3795V19.356H26.5865V19.3502ZM25.3684 50.0474C19.525 50.0474 13.7582 45.4358 13.7582 37.9786C13.7111 36.4179 13.9759 34.869 14.5349 33.4256C15.094 31.9705 15.9472 30.6504 17.0241 29.5298C18.101 28.4091 19.4015 27.5056 20.8255 26.8837C22.2614 26.2617 23.8031 25.9332 25.3566 25.9214C31.8355 25.9214 36.8904 30.6035 36.8904 37.9903C36.8904 45.3771 31.8355 50.0592 25.3566 50.0592L25.3684 50.0474Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M173.772 19.3502C168.282 19.3502 163.239 22.2192 160.955 26.3087V4.57651C160.92 3.62602 160.502 2.72833 159.82 2.06534C159.125 1.40821 158.219 1.03857 157.26 1.03857C156.301 1.03857 155.383 1.40821 154.7 2.06534C154.006 2.72247 153.6 3.62602 153.564 4.57651V52.8578C153.541 53.3566 153.623 53.8611 153.806 54.3246C153.982 54.7882 154.247 55.2165 154.594 55.5744C154.941 55.9323 155.359 56.2198 155.812 56.4192C156.265 56.607 156.772 56.7185 157.272 56.7185C157.772 56.7185 158.266 56.6246 158.731 56.4192C159.184 56.2315 159.602 55.9323 159.949 55.5744C160.296 55.2165 160.561 54.7882 160.738 54.3246C160.914 53.8611 160.991 53.3624 160.979 52.8578V49.6191C163.109 53.691 168.305 56.5777 173.796 56.5777C183.046 56.5777 191.308 49.1204 191.308 37.9727C191.308 26.825 183.046 19.3795 173.796 19.3795V19.356H173.772V19.3502ZM172.554 50.0474C166.722 50.0474 160.95 45.4358 160.95 37.9786C160.903 36.4179 161.167 34.869 161.726 33.4256C162.291 31.9705 163.139 30.6504 164.216 29.5298C165.292 28.4091 166.581 27.5056 168.017 26.8837C169.453 26.2617 170.995 25.9332 172.548 25.9214C179.027 25.9214 184.082 30.6035 184.082 37.9903C184.082 45.3771 179.027 50.0592 172.548 50.0592L172.56 50.0474H172.554Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M79.2908 20.3359C78.8023 20.3359 78.3198 20.4298 77.8667 20.6117C77.4136 20.7936 77.0076 21.0635 76.6604 21.4096C76.3132 21.7558 76.0366 22.1606 75.8601 22.6124C75.6659 23.0642 75.5717 23.5394 75.5717 24.0323V36.5999C75.5717 45.4711 71.4349 49.7366 65.0972 49.7366C59.9835 49.7366 56.6234 45.829 56.6234 40.0791V24.0323C56.5881 23.0818 56.1703 22.1841 55.4877 21.5211C54.7933 20.864 53.8871 20.4944 52.9279 20.4944C51.9687 20.4944 51.0508 20.864 50.3681 21.5211C49.6738 22.1782 49.2677 23.0818 49.2324 24.0323V41.5753C49.2324 50.4465 54.8522 56.5601 63.3966 56.5601C68.5985 56.5601 73.7122 53.6676 75.5776 49.6016V52.8403C75.5541 53.339 75.6365 53.8436 75.8189 54.3071C76.0013 54.7706 76.2602 55.1989 76.6074 55.5569C76.9546 55.9147 77.3724 56.2022 77.8255 56.4017C78.2904 56.5895 78.7847 56.701 79.2849 56.701C79.7851 56.701 80.2794 56.6071 80.7443 56.4017C81.2091 56.214 81.6152 55.9265 81.9623 55.5569C82.3095 55.1989 82.5744 54.7706 82.7509 54.3071C82.9274 53.8436 83.0039 53.3449 82.9921 52.8403V24.0323C82.9921 23.0583 82.5979 22.1137 81.9035 21.4214C81.2091 20.729 80.2676 20.3359 79.2849 20.3359H79.2908Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M133.48 19.3486C127.636 19.3486 122.852 21.8011 120.304 26.401C118.345 22.0886 113.608 19.3486 108.564 19.3486C106.234 19.3956 103.951 20.0644 101.968 21.2789C99.9848 22.4935 98.343 24.2067 97.2485 26.2602V24.0307C97.2131 23.0802 96.7953 22.1825 96.1127 21.5195C95.4184 20.8624 94.5121 20.4927 93.553 20.4927C92.5938 20.4927 91.6758 20.8624 90.9932 21.5195C90.2988 22.1766 89.8928 23.0802 89.8574 24.0307V52.8563C89.8339 53.355 89.9163 53.8596 90.0987 54.3231C90.2811 54.7866 90.5401 55.2149 90.8872 55.5728C91.2344 55.9307 91.6522 56.2182 92.1054 56.4177C92.5702 56.6055 93.0645 56.7169 93.5647 56.7169C94.0649 56.7169 94.5592 56.6231 95.0241 56.4177C95.489 56.23 95.895 55.9307 96.2422 55.5728C96.5894 55.2149 96.8542 54.7866 97.0307 54.3231C97.2073 53.8596 97.2838 53.3609 97.2602 52.8563V38.1003C97.2602 30.2147 100.967 26.1781 106.658 26.1781C111.213 26.1781 114.631 29.4402 114.631 34.621L114.667 52.868C114.643 53.3668 114.726 53.8713 114.896 54.3349C115.073 54.7984 115.338 55.2267 115.685 55.5846C116.032 55.9425 116.45 56.23 116.903 56.4294C117.356 56.6172 117.862 56.7287 118.362 56.7287C118.862 56.7287 119.357 56.6348 119.822 56.4294C120.275 56.2417 120.693 55.9425 121.04 55.5846C121.387 55.2267 121.652 54.7984 121.828 54.3349C122.005 53.8713 122.081 53.3726 122.07 52.868V38.112C122.07 30.2265 125.847 26.1898 131.608 26.1898C136.163 26.1898 139.582 29.452 139.582 34.6327L139.511 52.8798C139.488 53.3785 139.57 53.8831 139.753 54.3466C139.935 54.8101 140.194 55.2384 140.541 55.5963C140.888 55.9542 141.306 56.2417 141.759 56.4412C142.212 56.6289 142.713 56.7404 143.219 56.7404C143.725 56.7404 144.213 56.6465 144.678 56.4412C145.143 56.2534 145.549 55.9542 145.896 55.5963C146.243 55.2384 146.508 54.8101 146.685 54.3466C146.861 53.8831 146.938 53.3844 146.926 52.8798V33.119C146.926 24.8169 140.877 19.3486 133.539 19.3486",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M213.316 51.9582C213.122 51.1368 212.622 50.4092 211.904 49.9457C211.186 49.4822 210.327 49.312 209.491 49.4705C209.085 49.5409 208.667 49.5761 208.249 49.5761C205.548 49.5761 203.695 47.8746 203.695 45.469V4.57452C203.695 4.08754 203.601 3.6123 203.406 3.15465C203.212 2.70288 202.942 2.29804 202.606 1.95187C202.259 1.60571 201.853 1.32995 201.4 1.15393C200.958 0.977917 200.482 0.878174 199.988 0.878174C199.005 0.878174 198.063 1.27128 197.369 1.96361C196.675 2.65594 196.28 3.5947 196.28 4.57452V45.8269C196.28 48.6373 197.381 51.3538 199.364 53.3546C201.347 55.3553 204.036 56.4994 206.872 56.5346C208.32 56.5698 209.756 56.3703 211.139 55.9361C211.927 55.6839 212.586 55.1499 212.992 54.4341C213.398 53.7183 213.516 52.8735 213.34 52.0755L213.316 51.9699V51.9582Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M249.822 37.5605C249.246 32.3211 246.403 19.3486 232.31 19.3486C222.341 19.3486 214.009 26.8059 214.009 38.024C214.009 49.2421 222.377 56.5468 232.021 56.5468C238.153 56.5468 243.332 54.282 246.68 49.7467C246.945 49.4005 247.121 48.9957 247.227 48.5791C247.333 48.1625 247.345 47.7225 247.286 47.2942C247.215 46.8659 247.068 46.4493 246.845 46.0797C246.615 45.71 246.321 45.3873 245.974 45.1292C245.627 44.8652 245.221 44.6891 244.803 44.5835C244.385 44.4779 243.944 44.4662 243.514 44.5249C243.084 44.5953 242.667 44.7419 242.296 44.9649C241.925 45.1937 241.602 45.4871 241.337 45.8333C238.848 49.3125 235.411 50.1457 232.016 50.1457C226.814 50.1457 222.047 46.2381 221.329 39.7137H247.845C248.122 39.7137 248.392 39.6551 248.645 39.5495C248.898 39.4439 249.122 39.2737 249.304 39.0742C249.481 38.8689 249.628 38.6342 249.71 38.3702C249.793 38.1061 249.816 37.8362 249.793 37.5605H249.84L249.828 37.5722L249.822 37.5605ZM221.517 34.4626C222.018 32.0101 223.371 29.7923 225.331 28.2316C227.29 26.6592 229.756 25.826 232.263 25.873C237.106 25.873 241.154 28.7068 242.29 34.4626H221.512H221.517Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M87.2832 93.3988C78.6505 93.7156 74.755 97.5997 74.755 108.73V117.366C74.755 119.379 73.1191 121.01 71.0948 121.01C69.0705 121.01 67.4346 119.379 67.4346 117.366V89.8608C67.4346 87.8484 69.0705 86.2173 71.0948 86.2173C73.1191 86.2173 74.755 87.8484 74.755 89.8608V93.6452C77.0146 89.943 81.5222 87.0563 86.3358 86.8979C88.4071 86.6867 90.1607 87.819 90.3902 89.9254C90.5315 91.4156 89.5193 93.2931 87.2832 93.3929V93.3988Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M62.9221 102.777C62.9221 113.578 54.5424 121.024 44.2621 121.024C33.9818 121.024 25.4609 113.59 25.4609 102.777C25.4609 91.9635 33.9112 84.6001 44.2621 84.6001C54.6131 84.6001 62.9221 91.9752 62.9221 102.777ZM55.8076 102.777C55.8076 95.5483 50.2467 90.8546 44.2621 90.8546C38.2775 90.8546 32.6401 95.5601 32.6401 102.777C32.6401 109.993 38.1245 114.699 44.2621 114.699C50.3997 114.699 55.8076 109.993 55.8076 102.777Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M18.6953 76.1855C15.5764 76.3146 13.0167 78.2156 13.0167 82.0762V86.2243H21.614C23.2852 86.2243 24.6387 87.5679 24.6387 89.2401C24.6387 90.9122 23.2852 92.2558 21.614 92.2558H13.0284V117.379C13.0284 119.392 11.3925 121.023 9.36822 121.023C7.34393 121.023 5.70802 119.392 5.70802 117.379V92.2558H3.02466C1.35345 92.2558 0 90.9122 0 89.2401C0 87.5679 1.35345 86.2243 3.02466 86.2243H5.70214V82.0762C5.70214 74.2845 10.8452 69.45 18.5893 69.45C19.472 69.45 20.3253 69.5204 21.1373 69.667C23.0439 69.9545 24.2209 71.92 23.6736 73.7624C22.7026 76.3029 20.6136 76.1092 18.7011 76.1855H18.6953Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M270.983 83.702V83.7254C261.733 83.7254 253.471 91.1709 253.471 102.319C253.471 113.466 261.733 120.924 270.983 120.924C276.468 120.924 281.67 118.043 283.8 113.965V117.204C283.788 117.702 283.859 118.207 284.041 118.671C284.218 119.134 284.482 119.562 284.83 119.92C285.177 120.278 285.595 120.577 286.048 120.765C286.513 120.971 287.007 121.064 287.507 121.064C288.007 121.064 288.513 120.959 288.966 120.765C289.419 120.56 289.837 120.278 290.184 119.92C290.532 119.562 290.796 119.134 290.973 118.671C291.15 118.207 291.238 117.708 291.214 117.204V68.9283C291.179 67.9778 290.773 67.0684 290.079 66.4171C289.396 65.76 288.478 65.3904 287.519 65.3904C286.56 65.3904 285.653 65.76 284.959 66.4171C284.276 67.086 283.859 67.9778 283.823 68.9283V90.6546C281.54 86.571 276.497 83.6961 271.007 83.6961H270.983V83.702ZM272.237 114.411C265.758 114.411 260.703 109.729 260.703 102.342C260.703 94.9553 265.758 90.2733 272.237 90.2733C273.79 90.285 275.332 90.6194 276.768 91.2355C278.192 91.8574 279.492 92.761 280.569 93.8816C281.646 95.0022 282.493 96.3224 283.058 97.7774C283.617 99.2208 283.882 100.77 283.835 102.33C283.835 109.788 278.074 114.399 272.225 114.399L272.237 114.411Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M152.036 93.4002C143.403 93.717 139.508 97.6011 139.508 108.731V117.368C139.508 119.38 137.872 121.011 135.848 121.011C133.823 121.011 132.188 119.38 132.188 117.368V89.8623C132.188 87.8498 133.823 86.2188 135.848 86.2188C137.872 86.2188 139.508 87.8498 139.508 89.8623V93.6466C141.768 89.9444 146.275 87.0578 151.089 86.8993C153.16 86.6881 154.914 87.8205 155.143 89.9268C155.284 91.4171 154.272 93.2946 152.036 93.3944V93.4002Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M168.276 75.8591C168.276 78.5286 166.245 80.4824 163.497 80.4824C160.749 80.4824 158.643 78.5286 158.643 75.8591C158.643 73.3362 160.673 71.1653 163.497 71.1653C166.322 71.1653 168.276 73.3303 168.276 75.8591ZM159.731 117.311V88.9136C159.731 86.866 161.391 85.2114 163.45 85.2114C165.51 85.2114 167.263 86.9129 167.263 89.0134V117.217C167.263 119.312 165.551 121.019 163.45 121.019C161.349 121.019 159.731 119.364 159.731 117.317V117.311Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M299.828 109.831C301.405 109.496 302.983 110.247 303.8 111.632C305.448 114.09 308.202 115.064 311.727 115.064C315.946 115.064 318.624 113.169 318.624 110.429C318.624 108.323 317.141 106.985 313.904 106.287L306.301 104.738C300.24 103.406 296.798 100.179 296.798 95.2681C296.798 88.8142 302.223 84.2495 310.603 84.2495C316.423 84.2495 320.872 86.4673 323.373 89.9055C324.797 91.871 323.602 94.6462 321.219 95.1567C319.783 95.4559 318.3 94.834 317.57 93.5843C316.029 91.4545 313.828 90.0815 310.385 90.0815C306.095 90.0815 304.195 92.1879 304.195 94.6462C304.195 96.6117 305.319 97.8732 308.414 98.5773L316.723 100.402C322.355 101.593 325.809 104.89 325.809 109.801C325.809 117.1 319.818 121.031 311.091 121.031C305.413 121.031 300.323 119.294 297.622 115.645C296.021 113.486 297.192 110.394 299.834 109.842V109.831H299.828Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M208.571 102.05C207.994 96.811 205.152 83.8386 191.07 83.8386C181.114 83.8386 172.781 91.2959 172.781 102.502C172.781 113.709 181.161 121.013 190.782 121.013C196.914 121.013 202.092 118.749 205.441 114.225C205.694 113.879 205.882 113.474 205.988 113.057C206.094 112.641 206.106 112.201 206.047 111.772C205.976 111.344 205.829 110.939 205.605 110.558C205.376 110.188 205.082 109.866 204.734 109.607C204.387 109.343 203.981 109.167 203.563 109.062C203.146 108.956 202.704 108.944 202.275 109.003C201.845 109.074 201.427 109.22 201.057 109.443C200.686 109.672 200.362 109.965 200.103 110.312C197.614 113.791 194.172 114.624 190.776 114.624C185.574 114.624 180.82 110.728 180.102 104.192H206.629C206.906 104.192 207.177 104.133 207.418 104.028C207.671 103.922 207.894 103.752 208.077 103.552C208.253 103.347 208.401 103.112 208.483 102.848C208.565 102.584 208.589 102.314 208.565 102.039L208.577 102.062L208.571 102.05ZM180.314 98.9526C180.825 96.5118 182.191 94.3057 184.15 92.7568C186.11 91.2078 188.558 90.3747 191.07 90.4216C195.913 90.4216 199.98 93.2555 201.098 99.0112L180.308 98.9643V98.9526H180.314Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M121.977 76.187C118.858 76.3161 116.298 78.217 116.298 82.0777V86.2258H124.895C126.566 86.2258 127.92 87.5694 127.92 89.2415C127.92 90.9137 126.566 92.2573 124.895 92.2573H116.31V117.381C116.31 119.393 114.674 121.024 112.65 121.024C110.625 121.024 108.989 119.393 108.989 117.381V92.2573H106.3C104.629 92.2573 103.275 90.9137 103.275 89.2415C103.275 87.5694 104.629 86.2258 106.3 86.2258H108.978V82.0777C108.978 74.286 114.121 69.4514 121.865 69.4514C122.747 69.4514 123.601 69.5218 124.413 69.6685C126.319 69.956 127.496 71.9215 126.949 73.7638C125.978 76.3043 123.889 76.1107 121.977 76.187Z",
          fill: "currentColor",
        }),
        /* @__PURE__ */ e.createElement("path", {
          d: "M217.823 121.025C218.311 121.025 218.794 120.931 219.247 120.749C219.7 120.568 220.106 120.298 220.453 119.951C220.8 119.605 221.077 119.2 221.253 118.749C221.448 118.297 221.542 117.822 221.542 117.329V104.761C221.542 95.89 225.679 91.6245 232.016 91.6245C237.13 91.6245 240.49 95.5321 240.49 101.282V117.329C240.525 118.279 240.943 119.177 241.626 119.84C242.32 120.497 243.226 120.867 244.186 120.867C245.145 120.867 246.063 120.497 246.745 119.84C247.44 119.183 247.846 118.279 247.881 117.329V99.7858C247.881 90.9146 242.261 84.801 233.717 84.801C228.515 84.801 223.401 87.6935 221.536 91.7595V88.5208C221.559 88.0221 221.477 87.5175 221.295 87.054C221.112 86.5905 220.853 86.1622 220.506 85.8043C220.159 85.4464 219.741 85.1589 219.288 84.9594C218.823 84.7716 218.329 84.6602 217.829 84.6602C217.328 84.6602 216.834 84.754 216.369 84.9594C215.904 85.1471 215.498 85.4346 215.151 85.8043C214.804 86.1622 214.539 86.5905 214.363 87.054C214.186 87.5175 214.11 88.0162 214.121 88.5208V117.335C214.121 118.309 214.516 119.253 215.21 119.946C215.904 120.638 216.846 121.031 217.829 121.031L217.823 121.025Z",
          fill: "currentColor",
        }),
      ),
      /* @__PURE__ */ e.createElement(
        "defs",
        null,
        /* @__PURE__ */ e.createElement(
          "clipPath",
          { id: "clip0_16723_1836" },
          /* @__PURE__ */ e.createElement("rect", {
            width: 325.793,
            height: 120.178,
            fill: "white",
            transform: "translate(0 0.88501)",
          }),
        ),
      ),
    ),
  J3 =
    "data:image/png;base64,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",
  X3 = {
    black: q1["color-black"],
    white: q1["color-white"],
    custom: "",
  };
function $1({
  a11yLabel: t,
  color: a = "black",
  customColor: n,
  variant: i = "word-mark",
  width: o = "100%",
}) {
  const c = F({
      [q1.root]: !0,
      [X3[a]]: !0,
    }),
    l = {
      width: typeof o == "number" ? `${o}px` : o,
      ...(a === "custom" && { color: n }),
    },
    s = () => {
      switch (i) {
        case "primary":
          return /* @__PURE__ */ r(W3, {});
        case "hive":
          return /* @__PURE__ */ r(z3, {});
        case "word-mark":
          return /* @__PURE__ */ r(Y3, {});
        case "bff":
          return /* @__PURE__ */ r(K3, {});
        case "bff-full":
          return /* @__PURE__ */ r(U3, {});
        case "the-buzz":
          return /* @__PURE__ */ r("img", { src: J3, alt: "The Buzz Logo" });
        default:
          return null;
      }
    };
  return /* @__PURE__ */ r("div", {
    className: c,
    style: l,
    role: t ? "img" : void 0,
    "aria-label": t,
    children: /* @__PURE__ */ r("span", { className: q1.image, children: s() }),
  });
}
const $3 = "link__Nwimt",
  K1 = {
    link: $3,
    "link--decorated": "link--decorated__viW3E",
    "link--underlined": "link--underlined__pG7i2",
  },
  A1 = ({
    children: t,
    href: a,
    rel: n = "noopener noreferrer",
    title: i,
    target: o = "_self",
    extraClass: c,
    isDecorated: l,
    isUnderlined: s = !0,
    onClick: d,
  }) => {
    const g = F(K1.link, c, {
      [K1["link--decorated"]]: l,
      [K1["link--underlined"]]: s,
    });
    return /* @__PURE__ */ r("a", {
      href: a,
      rel: n,
      title: i,
      target: o,
      className: g,
      onClick: d,
      children: t,
    });
  },
  x4 = ({
    appLinks: t,
    companyLinks: a,
    legalLinks: n,
    socialLinks: i,
    downloadWidgetText: o,
    downloadCtaText: c,
    downloadUrl: l,
    languages: s,
    lang: d,
    languageA11yLabel: g,
    onLanguageChange: v,
  }) =>
    /* @__PURE__ */ f("footer", {
      className: G.footer,
      children: [
        /* @__PURE__ */ f("div", {
          className: G.footer__upper,
          children: [
            /* @__PURE__ */ r("div", {
              className: G.footer__logo,
              children: /* @__PURE__ */ r($1, {}),
            }),
            /* @__PURE__ */ f("nav", {
              className: G.footer__links,
              children: [
                /* @__PURE__ */ f("div", {
                  className: G["link-group"],
                  children: [
                    /* @__PURE__ */ r("h2", {
                      children: /* @__PURE__ */ r(f1, { isSubdued: !0, children: t.title }),
                    }),
                    /* @__PURE__ */ r("ul", {
                      children: t.links.map((h, V) =>
                        /* @__PURE__ */ r(
                          "li",
                          {
                            children: /* @__PURE__ */ r(A1, {
                              href: h.url,
                              target: h.hasIcon ? "_blank" : "_self",
                              children: /* @__PURE__ */ f(y1, {
                                children: [
                                  h.text,
                                  /* @__PURE__ */ r("span", {
                                    className: G["link-group__link-icon"],
                                    children:
                                      h.hasIcon && /* @__PURE__ */ r(N, { name: w.ArrowDiagonal }),
                                  }),
                                ],
                              }),
                            }),
                          },
                          `app-link-${V}`,
                        ),
                      ),
                    }),
                  ],
                }),
                /* @__PURE__ */ f("div", {
                  className: G["link-group"],
                  children: [
                    /* @__PURE__ */ r("h2", {
                      children: /* @__PURE__ */ r(f1, { isSubdued: !0, children: a.title }),
                    }),
                    /* @__PURE__ */ r("ul", {
                      children: a.links.map((h, V) =>
                        /* @__PURE__ */ r(
                          "li",
                          {
                            children: /* @__PURE__ */ r(A1, {
                              href: h.url,
                              target: h.hasIcon ? "_blank" : "_self",
                              children: /* @__PURE__ */ f(y1, {
                                children: [
                                  h.text,
                                  /* @__PURE__ */ r("span", {
                                    className: G["link-group__link-icon"],
                                    children:
                                      h.hasIcon && /* @__PURE__ */ r(N, { name: w.ArrowDiagonal }),
                                  }),
                                ],
                              }),
                            }),
                          },
                          `company-link-${V}`,
                        ),
                      ),
                    }),
                  ],
                }),
                /* @__PURE__ */ f("div", {
                  className: `${G["link-group"]} ${G["link-group--legal"]}`,
                  children: [
                    /* @__PURE__ */ r("h2", {
                      children: /* @__PURE__ */ r(f1, { isSubdued: !0, children: n.title }),
                    }),
                    /* @__PURE__ */ r("ul", {
                      children: n.links.map((h, V) =>
                        /* @__PURE__ */ r(
                          "li",
                          {
                            children: /* @__PURE__ */ r(A1, {
                              href: h.url,
                              target: h.hasIcon ? "_blank" : "_self",
                              onClick: h.onClick,
                              children: /* @__PURE__ */ r(X1, { children: h.text }),
                            }),
                          },
                          `legal-link-${V}`,
                        ),
                      ),
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
        /* @__PURE__ */ f("div", {
          className: G.footer__lower,
          children: [
            /* @__PURE__ */ r("div", {
              className: G.footer__qr,
              children: /* @__PURE__ */ r(_2, { text: o }),
            }),
            /* @__PURE__ */ f("div", {
              className: G["footer__lower-right"],
              children: [
                /* @__PURE__ */ r("ul", {
                  className: G.footer__social,
                  children: i.map((h, V) =>
                    /* @__PURE__ */ r(
                      "li",
                      {
                        children: /* @__PURE__ */ f(A1, {
                          href: h.url,
                          target: "_blank",
                          isUnderlined: !1,
                          children: [
                            /* @__PURE__ */ r("span", {
                              className: G["social-link-icon"],
                              children: /* @__PURE__ */ r(N, { name: h.iconName }),
                            }),
                            /* @__PURE__ */ r(Q1, { children: h.a11yLabel }),
                          ],
                        }),
                      },
                      `social-link-${V}`,
                    ),
                  ),
                }),
                /* @__PURE__ */ f("div", {
                  className: G.footer__buttons,
                  children: [
                    /* @__PURE__ */ r("div", {
                      className: G["footer__download-cta"],
                      children: /* @__PURE__ */ r(U, {
                        designType: "primary",
                        href: l,
                        text: c,
                        icon: w.Download,
                      }),
                    }),
                    /* @__PURE__ */ r("div", {
                      className: G.footer__language,
                      children: /* @__PURE__ */ r(T2, {
                        options: s,
                        selectedValue: d,
                        dropdownDirection: "up",
                        isIconOnly: !0,
                        hasMaxHeight: !0,
                        a11y: {
                          label: g,
                        },
                        onChange: v,
                      }),
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
      ],
    }),
  j = {
    "section-get-the-app-wrapper": "section-get-the-app-wrapper__1-BhX",
    "section-get-the-app": "section-get-the-app__TL3-u",
    "section-get-the-app--short": "section-get-the-app--short__UQpWP",
    "section-get-the-app__image": "section-get-the-app__image__szhv0",
    "section-get-the-app__qr": "section-get-the-app__qr__GrV2S",
    "section-get-the-app__cta": "section-get-the-app__cta__kxWSS",
    "section-get-the-app__copy": "section-get-the-app__copy__6jh20",
    "title-description": "title-description__nVgOy",
    "short-header": "short-header__omETz",
    "qr-block": "qr-block__v4S-p",
    "qr-block__qr": "qr-block__qr__dMZ3U",
  },
  T4 = ({ title: t, description: a, cta: n, qrCodeText: i, variant: o = "mobile-image" }) => {
    const c = H2();
    let l = `${c}/`;
    return (
      c && !c.endsWith("/") && (l = `${c}/`),
      o === "mobile-image"
        ? /* @__PURE__ */ r("div", {
            className: j["section-get-the-app-wrapper"],
            children: /* @__PURE__ */ f("section", {
              className: j["section-get-the-app"],
              children: [
                /* @__PURE__ */ f("div", {
                  className: j["section-get-the-app__copy"],
                  children: [
                    /* @__PURE__ */ f("div", {
                      className: j["title-description"],
                      children: [
                        /* @__PURE__ */ r(k1, { children: t }),
                        /* @__PURE__ */ r(n1, { children: a }),
                      ],
                    }),
                    /* @__PURE__ */ r("div", {
                      className: j["section-get-the-app__cta"],
                      children: /* @__PURE__ */ r(U, {
                        href: n.href,
                        text: n.text,
                        icon: w.Download,
                        onClick: n.onClick,
                      }),
                    }),
                    /* @__PURE__ */ r("div", {
                      className: j["section-get-the-app__qr"],
                      children: /* @__PURE__ */ r(F1, { size: "large" }),
                    }),
                  ],
                }),
                /* @__PURE__ */ r("div", {
                  className: j["section-get-the-app__image"],
                  children: /* @__PURE__ */ r("img", {
                    className: j["section-get-the-app__img"],
                    src: `${l}assets/get-the-app-mobile.png`,
                    srcSet: `${l}assets/get-the-app-mobile.png 658w, ${l}assets/get-the-app-tablet.png 632w, ${l}assets/get-the-app-desktop.png 1092w`,
                    sizes: "(width >= 1024px) 1092px, (width >= 768px) 632px, 658px",
                    alt: "3 mobile phone screens showing the Bumble app",
                  }),
                }),
              ],
            }),
          })
        : /* @__PURE__ */ r("div", {
            className: j["section-get-the-app-wrapper"],
            children: /* @__PURE__ */ f("section", {
              className: `${j["section-get-the-app"]} ${j["section-get-the-app--short"]}`,
              children: [
                /* @__PURE__ */ r("div", {
                  className: j["section-get-the-app__copy"],
                  children: /* @__PURE__ */ r("h3", { className: j["short-header"], children: t }),
                }),
                /* @__PURE__ */ r("div", {
                  className: j["section-get-the-app__qr"],
                  children: /* @__PURE__ */ f("div", {
                    className: j["qr-block"],
                    children: [
                      /* @__PURE__ */ r("div", {
                        className: j["qr-block__qr"],
                        children: /* @__PURE__ */ r(F1, { size: "stretch", hasPadding: !1 }),
                      }),
                      /* @__PURE__ */ r("div", {
                        className: j["qr-block__text"],
                        children: /* @__PURE__ */ r(n1, { children: i }),
                      }),
                    ],
                  }),
                }),
                /* @__PURE__ */ r("div", {
                  className: j["section-get-the-app__cta"],
                  children: /* @__PURE__ */ r(U, {
                    href: n.href,
                    text: n.text,
                    onClick: n.onClick,
                  }),
                }),
              ],
            }),
          })
    );
  },
  e4 = "header__mCZx6",
  t4 = "header__inner__Ficum",
  a4 = "header__actions__SlhVF",
  r4 = "header__logo__jQnob",
  n4 = "header__menu__RaRaE",
  z = {
    header: e4,
    "desktop-only": "desktop-only__1ZF5f",
    "not-desktop": "not-desktop__vo4gH",
    "mobile-only": "mobile-only__-Wi-w",
    "not-mobile": "not-mobile__Zl8Mg",
    header__inner: t4,
    header__actions: a4,
    header__logo: r4,
    "header__logo-link": "header__logo-link__Iv7B9",
    header__menu: n4,
    "header-container": "header-container__6IbiS",
    "is-open": "is-open__oYcyp",
    "header-container__nav": "header-container__nav__GSyPJ",
    "header-container__modal": "header-container__modal__URf0k",
    "header-container__app-download-widget": "header-container__app-download-widget__S3Esw",
  },
  l4 = typeof (global == null ? void 0 : global.window) < "u" ? F2 : v1,
  i4 = {
    "desktop-sm": 640,
  },
  S2 = (t = 900) => {
    const [a, n] = X(void 0),
      i = f2((o) => {
        o.matches ? n(!0) : n(!1);
      }, []);
    return (
      l4(() => {
        const o = window.matchMedia(`(max-width: ${t - 1}px)`);
        return (o.addListener(i), o.matches ? n(!0) : n(!1), () => o.removeListener(i));
      }, [t, i]),
      a
    );
  },
  T1 = {
    "header-menu__link": "header-menu__link__2GNaH",
    "header-menu": "header-menu__CKg-f",
    "header-menu__item": "header-menu__item__sEynU",
    "is-active": "is-active__bNEU1",
  },
  o4 = "submenu__MIXh4",
  c4 = "submenu__back__j9cQ3",
  s4 = "submenu__header__-72Dn",
  d4 = "submenu__items__NQbhI",
  u4 = "submenu__link__oZFt4",
  R = {
    "navigation-modal": "navigation-modal__kwSXz",
    "navigation-modal__nav": "navigation-modal__nav__Tn-YT",
    "with-submenu": "with-submenu__rmxq4",
    "navigation-modal__nav-list": "navigation-modal__nav-list__xKvqQ",
    "navigation-modal__submenu": "navigation-modal__submenu__5uKHy",
    "navigation-modal--with-top-level-menu": "navigation-modal--with-top-level-menu__7PdM1",
    "navigation-modal__close": "navigation-modal__close__Xh9mq",
    "menu-item__button": "menu-item__button__3TtSO",
    "is-active": "is-active__pAp0V",
    "menu-item__title": "menu-item__title__CPcBa",
    "menu-item__icon": "menu-item__icon__i8t1J",
    submenu: o4,
    submenu__back: c4,
    "submenu__back-text": "submenu__back-text__tFYXq",
    "submenu__back-icon": "submenu__back-icon__c39Xa",
    submenu__header: s4,
    submenu__items: d4,
    "submenu__items-list": "submenu__items-list__FcxZG",
    submenu__link: u4,
    "submenu__link-icon": "submenu__link-icon__uQmZJ",
    "submenu__link-text": "submenu__link-text__PiKRp",
  },
  C4 = ({ title: t, description: a, iconName: n, url: i, onClick: o }) => {
    const [c, l] = X(!1);
    return /* @__PURE__ */ f("li", {
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      className: R.submenu__item,
      children: [
        /* @__PURE__ */ r("a", {
          className: R.submenu__link,
          href: i,
          onClick: o,
          children: /* @__PURE__ */ f(y1, {
            children: [
              n
                ? /* @__PURE__ */ r("span", {
                    className: R["submenu__link-icon"],
                    children: /* @__PURE__ */ r(N, { name: n, size: "sm", isInline: !0 }),
                  })
                : null,
              /* @__PURE__ */ r("span", { className: R["submenu__link-text"], children: t }),
              /* @__PURE__ */ r(N, { name: w.GenericChevronRight, size: "sm", isInline: !0 }),
            ],
          }),
        }),
        /* @__PURE__ */ r(X1, { isSubdued: !c, children: a }),
      ],
    });
  },
  h4 = ({ title: t, titleUrl: a, description: n, submenuTitle: i, backButton: o, items: c }) =>
    /* @__PURE__ */ f("div", {
      className: R.submenu,
      children: [
        /* @__PURE__ */ r("button", {
          className: R.submenu__back,
          type: "button",
          onClick: o.onClick,
          children: /* @__PURE__ */ f(y1, {
            children: [
              /* @__PURE__ */ r("span", {
                className: R["submenu__back-icon"],
                children: /* @__PURE__ */ r(N, { name: w.GenericChevronLeft, size: "stretch" }),
              }),
              /* @__PURE__ */ r("span", { className: R["submenu__back-text"], children: o.text }),
            ],
          }),
        }),
        /* @__PURE__ */ f("div", {
          className: R.submenu__header,
          children: [
            /* @__PURE__ */ r("div", {
              className: R["submenu__header-title"],
              children: a
                ? /* @__PURE__ */ r("a", {
                    href: a,
                    children: /* @__PURE__ */ f(p1, {
                      children: [
                        t,
                        " ",
                        /* @__PURE__ */ r(N, {
                          name: N.Name.GenericChevronRight,
                          size: "sm",
                          isInline: !0,
                        }),
                      ],
                    }),
                  })
                : /* @__PURE__ */ f(p1, {
                    children: [
                      t,
                      " ",
                      /* @__PURE__ */ r(N, {
                        name: N.Name.GenericChevronRight,
                        size: "sm",
                        isInline: !0,
                      }),
                    ],
                  }),
            }),
            /* @__PURE__ */ r(n1, { extraClass: R["submenu__header-description"], children: n }),
          ],
        }),
        /* @__PURE__ */ f("div", {
          className: R.submenu__items,
          children: [
            /* @__PURE__ */ r(G1, { isSubdued: !0, children: i }),
            /* @__PURE__ */ r("ul", {
              className: R["submenu__items-list"],
              children: c.map((l, s) => /* @__PURE__ */ r(C4, { ...l }, `submenu-item-${s}`)),
            }),
          ],
        }),
      ],
    }),
  m4 = (t) => {
    const { title: a, isActive: n, url: i, id: o, onClick: c, subMenu: l } = t;
    return /* @__PURE__ */ r("li", {
      className: `${R["menu-item"]} ${n ? R["is-active"] : ""}`,
      children: l
        ? /* @__PURE__ */ f("button", {
            className: R["menu-item__button"],
            type: "button",
            id: o,
            onClick: () => (c == null ? void 0 : c(t)),
            children: [
              /* @__PURE__ */ r(p1, { extraClass: R["menu-item__title"], children: a }),
              /* @__PURE__ */ r("span", {
                className: R["menu-item__icon"],
                children: /* @__PURE__ */ r(N, {
                  name: w.GenericChevronRight,
                  size: "md",
                  isInline: !0,
                }),
              }),
            ],
          })
        : /* @__PURE__ */ r("a", {
            className: R["menu-item__button"],
            href: i,
            id: o,
            children: /* @__PURE__ */ r(p1, { extraClass: R["menu-item__title"], children: a }),
          }),
    });
  },
  f4 = ({
    isOpen: t,
    showTopLevelMenu: a,
    backButtonText: n,
    menuItems: i,
    closeA11yLabel: o,
    onClose: c,
  }) => {
    const [l, s] = X(i);
    v1(() => {
      s(i);
    }, [i]);
    const d = (h) => {
        s(
          l.map((V) => ({
            ...V,
            isActive: V.title === h.title,
          })),
        );
      },
      g = () => {
        s(
          l.map((h) => ({
            ...h,
            isActive: !1,
          })),
        );
      };
    let v;
    if (l.length) {
      const h = l.find((V) => V.isActive);
      ((v = h == null ? void 0 : h.subMenu),
        v &&
          (v.backButton = {
            text: n,
            onClick: g,
          }));
    }
    return t
      ? /* @__PURE__ */ f("div", {
          className: F({
            [R["navigation-modal"]]: !0,
            [R["navigation-modal--with-top-level-menu"]]: a,
          }),
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": a ? "navigation-title" : void 0,
          id: "modal-navigation",
          children: [
            !a &&
              /* @__PURE__ */ r("button", {
                className: R["navigation-modal__close"],
                type: "button",
                onClick: c,
                "aria-controls": "modal-navigation",
                "aria-label": o,
                children: /* @__PURE__ */ r(N, { name: w.Close, size: "sm", isInline: !0 }),
              }),
            a &&
              /* @__PURE__ */ r("nav", {
                className: F({ [R["navigation-modal__nav"]]: !0, [R["with-submenu"]]: !!v }),
                children: /* @__PURE__ */ r("ul", {
                  className: R["navigation-modal__nav-list"],
                  children: l.map((h, V) =>
                    /* @__PURE__ */ r(
                      m4,
                      {
                        ...h,
                        onClick: h.subMenu ? () => d(h) : void 0,
                        id: h.isActive ? "navigation-title" : void 0,
                      },
                      `menu-item-${V}`,
                    ),
                  ),
                }),
              }),
            v &&
              /* @__PURE__ */ r("div", {
                className: R["navigation-modal__submenu"],
                children: /* @__PURE__ */ r(h4, { ...v }),
              }),
          ],
        })
      : null;
  },
  p4 = ({ items: t }) =>
    /* @__PURE__ */ r("ul", {
      className: T1["header-menu"],
      children:
        t &&
        t.map((a, n) => {
          const { isActive: i, url: o, title: c, onClick: l } = a,
            s = F({
              [T1["header-menu__link"]]: !0,
              [T1["is-active"]]: i,
            });
          return /* @__PURE__ */ r(
            "li",
            {
              className: T1["header-menu__item"],
              children: o
                ? /* @__PURE__ */ r("a", {
                    className: s,
                    href: o,
                    title: c,
                    onClick: () => (l == null ? void 0 : l(a)),
                    children: c,
                  })
                : /* @__PURE__ */ r("button", {
                    className: s,
                    type: "button",
                    onClick: () => {
                      l == null || l(a);
                    },
                    children: c,
                  }),
            },
            `header-menu-item-${n}`,
          );
        }),
    }),
  _4 = ({
    logo: t,
    headerMenuItems: a,
    languages: n,
    lang: i,
    downloadUrl: o,
    downloadA11yLabel: c,
    signInText: l,
    signInUrl: s = "/get-started",
    isMenuOpen: d = !1,
    isDarkMode: g = !1,
    hamburgerMenuOpenA11yLabel: v,
    hamburgerMenuCloseA11yLabel: h,
    languageA11yLabel: V,
    onClickHamburgerMenu: y,
    onLanguageChange: E,
  }) => {
    const b = r1.useRef(null),
      A = S2(i4["desktop-sm"]);
    return /* @__PURE__ */ r("header", {
      className: z.header,
      ref: b,
      children: /* @__PURE__ */ f("div", {
        className: z.header__inner,
        children: [
          /* @__PURE__ */ r("div", {
            className: z.header__logo,
            children: /* @__PURE__ */ r("a", {
              className: z["header__logo-link"],
              href: "/",
              "aria-label": "logo link",
              children: /* @__PURE__ */ r($1, {
                variant: t.variant,
                a11yLabel: t.a11yLabel,
                color: g ? "white" : "black",
              }),
            }),
          }),
          /* @__PURE__ */ r("nav", {
            className: `${z.header__menu} ${z["desktop-only"]}`,
            "aria-label": "header navigation",
            children: /* @__PURE__ */ r(p4, { items: a }),
          }),
          /* @__PURE__ */ f("div", {
            className: z.header__actions,
            children: [
              /* @__PURE__ */ r("div", {
                className: z["not-mobile"],
                children: /* @__PURE__ */ r(T2, {
                  isIconOnly: !0,
                  options: n,
                  selectedValue: i,
                  isHeaderStyle: !0,
                  hasMaxHeight: !0,
                  a11y: {
                    label: V,
                  },
                  onChange: E,
                }),
              }),
              /* @__PURE__ */ r(U, {
                text: l,
                color: g ? "inverse" : "default",
                isInline: !0,
                size: A ? "small" : "medium",
                href: s,
                extraClass: z["desktop-only"],
              }),
              /* @__PURE__ */ r(U, {
                icon: N.Name.Download,
                color: "inverse",
                isInline: !0,
                size: A ? "small" : "medium",
                isHeaderButton: !0,
                extraClass: z["mobile-only"],
                href: o,
                ariaLabel: c,
              }),
              /* @__PURE__ */ r(U, {
                icon: d ? N.Name.Close : N.Name.NavigationBarHamburgerMenu,
                color: "inverse",
                isInline: !0,
                isActive: d,
                size: A ? "small" : "medium",
                isHeaderButton: !0,
                extraClass: z["not-desktop"],
                onClick: y,
                ariaLabel: d ? h : v,
                ariaControls: "modal-navigation",
                ariaExpanded: d,
                ariaHasPopup: !0,
              }),
            ],
          }),
        ],
      }),
    });
  },
  S4 = ({
    menuItems: t,
    backButtonText: a,
    languages: n,
    lang: i,
    downloadUrl: o,
    downloadA11yLabel: c,
    signInText: l,
    signInUrl: s,
    getTheAppText: d,
    logoA11yLabel: g,
    isDarkMode: v,
    hamburgerMenuOpenA11yLabel: h,
    hamburgerMenuCloseA11yLabel: V,
    languageA11yLabel: y,
    onLanguageChange: E,
  }) => {
    const [b, A] = X(!1),
      L = S2(1200),
      q = (H) => {
        (e1((_) =>
          _.map((Z) => ({
            ...Z,
            onClick: q,
            isActive: Z.title === H.title ? !Z.isActive : !1,
          })),
        ),
          H.subMenu && A(!H.isActive));
      },
      P = () => {
        (e1((H) =>
          H.map((_) => ({
            ..._,
            isActive: !1,
          })),
        ),
          A(!1));
      },
      D = (H) => {
        H.target === H.currentTarget && P();
      },
      [$, e1] = X(
        t.map((H) => ({
          ...H,
          onClick: q,
        })),
      );
    return /* @__PURE__ */ r(x2.FocusTrap, {
      focusTrapOptions: {
        escapeDeactivates: !0,
        onDeactivate: P,
        initialFocus: !1,
        allowOutsideClick: !0,
        clickOutsideDeactivates: !0,
      },
      active: b,
      children: /* @__PURE__ */ f("div", {
        className: F(z["header-container"], { [z["is-open"]]: b }),
        onClick: D,
        children: [
          /* @__PURE__ */ r("div", {
            className: z["header-container__nav"],
            children: /* @__PURE__ */ r(_4, {
              logo: { variant: "word-mark", a11yLabel: g },
              headerMenuItems: $,
              languages: n,
              lang: i,
              downloadUrl: o,
              downloadA11yLabel: c,
              signInText: l,
              signInUrl: s,
              isMenuOpen: b,
              isDarkMode: v,
              hamburgerMenuOpenA11yLabel: h,
              hamburgerMenuCloseA11yLabel: V,
              languageA11yLabel: y,
              onClickHamburgerMenu: () => A(!b),
              onLanguageChange: E,
            }),
          }),
          /* @__PURE__ */ r("div", {
            className: z["header-container__modal"],
            children: /* @__PURE__ */ r(f4, {
              menuItems: $,
              backButtonText: a,
              isOpen: b,
              showTopLevelMenu: L,
              closeA11yLabel: V,
              onClose: P,
            }),
          }),
          /* @__PURE__ */ r("div", {
            className: z["header-container__app-download-widget"],
            "aria-hidden": "true",
            children: /* @__PURE__ */ r(_2, { text: d, isFloating: !0 }),
          }),
        ],
      }),
    });
  },
  g4 = "hero__zaAoJ",
  v4 = "hero__words__0oIfL",
  H4 = "hero__word__And8m",
  V4 = "hero__description__ziyM0",
  b4 = "hero__logo__KrJHs",
  E4 = "hero__animation__b40Ed",
  B = {
    "header-1": "header-1__T-sgT",
    "is-responsive": "is-responsive__QLR9k",
    "header-2": "header-2__W2Zcm",
    "header-3": "header-3__lL36G",
    "p-1": "p-1__htVqi",
    "p-2": "p-2__r2qCX",
    "p-3": "p-3__J-hly",
    "action-small": "action-small__hRgO1",
    "action-medium": "action-medium__RLzCJ",
    "action-large": "action-large__eQQFo",
    "is-inherited": "is-inherited__u-8yV",
    "is-italic": "is-italic__NFjvM",
    "formatted-text": "formatted-text__LoMTY",
    "is-one-line": "is-one-line__91HNC",
    hero: g4,
    "hero--logo": "hero--logo__vOhk5",
    "hero--words": "hero--words__U9rUi",
    "hero--cta": "hero--cta__e--wO",
    "hero--full-width-image": "hero--full-width-image__tzEZa",
    "hero--rounded-image": "hero--rounded-image__-ogy3",
    "hero--spacing-compact": "hero--spacing-compact__mMsKH",
    "hero--background-white": "hero--background-white__BAyR2",
    "hero--background-yellow": "hero--background-yellow__lu7pS",
    "hero__background-overlay": "hero__background-overlay__ce5Od",
    "hero__background-overlay--gradient-top": "hero__background-overlay--gradient-top__Agcvx",
    "hero__background-overlay--gradient-bottom": "hero__background-overlay--gradient-bottom__TeuG7",
    "hero__background-image": "hero__background-image__s1BKv",
    hero__words: v4,
    hero__word: H4,
    "hero__word-header": "hero__word-header__i9YAx",
    hero__description: V4,
    hero__logo: b4,
    hero__animation: E4,
    "hero__cta-box": "hero__cta-box__0IZlN",
    "hero__rounded-box": "hero__rounded-box__gZES-",
  },
  i1 = {
    "animation-cards": "animation-cards__K44WF",
    "animation-card": "animation-card__QRX4J",
    "animation-cards--in": "animation-cards--in__nePmO",
    "swap-card-4": "swap-card-4__-SUId",
    "animation-cards--out": "animation-cards--out__B-hod",
    "slide-out": "slide-out__Wb3Nw",
    "animation-card__img": "animation-card__img__xC814",
    "animation-card__text": "animation-card__text__-TlkY",
  },
  w4 = ({ imgSrc: t, altText: a, text: n, ref: i }) => {
    const o = H1();
    return /* @__PURE__ */ f("div", {
      className: i1["animation-card"],
      ref: i,
      children: [
        /* @__PURE__ */ r(o, { className: i1["animation-card__img"], src: t, alt: a }),
        /* @__PURE__ */ r("div", {
          className: i1["animation-card__text"],
          children: /* @__PURE__ */ r(n1, { color: "inverse", children: n }),
        }),
      ],
    });
  },
  h2 = r1.memo(w4),
  A4 = ({ cards: t, animation: a, onAnimationEnd: n }) => {
    const i = r1.useRef(null);
    return (
      r1.useEffect(() => {
        const o = i.current,
          c = (l) => {
            (l.animationName === i1["swap-card-4"] || l.animationName === i1["slide-out"]) &&
              n(l.animationName === i1["swap-card-4"] ? "in" : "out");
          };
        return (
          o && o.addEventListener("animationend", c),
          () => {
            o && o.removeEventListener("animationend", c);
          }
        );
      }, [i.current]),
      /* @__PURE__ */ f("div", {
        className: F(i1["animation-cards"], {
          [i1["animation-cards--in"]]: a === "in",
          [i1["animation-cards--out"]]: a === "out",
        }),
        children: [
          t.map((o, c) => /* @__PURE__ */ r(h2, { ...o }, `animation-card-${c}`)),
          t.map((o, c) =>
            /* @__PURE__ */ r(
              h2,
              { ...o, ...(c === 2 ? { ref: i } : {}) },
              `animation-card-2-${c}`,
            ),
          ),
        ],
      })
    );
  },
  F4 = ({
    variant: t = "logo",
    spacing: a = "default",
    backgroundImageSrc: n,
    backgroundImageAlt: i = "",
    backgroundColor: o,
    words: c,
    textColor: l = "default",
    descriptionText: s,
    ctaBox: d,
    animationCards: g = [],
    animation: v,
    overlay: h,
  }) => {
    const V = H1(),
      [y, E] = X(v),
      b = C1(!1),
      A = C1(void 0);
    v1(() => {
      v &&
        ((A.current = v), !b.current && y !== v && (E(v), (A.current = void 0), (b.current = !0)));
    }, [v, E]);
    const L = f2(
      (q) => {
        ((b.current = !1),
          A.current && y !== A.current
            ? (E(A.current), (A.current = void 0), (b.current = !0))
            : q === "out" &&
              setTimeout(() => {
                E(void 0);
              }, 100));
      },
      [y, E],
    );
    return /* @__PURE__ */ f("div", {
      className: F(B.hero, {
        [B["hero--logo"]]: t === "logo",
        [B["hero--words"]]: t === "three-words",
        [B["hero--cta"]]: t === "cta",
        [B["hero--full-width-image"]]: t === "full-width-image",
        [B["hero--rounded-image"]]: t === "rounded-image",
        [B[`hero--background-${o}`]]: o,
        [B["hero--spacing-compact"]]: a === "compact",
      }),
      children: [
        n && t !== "rounded-image"
          ? /* @__PURE__ */ r("div", {
              className: B["hero__background-image"],
              children: /* @__PURE__ */ r(V, { src: n, alt: i }),
            })
          : null,
        t === "logo"
          ? /* @__PURE__ */ f(r1.Fragment, {
              children: [
                /* @__PURE__ */ r("div", {
                  className: B.hero__animation,
                  children: /* @__PURE__ */ r(A4, {
                    cards: g,
                    animation: y,
                    onAnimationEnd: L,
                  }),
                }),
                /* @__PURE__ */ r("h1", {
                  className: B.hero__logo,
                  children: /* @__PURE__ */ r($1, {}),
                }),
              ],
            })
          : void 0,
        t === "three-words"
          ? /* @__PURE__ */ r("div", {
              className: B.hero__words,
              children:
                c == null
                  ? void 0
                  : c.map((q, P) =>
                      /* @__PURE__ */ f(
                        "div",
                        {
                          className: B.hero__word,
                          children: [
                            /* @__PURE__ */ r("div", {
                              className: B["hero__word-header"],
                              children: /* @__PURE__ */ r(W2, { color: l, children: q }),
                            }),
                            s &&
                              P === c.length - 1 &&
                              /* @__PURE__ */ r("div", {
                                className: B.hero__description,
                                children: /* @__PURE__ */ r(n1, { color: l, children: s }),
                              }),
                          ],
                        },
                        `word-${P}`,
                      ),
                    ),
            })
          : void 0,
        (() => {
          if (!(h ? h !== "none" : (t === "cta" || t === "full-width-image") && !o)) return null;
          const P =
            h === "gradient-bottom"
              ? B["hero__background-overlay--gradient-bottom"]
              : h === "gradient-top"
                ? B["hero__background-overlay--gradient-top"]
                : void 0;
          return /* @__PURE__ */ r("div", { className: F(B["hero__background-overlay"], P) });
        })(),
        t === "cta" || t === "full-width-image"
          ? /* @__PURE__ */ r("div", {
              className: B["hero__cta-box"],
              children: /* @__PURE__ */ r(R1, {
                title: (d == null ? void 0 : d.title) || "",
                description: d == null ? void 0 : d.description,
                cta: d == null ? void 0 : d.cta,
                color: l,
                align: "center",
                headerLevel: "h1",
                isTextShadow: t === "full-width-image",
              }),
            })
          : void 0,
        t === "rounded-image"
          ? /* @__PURE__ */ f("div", {
              className: B["hero__rounded-box"],
              children: [
                /* @__PURE__ */ r("div", {
                  className: B["hero__background-image"],
                  children: /* @__PURE__ */ r(V, { src: n, alt: i }),
                }),
                h !== "none" &&
                  /* @__PURE__ */ r("div", {
                    className: F(B["hero__background-overlay"], {
                      [B["hero__background-overlay--gradient-bottom"]]: h === "gradient-bottom",
                      [B["hero__background-overlay--gradient-top"]]: h === "gradient-top",
                    }),
                  }),
                /* @__PURE__ */ r("div", {
                  className: B["hero__cta-box"],
                  children: /* @__PURE__ */ r(R1, {
                    title: (d == null ? void 0 : d.title) || "",
                    description: d == null ? void 0 : d.description,
                    cta: d == null ? void 0 : d.cta,
                    color: l,
                    align: "center",
                    headerLevel: "h1",
                    isTextShadow: !0,
                  }),
                }),
              ],
            })
          : void 0,
      ],
    });
  },
  d1 = {
    "social-cta-wrapper": "social-cta-wrapper__wruOW",
    "social-cta": "social-cta__vHAUb",
    "social-cta__inner": "social-cta__inner__qRgPz",
    "social-cta__title-description": "social-cta__title-description__-kh3h",
    "social-cta__description": "social-cta__description__61CQW",
    "social-cta__socials": "social-cta__socials__2uuat",
    "social-cta__qr": "social-cta__qr__Keb8l",
  },
  R4 = ({ title: t, description: a, cta: n, socialLinks: i, showQrCode: o }) =>
    /* @__PURE__ */ r("section", {
      className: d1["social-cta-wrapper"],
      children: /* @__PURE__ */ r("div", {
        className: d1["social-cta"],
        children: /* @__PURE__ */ f("div", {
          className: d1["social-cta__inner"],
          children: [
            /* @__PURE__ */ f("div", {
              className: d1["social-cta__title-description"],
              children: [
                /* @__PURE__ */ r(k1, { children: t }),
                /* @__PURE__ */ r("div", {
                  className: d1["social-cta__description"],
                  children: /* @__PURE__ */ r(n1, { children: a || "" }),
                }),
              ],
            }),
            /* @__PURE__ */ r("ul", {
              className: d1["social-cta__socials"],
              children: i.map((c, l) =>
                /* @__PURE__ */ r(
                  "li",
                  {
                    children: /* @__PURE__ */ f(A1, {
                      href: c.url,
                      children: [
                        /* @__PURE__ */ r(N, { name: c.iconName }),
                        /* @__PURE__ */ r(Q1, { children: c.a11yLabel }),
                      ],
                    }),
                  },
                  `social-link-${l}`,
                ),
              ),
            }),
            o &&
              /* @__PURE__ */ r("div", {
                className: d1["social-cta__qr"],
                children: /* @__PURE__ */ r(F1, { size: "stretch" }),
              }),
            n &&
              /* @__PURE__ */ r("div", {
                className: d1["social-cta__cta"],
                children:
                  n && /* @__PURE__ */ r(U, { href: n.href, text: n.text, onClick: n.onClick }),
              }),
          ],
        }),
      }),
    }),
  m2 = {
    "mission-statement": "mission-statement__u9dh4",
    "mission-statement__statement": "mission-statement__statement__ADppj",
  },
  D4 = ({ title: t, statement: a }) =>
    /* @__PURE__ */ f("section", {
      className: m2["mission-statement"],
      children: [
        /* @__PURE__ */ r(p1, { as: "div", children: t }),
        /* @__PURE__ */ r("div", {
          className: m2["mission-statement__statement"],
          children: /* @__PURE__ */ r(k1, { children: a }),
        }),
      ],
    });
export {
  Q1 as A11yVisuallyHidden,
  O2 as ActionBadge,
  y1 as ActionLarge,
  j2 as ActionMedium,
  X1 as ActionSmall,
  _2 as AppDownloadWidget,
  K2 as Badge,
  U as Button,
  i2 as Card,
  ze as Cards,
  k4 as CarouselQuotes,
  N4 as CarouselStackedCards,
  L4 as CarouselYearCards,
  R1 as CtaBox,
  I4 as CtaImageBox,
  T2 as Dropdown,
  x4 as Footer,
  T4 as GetTheApp,
  _4 as Header,
  W2 as Header1,
  k1 as Header2,
  p1 as Header3,
  S4 as HeaderContainer,
  p4 as HeaderMenu,
  F4 as Hero,
  N as Icon,
  g2 as ImageComponentContext,
  v2 as ImagePathContext,
  y4 as ImageProvider,
  A1 as Link,
  $1 as Logo,
  D4 as MissionStatement,
  f4 as NavigationModal,
  n1 as P1,
  G1 as P2,
  f1 as P3,
  w2 as PaginationDots,
  F1 as QRCode,
  Ue as Quote,
  l2 as QuoteText,
  R4 as SocialCta,
  H1 as useImage,
  We as useImageComponent,
  H2 as useImagePath,
  S2 as useMediaQuery,
};
